$(document).ready(function () {

var urlParams = new URLSearchParams(window.location.search);
if (document.referrer.indexOf("football") >= 0 || sessionStorage.getItem('glove_page') === 'true' || urlParams.get('type') == 'football'){
  document.body.classList.add("football_points");
} else if(document.referrer.indexOf("golf") >= 0 || sessionStorage.getItem('glof_page') === 'true'){
  document.body.classList.add("golf_points");
}

 
window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    $('.cartdrawer_loader').removeClass('show');
  }
});


  var scrolling_complete = false, scrolled_id = '', custom_above_scroll = "", pixels_above_quotes = $('body').attr("data-pixels_above_quotes"), t = 0;

  function scroll_shop(e = window.location.hash.split('#')[1]){
    var e = e;
    var o; 
        if ("" != e) {
          if(("shop_now" == e || custom_above_scroll == true ) &&
                    $("#" + e).parents("body").find(".shopify-press-section").length > 0) {
                  custom_above_scroll = false;
                   if (window.innerWidth < 750){
                      o = document.getElementById("press_section").offsetTop - pixels_above_quotes;
                    }else{
                      o = document.getElementById("press_section").offsetTop + 27;
                    }
                    if (window.innerWidth > 768){
                      o= o + $('div.shopify-section-header_vm').height() - 115;
                      if($('.announcement-bar').hasClass('theridge-promoBanner__wrapper') == false) {
                        o= o - ($('.announcement-bar').outerHeight() - 45);
                      }
                   }
                  window.scroll({ top: o, left: 0, behavior: "smooth" });
            
            } else if($("#" + e).length > 0){
              if(window.innerWidth > 750){
                t += 9;
              } else{
                t += 12;
              }
                o = $("#" + e).offset().top -  $("header").height() - $('.announcement-bar').outerHeight() - t;
                if (window.innerWidth > 768){
                  o= o + $("header").height() + $('.announcement-bar').outerHeight() - 115;
                  if($('.announcement-bar').hasClass('theridge-promoBanner__wrapper') == false) {
                      o= o - ($('.announcement-bar').outerHeight() - 45);
                    }
                 }
               scrolling_complete = true;
              scrolled_id = e;
              window.scroll({ top: o, left: 0, behavior: "smooth" });
               t = 0;
              
            }
            if(e == window.location.hash.replaceAll('#','')){
              scrolling_complete = true;
              scrolled_id = window.location.hash.replaceAll('#','');
            }
        }
  }

    scroll_shop();

   var paramss = new URLSearchParams(window.location.search);
    var opencart = paramss.get('cartopen');
  if(opencart == "true") {
      document.querySelector('body').classList.add('open-cart');
      lockScroll();            
  }
  var discount_code = paramss.get('discount_code');
  if (discount_code != '' && discount_code != null && discount_code != undefined && discount_code) {
var discountUrl = '/discount/' + discount_code;
            fetch(discountUrl, {method: 'GET',headers: {'X-Requested-With': 'XMLHttpRequest'}})
            .then(() => {
             
              fetch("/")
              .then(response => response.text())
              .then(data => {$('.cartdrawer').html($(data).find('.cartdrawer').html());
 }).catch(error => console.error('Error fetching data:', error));
            })
            .catch(error => {
                console.log("Error applying discount.");
                $('.discount-code-btn').attr('aria-busy',false).prop('disabled',false);
            });
  }

  
    $('body').on("click",".custom_link_on_homepage",function(e){
      e.preventDefault();
        var _this = $(this);
        if (_this.attr("href").indexOf("#") != -1 && $("#" + _this.attr("href").split("#")[1]).length > 0) {
            var r = _this.attr("href").split("#")[1];
          scroll_shop(r);
        } else {
           window.location = _this.attr("href");
        }
        if($('.site-header__icon.js-mobile-nav-toggle.mobile-nav--close').length > 0){
          $(".mobile-nav--close").click();
        }
    });
  
    $('body').on("click",".text_above_on_video, .content-span",function(e){
      var video = $(this).closest('.mobile-banner').find('video')[0];
      if(video != null){
        if(video.paused){
          video.controls=false;
          video.loop=true;
          video.autoplay=true;
          video.muted=true;
          video.currentTime=0;
          video.play();
        }
      }
    });

     $(window).on("load", function () {
      setTimeout(function () {
          scroll_shop(), history.pushState("", "", window.location.pathname + window.location.search);
      }, 500);
    });

  
   var opencart = document.querySelector('.site-header__cart');
        opencart.addEventListener('click', function(ev) {
            ev.preventDefault();
            document.querySelector('body').classList.add('open-cart');
            lockScroll();
        }, false);

    /*    document.querySelectorAll('.add_product_list_grid [data-add-to-cart]').forEach(item => {
          item.addEventListener('click', function(ev) {
            ev.preventDefault();
            var form = ev.target.closest('form')
            var id = form.querySelector('[name="id"]').value;
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: {id:id,quantity:1},
              dataType: 'json',
              error: function(jqXHR, textStatus, errorThrown){
                var response = $.parseJSON(jqXHR.responseText);
                
                var desc = response.description;
                if(desc.indexOf(' to the cart.') != -1){
                  var ptitle = desc.replace('to the cart.','');
                  var optitle = ptitle.replace("You can't add more","").split(' - ');
                  alert('Sorry, we cannot add '+ optitle[optitle.length - 1] +'to your cart due to our limited inventory at this time.');
                }else if(desc.indexOf("' is already sold out.") != -1){
                  var ptitle = desc.replace("' is already sold out.","");
                  var optitle = ptitle.replace("The product '","").split(' - ');
                  alert('Sorry, we cannot add '+ optitle[optitle.length - 1] +' to your cart due to our limited inventory at this time.');
                }else if(desc.indexOf("are in your cart.") != -1){
                  var ptitle = desc.replace('are in your cart.','');
                  var optitle = ptitle.replace('All','').split(' - ');
                  alert('Sorry, we cannot add '+ optitle[optitle.length - 1] +'to your cart due to our limited inventory at this time.');
                }
              },success: function(data){
                if(document.querySelector('body').classList.contains('template-product')){
                  var current_list_id = 'Similar Products';
                }else if(document.querySelector('body').classList.contains('template-index')){
                  var current_list_id = 'Home Page';
                }else if(document.querySelector('body').classList.contains('template-collection')){
                  var current_list_id = 'Collection Page';
                }else if(document.querySelector('body').classList.contains('template_how_to_use')){
                  var current_list_id = 'How To Use Page';
                } else if(document.querySelector('body').classList.contains('template_game_pages') || document.querySelector('body').classList.contains('template_edge')  || document.querySelector('body').classList.contains('template_new_game_page') || document.querySelector('body').classList.contains('template_black_friday_bogo')   || document.querySelector('body').classList.contains('template_black_friday_football_bogo')  || document.querySelector('body').classList.contains('template_black_friday_wipes')  || document.querySelector('body').classList.contains('template_boxing') || document.querySelector('body').classList.contains('template_girlsrule') || document.querySelector('body').classList.contains('template_black_friday') || document.querySelector('body').classList.contains('template_black_friday_early_access')  || document.querySelector('body').classList.contains('template_new_glof_page')  || document.querySelector('body').classList.contains('template_new_glove_page')){
                  var current_list_id = 'Home Page';     
                } else {
                  var current_list_id = 'Home Page';
                }
                add_track_event(data,current_list_id);
              }
            }).done(function( data ) {
              $.getJSON("/cart", function(data) {
                $('[data-cart-count]').text(data.item_count);
              });
              fetch("/")
              .then(response => response.text())
              .then(data => {
                if ($(data).find('.empty').length == 1 || $('.cartdrawer .empty').length == 1) {
                  $('.cartdrawer').html($(data).find('.cartdrawer').html());
                } else {
                  $('.cartdrawer .cartdrawer-footer').html($(data).find('.cartdrawer-footer').html());
                  $('.cartdrawer .header').html($(data).find('.header').html());
                  if ($(data).find('.items .item').length == 1) {
                    $('.cartdrawer .cartdrawer-upsell').addClass('setfull');
                  } else {
                    $('.cartdrawer .cartdrawer-upsell').removeClass('setfull');
                  }
                  $('.cartdrawer .cartdrawer-upsell').html($(data).find('.cartdrawer-upsell').html());
                  $('.cartdrawer [data-cart_rows]').html($(data).find('[data-cart_rows]').html());
                  $('.cartdrawer .cartdrawer-announcements').html($(data).find('.cartdrawer-announcements').html());
                }
                
                localStorage.setItem("scroll_value", document.querySelector('html').scrollTop);
                $('body').addClass('open-cart');
                
                setTimeout(function(){
                  $('body').addClass('no-scroll');
                  $('html').addClass('no-scroll');
                },415);
              })
              .catch(error => console.error('Error fetching data:', error));
            });
        }, false);
      });*/
      $('body').on("click",'.add_product_list_grid [data-add-to-cart]',function(ev){
          ev.preventDefault();
            var form = $(this).closest('form');
            var id = form.find('[name="id"]').val();
        $(this).find('[data-add-to-cart-text]').addClass('hide');
          $(this).find('[data-loader]').removeClass('hide');
          $('.cartdrawer .empty').hide();
          var properties = {};

          if (sessionStorage.getItem('glove_page') === 'true') {
            properties._glove_page = 'true';
          }

          if (sessionStorage.getItem('glof_page') === 'true') {
            properties._glof_page = 'true';
          }

          if (sessionStorage.getItem('mat_page') === 'true') {
            properties._mat_page = 'true';
          }
              
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: {id:id,quantity:1,properties: properties},
              dataType: 'json',
              error: function(jqXHR, textStatus, errorThrown){
                var response = $.parseJSON(jqXHR.responseText);
                
                var desc = response.description;
                if(desc.indexOf(' to the cart.') != -1){
                  var ptitle = desc.replace('to the cart.','');
                  var optitle = ptitle.replace("You can't add more","").split(' - ');
                  alert('Sorry, we cannot add '+ optitle[optitle.length - 1] +'to your cart due to our limited inventory at this time.');
                }else if(desc.indexOf("' is already sold out.") != -1){
                  var ptitle = desc.replace("' is already sold out.","");
                  var optitle = ptitle.replace("The product '","").split(' - ');
                  alert('Sorry, we cannot add '+ optitle[optitle.length - 1] +' to your cart due to our limited inventory at this time.');
                }else if(desc.indexOf("are in your cart.") != -1){
                  var ptitle = desc.replace('are in your cart.','');
                  var optitle = ptitle.replace('All','').split(' - ');
                  alert('Sorry, we cannot add '+ optitle[optitle.length - 1] +'to your cart due to our limited inventory at this time.');
                }
                $('[data-add-to-cart-text]').removeClass('hide');
              $('[data-loader]').addClass('hide');
              $('.cartdrawer_loader').removeClass("show");
              },success: function(data){
                if(document.querySelector('body').classList.contains('template-product')){
                  var current_list_id = 'Similar Products';
                }else if(document.querySelector('body').classList.contains('template-index')){
                  var current_list_id = 'Home Page';
                }else if(document.querySelector('body').classList.contains('template-collection')){
                  var current_list_id = 'Collection Page';
                }else if(document.querySelector('body').classList.contains('template_how_to_use')){
                  var current_list_id = 'How To Use Page';
                } else if(document.querySelector('body').classList.contains('template_wipes') ||  document.querySelector('body').classList.contains('template_game_pages') || document.querySelector('body').classList.contains('template_edge')  || document.querySelector('body').classList.contains('template_new_game_page')  || document.querySelector('body').classList.contains('template_black_friday_bogo')  || document.querySelector('body').classList.contains('template_black_friday_football_bogo')   || document.querySelector('body').classList.contains('template_black_friday_wipes') || document.querySelector('body').classList.contains('template_girlsrule') || document.querySelector('body').classList.contains('template_boxing') || document.querySelector('body').classList.contains('template_black_friday') || document.querySelector('body').classList.contains('template_black_friday_early_access')  || document.querySelector('body').classList.contains('.template_new_glof_page') || document.querySelector('body').classList.contains('template_new_glove_page')){
                  var current_list_id = 'Home Page';     
                } else {
                  var current_list_id = 'Home Page';
                }
                add_track_event(data,current_list_id);
              }
            }).done(function( data ) {
              

          $('.cartdrawer_loader').addClass("show");
          $('body').addClass('open-cart'); 
              $('[data-add-to-cart-text]').removeClass('hide');
              $('[data-loader]').addClass('hide');


              $.getJSON("/cart", function(data) {
                $('[data-cart-count]').text(data.item_count);
              });
              fetch("/")
              .then(response => response.text())
              .then(data => {
                if ($(data).find('.empty').length == 1 || $('.cartdrawer .empty').length == 1) {
                  $('.cartdrawer').html($(data).find('.cartdrawer').html());
                } else {
                  $('.cartdrawer .cartdrawer-footer').html($(data).find('.cartdrawer-footer').html());
                  $('.cartdrawer .header').html($(data).find('.header').html());
                  if ($(data).find('.items .item').length == 1) {
                    $('.cartdrawer .cartdrawer-upsell').addClass('setfull');
                  } else {
                    $('.cartdrawer .cartdrawer-upsell').removeClass('setfull');
                  }
                  $('.cartdrawer .cartdrawer-upsell').html($(data).find('.cartdrawer-upsell').html());
                  $('.cartdrawer [data-cart_rows]').html($(data).find('[data-cart_rows]').html());
                  $('.cartdrawer .cartdrawer-announcements').html($(data).find('.cartdrawer-announcements').html());
                }
                
                $('.cartdrawer_loader').removeClass("show");
                
                lockScroll();
                
              })
              .catch(error => console.error('Error fetching data:', error));

            });
      });
   

     $('body').on("click", '.product-single #add-to-cartform [data-add-to-cart]', function(ev) {
        ev.preventDefault();
          var _this = $(this);
          console.log(_this);
          var form = _this.closest('#add-to-cartform').serialize();
          _this.find('[data-add-to-cart-text]').addClass('hide');
          _this.find('[data-loader]').removeClass('hide');
          $('.cartdrawer .empty').hide();
           var properties = [];

          if (sessionStorage.getItem('glove_page') == 'true') {
            properties.push('properties[_glove_page]=true');
          }

          if (sessionStorage.getItem('glof_page') == 'true') {
            properties.push('properties[_glof_page]=true');
          }

          if (sessionStorage.getItem('mat_page') == 'true') {
            properties.push('properties[_mat_page]=true');
          }

          if (properties.length > 0) {
            form += '&' + properties.join('&');
          }

          console.log(form);

          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: form,
            dataType: 'json',
            error: function(jqXHR, textStatus, errorThrown){
              var response = $.parseJSON(jqXHR.responseText);
              var desc = response.description;
              if(desc.indexOf(' to the cart.') != -1){
                var ptitle = desc.replace('to the cart.','');
                var optitle = ptitle.replace("You can't add more","").split(' - ');
                alert('Sorry, we cannot add '+ optitle[optitle.length - 1] +'to your cart due to our limited inventory at this time.');
              }else if(desc.indexOf("' is already sold out.") != -1){
                var ptitle = desc.replace("' is already sold out.","");
                var optitle = ptitle.replace("The product '","").split(' - ');
                alert('Sorry, we cannot add '+ optitle[optitle.length - 1] +' to your cart due to our limited inventory at this time.');
              }else if(desc.indexOf("are in your cart.") != -1){
                var ptitle = desc.replace('are in your cart.','');
                var optitle = ptitle.replace('All','').split(' - ');
                alert('Sorry, we cannot add '+ optitle[optitle.length - 1] +'to your cart due to our limited inventory at this time.');
              }
              $('[data-add-to-cart-text]').removeClass('hide');
              $('[data-loader]').addClass('hide');
              $('.cartdrawer_loader').removeClass("show");
            },success: function(data){
              var current_list_id='Product Page'
                add_track_event(data,current_list_id);
              }
          }).done(function( data ) {
            $('.cartdrawer_loader').addClass("show");
            $('body').addClass('open-cart');
            
            $('[data-add-to-cart-text]').removeClass('hide');
            $('[data-loader]').addClass('hide');
            


            $.getJSON("/cart.js", function(data) {
              $('[data-cart-count]').text(data.item_count);
            });
            fetch("/")
            .then(response => response.text())
            .then(data => {
              if ($(data).find('.empty').length == 1 || $('.cartdrawer .empty').length == 1) {
                $('.cartdrawer').html($(data).find('.cartdrawer').html());
              } else {
                $('.cartdrawer .cartdrawer-footer').html($(data).find('.cartdrawer-footer').html());
                $('.cartdrawer .header').html($(data).find('.header').html());
                if ($(data).find('.items .item').length == 1) {
                  $('.cartdrawer .cartdrawer-upsell').addClass('setfull');
                } else {
                  $('.cartdrawer .cartdrawer-upsell').removeClass('setfull');
                }
                $('.cartdrawer .cartdrawer-upsell').html($(data).find('.cartdrawer-upsell').html());
                $('.cartdrawer [data-cart_rows]').html($(data).find('[data-cart_rows]').html());
                $('.cartdrawer .cartdrawer-announcements').html($(data).find('.cartdrawer-announcements').html());
              }
              $('.cartdrawer_loader').removeClass("show");
              
              lockScroll();
            })
            .catch(error => console.error('Error fetching data:', error));
          });
      });

  
  var scroll_e;
    window.addEventListener("scroll", function () {
      clearTimeout(scroll_e),
      (scroll_e = setTimeout(function () {
          scrolling_complete && ((scrolling_complete = !1), scroll_shop(scrolled_id), (scrolled_id = ""));
      }, 220));
    });

    if($('.animatable').length > 0){
      var animation = function () {
        var s = $(window).scrollTop() + $(window).height(),
            all_animatable = $(".animatable");
        
        if (all_animatable.length == 0) {
            $(window).off("scroll", animation);
        }
        all_animatable.each(function(index,val) {
          var val_div = $(val);
          if(val_div.offset().top + val_div.height() - 160 < s){
            val_div.removeClass("animatable").removeClass('moveUp').addClass("animated");
          }
        });
    };
      $(window).on("scroll", animation);
      $(window).trigger("scroll");
    }

  var isScrolling;

  function check_button(){
        if($(window).width() < 750 && $('.shop-collection.add_product_list_grid').length > 0 && $('body').hasClass('template_edge') == true){
  
        var shop_collection = $('.shop-collection.add_product_list_grid').offset().top - $('#press_section').height() - 132;
        
          var scroll = $(window).scrollTop() + $('.shopify-section-header_vm').height();
          var elemBottom = $('.review_caurosal').offset().top;
          // var elemBottom = shop_collection + $('.shop-collection.add_product_list_grid').height() - $('.shop-collection.add_product_list_grid li.grid__item:last').height() + 125 + $('.shop-collection.add_product_list_grid li.grid__item:last .price_group_name').height();
  
          if (($(window).scrollTop()+$(window).height() <= elemBottom - 8) && (scroll > shop_collection)) {
            if($('.custom_popup_button_wrp').hasClass('first_time')){
              $('.custom_popup_button_wrp').removeClass('first_time');
              setTimeout(function(){
                $(".custom_popup_button_wrp").addClass("show_button");
              },200);
            } else{ 
              $(".custom_popup_button_wrp").addClass("show_button");
            }
          } else{
            $(".custom_popup_button_wrp").removeClass("show_button");
          } 
      } else if($(window).width() < 750 && $('.shop-collection.add_product_list_grid').length > 0 && $('body').hasClass('template_edge') == false){
            var shop_collection = $('.shop-collection.add_product_list_grid').offset().top - 10;
        
          var scroll = $(window).scrollTop() + $('header').height() + $('.announcement-bar').height() ;
          var elemBottom_below = shop_collection + $('.shop-collection.add_product_list_grid').height();
          var elemBottom = shop_collection + $('.shop-collection.add_product_list_grid').height() - ($('.shop-collection.add_product_list_grid li.grid__item:last .banner_block_wrp').length > 0 ? $('.shop-collection.add_product_list_grid li.grid__item:last .banner_block_wrp').height() : $('.shop-collection.add_product_list_grid li.grid__item:last .price_group_name').height()) - 57 - ($('.shop-collection.add_product_list_grid li.grid__item:last .price_group_name').length == 0 && ($('.shop-collection.add_product_list_grid li.grid__item:last .banner_block_wrp').length > 0 ? $('.shop-collection.add_product_list_grid li.grid__item:last .banner_block_wrp').height() - 450 : $('.shop-collection.add_product_list_grid li.grid__item:last .price_group_name').height() * 2));

          if ($('.custom_button_below_pro_list').is(':visible')){
            elemBottom_below -= $('.custom_button_below_pro_list').height(); 
            elemBottom -= $('.custom_button_below_pro_list').height();   
          }


          if ((($(window).scrollTop() + $('header').height() + $('.announcement-bar').height() - 15) < elemBottom) && (scroll > shop_collection)) {
            $(".custom_popup_button_wrp.in_header").slideDown(100);
          } else{
            $(".custom_popup_button_wrp.in_header").slideUp(100);
          }

      } else{
        $(".custom_popup_button_wrp").removeClass("show_button");
      }
  }
  
  $(window).on("scroll",function(){

    if($('.custom_popups:not(.inside_popup)').hasClass("active_popup")){
    $('.custom_popups').removeClass("active_popup");
    setTimeout(function(){
      $('.custom_popups').removeClass("formula_only_popup");
      $('.learnmore_product_wrp .keep__shopping_close').show();
    },2000);
    if($('.custom_popups').find('.image_text_card__video').length > 0){
         $('.custom_popups').find('.image_text_card__video').each(function(index, val){
           var video = $(val)[0];
            if(video != null){
                video.stop(); 
            }
         });
     }
    }

    clearTimeout(isScrolling);
    if($('.custom_popup_button_wrp').hasClass('first_time')){
      isScrolling = setTimeout(function() {
       check_button();         
      },300);
    } else{
      check_button();
    }
    
  });

   document.getElementById("mobile-nav-wrapper").style.setProperty("--header_height", document.getElementById("header").offsetHeight + "px");
    window.addEventListener("load", function () {
        document.getElementById("mobile-nav-wrapper").style.setProperty("--header_height", document.getElementById("header").offsetHeight + "px");
    });

    function margin_top(){
      var height = $('div#header').outerHeight();
      if ($('.custom_popup_button_wrp.in_header').is(':visible')){
        height -= $('.custom_popup_button_wrp.in_header').outerHeight();
      }
      $('div#PageContainer').css("margin-top",height);
  }
  margin_top();
  $(window).on("load, resize",function(){
    margin_top();
    check_button();
  });

  if($(".shopify-feature-row--section").length >  0){
     $(".shopify-feature-row--section").each(function (index) {
      $(this).addClass("shopify-feature-row-" + (index + 1));
    });
  }

  if($(".slider-for2").length > 0){
    $(".slider-for2").slick({infinite:true,slidesToShow:1,slidesToScroll:1,arrows:false,autoplay:true,autoplaySpeed:6000});
  }
  
    function add_track_event(data,current_list_id="Home page"){
      // console.log(data);
      //     var currency = document.querySelector('body').getAttribute('data-currency');
      //     gtag("event", "custom_add_to_cart", {
      //        send_to:[
      //         "G-C2R2CG5Z6T",
      //         "AW-304005457/SGbBCOrKqrcDENGC-5AB"
      //       ],
      //       currency: currency,
      //       value: data.price,
      //       location_id: current_list_id,
      //       items: [
      //         {
      //           item_id: data.id,
      //           item_name: data.title,
      //           affiliation: data.product_type,
      //           discount: data.total_discount,
      //           index: 0,
      //           item_brand: data.vendor,
      //           item_category: data.vendor,
      //           item_list_id: current_list_id,
      //           item_list_name: current_list_id,
      //           item_variant: data.variant_title,
      //           price: data.price,
      //           quantity: data.quantity
      //         }
      //       ]
      //     });
        }


  
//   $('[data-class] .jdgm-widget.jdgm-preview-badge').on("click",function(e){
//     e.preventDefault();
//     $('.'+$(this).parent().attr("data-class")).addClass("active");
// });
  
   $('body').on("click",".custom_review_popup:not(.custom_review_popup_learn_more)",function(event){
      event.stopPropagation();
      event.preventDefault();
      $('#product_review_popup').addClass("active");
      lockScroll();
});

$('body').on("click",".product_review_popup .close_icon",function(e){
    e.preventDefault();
    $(this).closest(".product_review_popup").removeClass("active");

  if($('.learn_more_popup.active').length == 0) {
    unlockScroll();
  }
});

$('body').on('click', function(e) {
  if ($(e.target).closest('.product_review_popup .product_review_popup_wrp').length === 0 && $('.product_review_popup').hasClass('active')) {
    $('.product_review_popup').removeClass('active');
    if($('.learn_more_popup.active').length == 0) {
      unlockScroll();
    }
  }
});



      $('body').on("click",".site-nav--has-dropdown",function(e){
      e.preventDefault();
      if($(this).hasClass("site-nav--active-dropdown")){
        $(this).removeClass("site-nav--active-dropdown");
      } else {
        $('.site-nav--has-dropdown').removeClass("site-nav--active-dropdown");
        $(this).addClass("site-nav--active-dropdown");
      }
    });
     

    $('body').on("click",".site-header__menu.js-mobile-nav-toggle",function(e){
      e.preventDefault();
      if($(this).hasClass("mobile-nav--open")){
        $(this).attr("aria-expanded","true");  
      } else{
        $(this).attr("aria-expanded","false");  
      }
      $(this).toggleClass("mobile-nav--open");
      $(this).toggleClass("mobile-nav--close");
      document.getElementById("mobile-nav-wrapper").style.setProperty("--header_height", document.getElementById("header").offsetHeight + "px");
      $(".mobile-nav-wrapper").toggleClass("js-menu--is-open");
      $(".mobile-nav-wrapper").toggleClass("sub-nav--is-open");
      if($(this).hasClass("mobile-nav--open")){
        unlockScroll();
      } else{
        lockScroll();
      }
    });

   $('body').on("click",".js-toggle-submenu.mobile-nav__link",function(e){
      e.preventDefault();
      $(this).toggleClass("is-active");
     if($(this).hasClass("is-active")){
         var scroll = $(this).closest('li').find('.mobile-nav__dropdown').height();
         $(".mobile-nav-wrapper").scrollTop($(".mobile-nav-wrapper").scrollTop()+(scroll*2));
         
       }
    });

    $('body').on("click",".active_popup.custom_popups .close_icon, .shop_now_custom_popup_btn,  .custom_popups .ovrelay, .inside_popup .overlay, .inside_popup .close_icon, .inside_popup .keep__shopping_close_btn",function(e){
      e.preventDefault();
    $(this).closest('.custom_popups').removeClass("active_popup");
    $('body').removeClass("no_alia_popup");
    if($('.custom_popups').find('.image_text_card__video').length > 0){
         $('.custom_popups').find('.image_text_card__video').each(function(index, val){
           var video = $(val)[0];
            if(video != null){
                video.stop(); 
            }
         });
     }
     if($(this).hasClass('inside_shop_now_btn')) {
      $('body').find('.custom_link_on_homepage')[0].click();
     }
    //  if($(this).closest('[data-inside_popup_custom]').length > 0) {
    //   $('html').removeClass('no-scroll');
    //   if(localStorage.getItem("scroll_value") != null && localStorage.getItem("scroll_value") != undefined && localStorage.getItem("scroll_value") != '' && localStorage.getItem("scroll_value") != 'undefined'){
    //     window.scrollTo(0, localStorage.getItem("scroll_value"));
    //     localStorage.removeItem("scroll_value");
    //   }
    // } 
    unlockScroll();

       if($('.learn_more_popup.active').length == 1) {
      lockScroll();
    }

    var _this = $(this);
    if(_this.closest('.custom_popups').hasClass("formula_only_popup")) {
      setTimeout(function(){
        _this.closest('.custom_popups').removeClass("formula_only_popup"); 
        console.log(_this.closest('.custom_popups'));
        _this.closest('.custom_popups').find('.custom_popup_text_wrp_above').html(_this.closest('.custom_popups').find('.custom_popup_text_wrp_above').html().replace('lines.', 'lines below.'));
      },500);
    }
      $('.learn_more_popup .keep__shopping_close').show();


  });

   $('body').on("click",".custom_popup_button_wrp .custom_popup_button, .custom_button_below_pro_list .custom_popup_button, .promo_popup_open, .js_open_popup_include",function(event){
    event.preventDefault(); 
    event.stopPropagation();
    var custom_popups = $(`[data-${$(this).attr("data-popup_js")}`);
    if (custom_popups.find('.scroll_part').length > 0){
      custom_popups.find('.scroll_part').scrollTop(0);
    }
    
    if($(this).hasClass("effect_continue")){
      $(this).removeClass("effect_conitnue"); 
    }

    $('body').addClass("no_alia_popup");
    
    lockScroll();

    if($(this).hasClass("more_z_index")){ 
      custom_popups.addClass("formula_only_popup");
      custom_popups.find('.custom_popup_text_wrp').html(custom_popups.find('.custom_popup_text_wrp').html().replace('lines below.', 'lines.'));
      $('.learnmore_product_wrp .keep__shopping_close').hide();
      setTimeout(function(){
        custom_popups.addClass("active_popup");
      },500);  
    } else {
        custom_popups.addClass("active_popup");
        setTimeout(function(){
          custom_popups.addClass("active_popup");
        },300);  
    }

     if(custom_popups.find('.image_text_card__video').length > 0){
         custom_popups.find('.image_text_card__video').each(function(index, val){
           var video = $(val)[0];
            if(video != null){
                video.controls=false;
                video.loop=true;
                video.autoplay=true;
                video.muted=true;
                video.currentTime=0;
                video.play(); 
            }
         });
     }

  });

 $('body').on('click', '.cartdrawer-close,.cartdrawer-overlay', function(e) {
    e.preventDefault();
    $('body').removeClass('open-cart');
    if($('.cartdrawer .items').length > 0){
      $('.cartdrawer .items').get(0).scrollTo(0,0);
    }
    unlockScroll();
  });
  function cartrefresh(data){
    $.getJSON("/cart", function(data) {
      
      $('[data-cart-count]').text(data.item_count);
    });
    fetch("/")
    .then(response => response.text())
    .then(data => {
      if ($(data).find('.empty').length == 1 || $('.cartdrawer .empty').length == 1) {
        $('body .cartdrawer').html($(data).find('.cartdrawer').html());
      } else {
        $('body .cartdrawer .cartdrawer-footer').html($(data).find('.cartdrawer-footer').html());
        $('body .cartdrawer .header').html($(data).find('.header').html());
        if ($(data).find('.items .item').length == 1) {
          $('body .cartdrawer .cartdrawer-upsell').addClass('setfull');
        } else {
          $('body .cartdrawer .cartdrawer-upsell').removeClass('setfull');
        }
        $('body .cartdrawer .cartdrawer-upsell').html($(data).find('.cartdrawer-upsell').html());
        $('body .cartdrawer [data-cart_rows]').html($(data).find('[data-cart_rows]').html());
        $('body .cartdrawer .cartdrawer-announcements').html($(data).find('.cartdrawer-announcements').html());
      }
      $('body').addClass('open-cart');
      $('.cartdrawer_loader').removeClass("show");
      if($('.cartdrawer .items').length > 0){
        $('.cartdrawer .items').get(0).scrollTo(0,0);
      }    
    })
    .catch(error => {
      console.error('Cart refresh failed:', error);
      $('.cartdrawer_loader').removeClass("show");
    });
  }

  $('body').on('click', '.cartdrawer .items .item .remove', function(e) {
    e.preventDefault();
    var id = $(this).parents('.item').attr('data-variant-id');
    $('.rc_popup').attr('data-line-item-id',id);
    $('body').addClass('open_rc_popup');
  });
  $('body').on('click', '.remove_confirm', function(e) {
    e.preventDefault();
    var id = $(this).parents('.rc_popup').attr('data-line-item-id');
    $('body').removeClass('open_rc_popup');
    $('.cartdrawer_loader').addClass("show");
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {id:id,quantity:0},
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
        $('.cartdrawer_loader').removeClass("show");
      }
    }).done(function( data ) {
      cartrefresh(data);
    });
  });
  $('body').on('click', '.cartdrawer .items .item .quantity', function(e) {
    $('.cartdrawer_loader').addClass("show");
    console.log("sss");
    e.preventDefault();
    var id = $(this).parents('.item').attr('data-variant-id');
    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    var current_ip = parseInt(input.val());

   
    if($(this).hasClass('minus') && ip == 1){
      $(this).parents('.item').find('.remove').click();
    } else{
       if($(this).hasClass('plus')) {
        ip = ip + 1;
      } else {
        ip = ip - 1;
      }
      input.val(ip);
      
setTimeout(function(){
  
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: {id:id,quantity:ip},
          async: false,
          dataType: 'json',
          error: function(jqXHR, textStatus, errorThrown){
            var response = $.parseJSON(jqXHR.responseText);
            var desc = response.description;
            input.val(current_ip);
            if(desc.indexOf(' to the cart.') != -1){
              var ptitle = desc.replace('to the cart.','');
              var optitle = ptitle.replace("You can't add more","").split(' - ');
              alert('Sorry, we cannot add '+ optitle[optitle.length - 1] +'to your cart due to our limited inventory at this time.');
            }else if(desc.indexOf("' is already sold out.") != -1){
              var ptitle = desc.replace("' is already sold out.","");
              var optitle = ptitle.replace("The product '","").split(' - ');
              alert('Sorry, we cannot add '+ optitle[optitle.length - 1] +' to your cart due to our limited inventory at this time.');
            }else if(desc.indexOf("are in your cart.") != -1){
              var ptitle = desc.replace('are in your cart.','');
              var optitle = ptitle.replace('All','').split(' - ');
              alert('Sorry, we cannot add '+ optitle[optitle.length - 1] +'to your cart due to our limited inventory at this time.');
            }
            $('.cartdrawer_loader').removeClass("show");
          }
        }).done(function( data ) {
          cartrefresh(data);
          if($('.cartdrawer .items').length > 0){
            $('.cartdrawer .items').get(0).scrollTo(0,0);
          }    
        }); 
  },1000); 
    }
  });
  $('body').on('click', '[name="checkout"]', function(e) {
    $('.cartdrawer_loader').addClass("show"); 
  });
  $('body').on('click', '.upsell-list .price-button button', function(e) {
    e.preventDefault();
    var id = $(this).parents('.upsell-item').attr('data-id');
    $('.cartdrawer_loader').addClass("show");
     var properties = {};

          if (sessionStorage.getItem('glove_page') === 'true') {
            properties._glove_page = 'true';
          }

          if (sessionStorage.getItem('glof_page') === 'true') {
            properties._glof_page = 'true';
          }

          if (sessionStorage.getItem('mat_page') === 'true') {
            properties._mat_page = 'true';
          }
    setTimeout(function(){
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {id:id,quantity:1,properties: properties},
      dataType: 'json',
      async: false,
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
        $('.cartdrawer_loader').removeClass("show");
      },success: function(data){
        var current_list_id='Upsell';
        add_track_event(data,current_list_id);
      }
    }).done(function( data ) {
      cartrefresh(data);
      if($('.cartdrawer .items').length > 0){
        $('.cartdrawer .items').get(0).scrollTo(0,0);
      }    
    });
      },1000); 
  });
  $('body').on('click','.remove_upsell',function(e){
    e.preventDefault();
    $('body').addClass('hide_upsell');
  });
  $('body').on('click', '.close_rc_popup,.rc_overlay', function(e) {
    e.preventDefault();
    $('body').removeClass('open_rc_popup');
    $('.cartdrawer_loader').removeClass("show"); 
  });
   $('body').on('click','.empty_cart_link',function(e){
     e.preventDefault(); 
    $('body').removeClass('open-cart'); 
    
    if($('.cartdrawer .items').length > 0){
      $('.cartdrawer .items').get(0).scrollTo(0,0);
    }
    // $('body').removeClass('no-scroll');
    // $('html').removeClass('no-scroll');
    // if(localStorage.getItem("scroll_value") != null && localStorage.getItem("scroll_value") != undefined && localStorage.getItem("scroll_value") != '' && localStorage.getItem("scroll_value") != 'undefined'){
    //   window.scrollTo(0, localStorage.getItem("scroll_value"));
    //   localStorage.removeItem("scroll_value");
    // }
   
    unlockScroll();
     
    var href = $(this).attr('data-href');
     if($('.template-index').length > 0 || ($("#press_section").length > 0 && $("#shop_now").length > 0 )){
       var id = href.split('#')[1];
       scroll_shop(id);
     }else{
       window.location = href;
     }
     
  });

  $('body').on('click','[data-disclosure-currency] .disclosure__toggle',function(e){
    e.preventDefault();
    $('body').addClass('hide_upsell');
    if(!$(this).closest('[data-disclosure-currency]').find('[data-disclosure-list]').hasClass('disclosure-list--visible')){
      $(this).closest('[data-disclosure-currency]').find('[data-disclosure-list]').addClass('disclosure-list--visible');
      $(this).attr("aria-expanded","true");
    } else{
      $(this).closest('[data-disclosure-currency]').find('[data-disclosure-list]').removeClass('disclosure-list--visible');
      $(this).attr("aria-expanded","false");
    }
  });

  $('body').on('click','.disclosure-list__option',function(e){
    e.preventDefault();
   var form = $(this).closest('form#localization_form');
    form.find('[name="country_code"]').val($(this).attr('data-value'));
    form.submit();
  });

   if($('.review_caurosals').length > 0){
    $(".review_caurosals").slick({
      slidesToShow: 3.1,
      slidesToScroll: 1,
      infinite: true,
      speed: 100,
      swipeToSlide: true,
      waitForAnimate: false,
      touchThreshold: 100,
      centerMode: false,
      arrows: true,
      cssEase: 'linear',
      variableWidth: false,
      autoplay: $('.review_caurosals').attr("data-autoplay") == 'false'? false : true,
      autoplaySpeed: $('.review_caurosals').attr("data-autoplay_speed"),
      dots: true,
      appendDots: $('.review_caurosals_slick_buttons .caurosal_dots'),
      prevArrow: $('.review_caurosals_slick_buttons .prev_button'),
      nextArrow: $('.review_caurosals_slick_buttons .next_button'),
      responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2.2
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1.2
        }
      }
    ]
    });
     $('.review_caurosals_slick_buttons .caurosal_dots ul.slick-dots li').css("width",($('.review_caurosals_slick_buttons .caurosal_dots').width()/$('.review_caurosal_card').length)+"px");
  }

$("body").on("click",".set > span", function () {
    $(this).hasClass("active")
      ? ($(this).removeClass("active"),
        $(this).siblings(".content").slideUp(200),
        $(".set > span i").removeClass("fa-minus").addClass("fa-plus"))
      : ($(".set > span i").removeClass("fa-minus").addClass("fa-plus"),
        $(this).find("i").removeClass("fa-plus").addClass("fa-minus"),
        $(".set > span").removeClass("active"),
        $(this).addClass("active"),
        $(".content").slideUp(200),
        $(this).siblings(".content").slideDown(200));
  });
  $("body").on("click",".faqbtn", function () {
      $(".faqbtn").toggleClass("active"), $(".togglecontainer").slideToggle();
  });

  if($(".slider1").length > 0){
    var slick_settings = {
        dots: !0,
        infinite: !1,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              dots: !0,
              slidesToShow: 1,
              slidesToScroll: 1,
              adaptiveHeight: !0,
            },
          },
        ],
      };
    if($(window).width() < 768){
      $(".slider1").slick(slick_settings);
    }
     $(window).on("resize orientationchange load", function () {
       if($(window).width() >= 768){
         if($(".slider1").hasClass('slick-initialized')){
           $(".slider1").slick("unslick");
         } 
       } else{
         $(".slider1").not('.slick-initialized').slick(slick_settings);
         $(".slider1").slick("refresh");
       }
     });
  }

  
// if ($('.theridge-promoBanner__text').length > 1) {
//   var bannerFlip = document.querySelector(".theridge-promoBanner__wrapper");
//   var bannerTextNumber = document.getElementsByClassName("theridge-promoBanner__text").length;

//   var bannerSize = 44.5;

//   if ($(window).width() < 768) {
//     bannerSize = 38;
//   }
//   var firstBannerClone = document.querySelector(".theridge-promoBanner__text").cloneNode(true);
//   bannerFlip.appendChild(firstBannerClone);

//   var currentPosition = 0;
//   var totalHeight = bannerSize * bannerTextNumber;

//   var bannerFlipInterval = setInterval(() => {
//     currentPosition -= bannerSize; 
//     bannerFlip.style.transition = "transform 0.5s ease";
//     bannerFlip.style.transform = `translateY(${currentPosition}px)`;

//     if (Math.abs(currentPosition) >= totalHeight) {
//       setTimeout(() => {
//         bannerFlip.style.transition = "none";
//         currentPosition = 0;
//         bannerFlip.style.transform = `translateY(${currentPosition}px)`;
//       }, 500); 
//     }
//   }, 3000);
// }

var promoWrappers = document.querySelectorAll(".announcement-bar--wrp .theridge-promoBanner__wrapper");

promoWrappers.forEach(wrapper => {
  if (window.getComputedStyle(wrapper).display === "block") {
    var bannerTextNumber = wrapper.getElementsByClassName("theridge-promoBanner__text").length;

    if (bannerTextNumber < 2) {
      return;
    }
    var bannerSize = 44.5;

    if ($(window).width() < 768) {
      bannerSize = 38;
    }

    var firstBannerClone = wrapper.querySelector(".theridge-promoBanner__text").cloneNode(true);
    wrapper.appendChild(firstBannerClone);

    var currentPosition = 0;
    var totalHeight = bannerSize * bannerTextNumber;

    wrapper.style.overflow = "hidden";

    var bannerFlipInterval = setInterval(() => {
      currentPosition -= bannerSize; 
      wrapper.style.transition = "transform 0.5s ease";
      wrapper.style.transform = `translateY(${currentPosition}px)`;

      if (Math.abs(currentPosition) >= totalHeight) {
        setTimeout(() => {
          wrapper.style.transition = "none";
          currentPosition = 0;
          wrapper.style.transform = `translateY(${currentPosition}px)`;
          setTimeout(() => {
            wrapper.style.transition = "transform 0.5s ease";
          }, 50); 
        }, 500); 
      }
    }, 4000);
  }
});


  
document.querySelectorAll('.review_caurosal_card').forEach(wrapper => {
  const desc = wrapper.querySelector('.review_caurosal_desc');
  const readMore = wrapper.querySelector('.read-more_review');

  const lineHeight = parseFloat(getComputedStyle(desc).lineHeight);
  const maxHeight = lineHeight * 7;

  if (desc.scrollHeight > maxHeight + 2) {
    readMore.style.display = 'inline';
  } else {
    readMore.style.display = 'none';
  }

  readMore.addEventListener('click', function(e) {
    e.preventDefault();

    const isExpanded = desc.classList.toggle('expanded');
    readMore.textContent = isExpanded ? 'Less' : 'More';
  });
 
});

 $(window).on("resize",function() {
    document.querySelectorAll('.review_caurosal_card').forEach(wrapper => {
  const desc = wrapper.querySelector('.review_caurosal_desc');
  const readMore = wrapper.querySelector('.read-more_review');

  const lineHeight = parseFloat(getComputedStyle(desc).lineHeight);
  const maxHeight = lineHeight * 7;

  if (desc.scrollHeight > maxHeight + 2) {
    readMore.style.display = 'inline';
  }  else {
    readMore.style.display = 'none';
  }
    });
});


if (navigator.appVersion.indexOf('Mac') >= 0) {
  $('body').addClass("mac");
} else {
  $('body').addClass("window");
}

  
$('body').on("click",".js_learnmore",function(e){
  e.preventDefault();
  var _this = $(this);
  var review_ratings = _this.next('.reviews_html_count').html();
  var url = $(this).attr("href");
  // document.querySelector('.learnmore_loader').style.display="flex";
  document.querySelector('.learnmore_loader').classList.add('show_loader');
  
  if(!$('body').hasClass('lock-scroll')) {
    lockScroll();
  }
  
  $('body').addClass("no_alia_popup");
  $('.learmore_product #ProductJson').remove();
  $('.learmore_product #ProdcutMetafields').remove();
  $('.learmore_product').html(" ");

  window.first_time_open = true;
  window.first_time_open_review = true;

  var learn_more_template = $(this).attr("data-template") || 'learn_more';

  $.get(`${url}&view=${learn_more_template}`, function(inner_images){

    $.get(url, function(html){

      var pid = $(html).find('.product_temp').attr("data-product_id");
      
      localStorage.setItem('popup_open_quick', 'true');

      if(inner_images && $(html).find('.append_images').length > 0){
        // alert(" inner_images ");
        $(html).find('.append_images').html(inner_images);
      }
      if ($(html).find('.js_main_product_wrp').length > 0) {
        if ($(html).find('.js_main_product_wrp').find(".pdp_append_data").length > 0) {
          $('.learmore_product').html($(html).find('.js_main_product_wrp').find(".pdp_append_data").html().replaceAll('custom_review_popup','custom_review_popup custom_review_popup_learn_more'));
        }
      }
      
      if(inner_images){
        $('.learmore_product .append_images').html(inner_images);
      }

      $('.learmore_product .product_temp').find('.custom_review_popup').html(review_ratings);

      document.querySelector('.learmore_product').scrollTo(0, 0);
      document.querySelector('.learmore_product_wrp').scrollTo(0, 0); 
      window.minus_pos = 0;
      if (url.indexOf('/products/sneaker-sole-grip-bundles?variant=42846654398616') == -1 && url.indexOf('/products/sneaker-sole-grip-bundles') > -1) {
        window.minus_pos = 1;
      }
      window.currentIndex = 0;
      window.mobile_image_load();
      window.load_change();
      window.image_height();
      window.load_time = true;
      window.change_name_id();

      window.all_observes();

      window.renderIndicator();

       const intervalID = setInterval(imagechange, 10);
    var timesRun = 0;
    var imagechange = setInterval(function () {
        timesRun += 1;
        if (timesRun === 10) {
            clearInterval(imagechange);
        }
        var img = document.querySelector(".learmore_product img.product-single__thumbnail-image:not(.with_video)"),
            height = img ? img.parentNode.clientHeight + "px" : "100%",
            videoImages = document.querySelectorAll(".learmore_product .with_video.product-single__thumbnail-image");
        videoImages.length > 0 &&
            videoImages.forEach(function (e) {
                e.style.height = height;
            });
             document.querySelectorAll(".learmore_product [data-slider-item] img").forEach(function(e){
              e.style.height = height;
            });
    }, 10);

      var scroll_wrp_l = document.querySelector(".learmore_product .scroll-wrap_mob .scroll-wrap"), o;

      $('.learmore_product .scroll-wrap_mob .scroll-wrap').scroll(function(){
        clearTimeout(o);
              o = setTimeout(function () {
                  var activeElement = document.querySelector(".learmore_product .scroll-wrap_mob.main_mob #indicator .active").parentElement;
                  var currentIndex = Array.from(activeElement.parentElement.children).indexOf(activeElement) + 1;
                  var totalItems = document.querySelectorAll(".learmore_product .scroll-wrap_mob.main_mob .scroll-wrap li:not(.hide_var)").length;
                  var nextArrow = document.querySelector(".learmore_product .scroll-wrap_mob.main_mob .arrow_next");
                  var prevArrow = document.querySelector(".learmore_product .scroll-wrap_mob.main_mob .arrow_prev");
      
                  nextArrow.style.display = "block";
                  prevArrow.style.display = "block";
      
                  if (currentIndex >= totalItems) {
                      nextArrow.style.display = "none";
                  }
      
                  if (currentIndex < 2) {
                      prevArrow.style.display = "none";
                  }
                $('.learmore_product .media-video').each(function(index, val) {
                  var v = $(val)[0];
                  if(v != null){
                  if (!v.paused) {
                    // if(!v.classList.contains('learnmore_video_mob')){}
                      v.pause();
                      v.controls=false;
                      v.loop=true;
                      v.autoplay=false;
                      v.muted=true;
                      // if(!v.classList.contains('learnmore_video_mob')){}
                      v.currentTime=0; 
                    }
                  }
                  $(val).next().css("display", "flex");

                });
                $('.learmore_product .main_mob').find('.product_media_button').css("display", "flex");
                var video = document.querySelectorAll('.learmore_product .main_mob .scroll-wrap > li:not(.hide_var)')[currentIndex-1].querySelector('video');
                $(document.querySelectorAll('.learmore_product .main_mob .scroll-wrap > li:not(.hide_var)')[currentIndex-1]).find('.product_media_button').css("display", "flex")

              var visibleItem = document.querySelectorAll('.learmore_product .main_mob .scroll-wrap > li:not(.hide_var)')[currentIndex - 1];
              var imgHeight = $(visibleItem).find('img').height() || $(visibleItem).find('video').height();
              var imgWidth = $(visibleItem).find('img').width() || $(visibleItem).find('video').width();

              var containerWidth = visibleItem.offsetWidth;
              var newHeight = (imgHeight / imgWidth) * containerWidth;

              console.log(imgHeight);
                document.querySelector(".learmore_product .scroll-wrap_mob .scroll-wrap").style.height = `${imgHeight}px`;
                if (imgHeight > 100) {
                  document.querySelector(".learmore_product .scroll-wrap_mob .scroll-wrap").style.minHeight = 'unset';
                }
              
              }, 10);
      });

    
        window.image_height();
        if(window.info_text != "" && window.info_text != undefined && window.info_text != null) {
          if($('.learmore_product .info_dis_text').length == 0){
            $('.learmore_product .select_option').after(`<p class='info_dis_text'>${window.info_text}</p>`);
          }
        }
        $('.learmore_product .product-single__thumbnails-item[data-slider-slide-index="-1"]').find('.product-single__thumbnail').click();
        $('.learmore_product #indicator li').find('span[data-index="1"]').closest('li').click();   
        
        var p_id = Number($('.learmore_product .product_temp').attr('data-product_id')); 

        if ((p_id == 6754115092632 || p_id == 7734929129624) && sessionStorage.getItem('glove_page') === 'true') {

          if (Shopify.locale == 'ko') {
            $('.learmore_product .product-single__description h3:visible').first()
            .html(`특허 출원 중인 <span data-popup_js="inside_popup_custom_football" class="js_open_popup_include more_z_index" style="color: #1a0dab;text-decoration: underline;">EDGE®</span> 포뮬러로 축구 장갑의 그립감을 새것처럼 되살려보세요.`);

          }
          else if (Shopify.locale == 'ja') {
          $('.learmore_product .product-single__description h3:visible').first()
            .html(`当社の特許出願中の<span data-popup_js="inside_popup_custom_football" class="js_open_popup_include more_z_index" style="color: #1a0dab;text-decoration: underline;">EDGE®</span>成分が、アメフトグローブを徹底的に洗浄し、グリップ力を回復させます。`);
         }else{
            $('.learmore_product .product-single__description h3:visible').first()
            .html(`Our patent-pending <span data-popup_js="inside_popup_custom_football" class="js_open_popup_include more_z_index" style="color: #1a0dab;text-decoration: underline;">EDGE® Formula</span> deep cleans and regrips football gloves.`);

         } 


        } 
        else if (p_id == 7728439034008 && sessionStorage.getItem('glove_page') === 'true') {


          if (Shopify.locale == 'ko') {

             $('.learmore_product .product-single__description h3:visible').first()
          .html(`특허 출원 중인 <span data-popup_js="inside_popup_custom_football" class="js_open_popup_include more_z_index" style="color: #1a0dab;text-decoration: underline;">EDGE®</span>, 포뮬러가 함유된 와이프로 축구 장갑을 깨끗하게 세정하고, 마모된 그립력을 새것처럼 복원시켜 보세요.`);
            

          } else if (Shopify.locale == 'ja') {
            $('.learmore_product .product-single__description h3:visible').first()
              .html(`当社の特許出願中の<span data-popup_js="inside_popup_custom_football" class="js_open_popup_include more_z_index" style="color: #1a0dab;text-decoration: underline;">EDGE®成分</span>を配合したワイプが、アメフトグローブを徹底的に洗浄し、グリップ力を回復させます。`);
          }  else{

              $('.learmore_product .product-single__description h3:visible').first()
            .html(`Infused with our patent-pending <span data-popup_js="inside_popup_custom_football" class="js_open_popup_include more_z_index" style="color: #1a0dab;text-decoration: underline;">EDGE® Formula</span>, our wipes deep clean and regrip football gloves.`);
            
          }
          

        } 
        else if (p_id == 7738116505752 && sessionStorage.getItem('glove_page') === 'true') {

          if (Shopify.locale == 'ko') {

            $('.learmore_product .product-single__description h3:visible').first()
            .html(`그립 스프레이와 그립 와이프를 동시에! 두 가지 제품이 선사하는 강력한 세정력과 탁월한 그립 복원력을 경험해 보세요.`);


          } else if (Shopify.locale == 'ja') {

              $('.learmore_product .product-single__description h3:visible').first()
                .html(`バンドルには当社のグリップスプレーとグリップワイプの両方が含まれています。どちらの製品も、アメフトグローブを徹底的に洗浄し、グリップ力を回復させます。`);
            } else{

              $('.learmore_product .product-single__description h3:visible').first()
            .html(`Bundles come with both our Grip Spray and our Grip Wipes - use either to deep clean and regrip football gloves.`);


            }


          
              
        } 
        else if ((p_id == 6754115092632 || p_id == 7734929129624 || p_id == 7728439034008) && sessionStorage.getItem('golf_page') === 'true') {
          $('.learmore_product .product-single__description h3:visible').first()
            .html(`Deep cleans and rejuvenates your golf grips.`);
        }

        
        $('.learn_more_popup').addClass("active");
        
        document.querySelector('.learmore_product').scrollTo(0, 0);
        document.querySelector('.learmore_product_wrp').scrollTo(0, 0); 
        
        // if($('.learn_more_popup').find('.learnmore_video:not(.learnmore_video_mob)').length > 0) {
        //   if($('.learn_more_popup').find('.learnmore_video:not(.learnmore_video_mob)')[0].paused && $('.learn_more_popup').find('.learnmore_video:not(.learnmore_video_mob)')[0].currentTime == 0){
        //     $('.learn_more_popup').find('.learnmore_video:not(.learnmore_video_mob)')[0].play();
        //   }  
        // }
        // if($('.learn_more_popup').find('.learnmore_video_mob').length > 0) {
        //   if($('.learn_more_popup').find('.learnmore_video_mob')[0].paused && $('.learn_more_popup').find('.learnmore_video_mob')[0].currentTime == 0){  
        //     $('.learn_more_popup').find('.learnmore_video_mob')[0].play();
        //   }  
        // }
        document.querySelector('.learnmore_loader').classList.remove('show_loader');

    });

  });
});


   $('body').on("click",".learn_more_popup.active .close_icon, .learn_more_popup .overlay, .keep__shopping_close",function(e){
      e.preventDefault();
    if (window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.delete('variant'); 
        window.history.replaceState({}, document.title, url.toString());
    }


   $('.learn_more_popup').removeClass("active");
   $('.learmore_product').html(" ");

   $('body').removeClass("no_alia_popup");
   
   unlockScroll();
   
    if($('.learn_more_popup').find('video').length > 0){
         $('.learn_more_popup').find('video').each(function(index, val){
           var video = $(val);
            if(video != null){
                video.stop(); 
            }
         });
     }
     

  });

  document.addEventListener("click", function(event) {
  if (event.target.closest(".custom_review_popup.custom_review_popup_learn_more")) {
    event.stopPropagation();
      event.preventDefault();
      $('#custom_learn_more_judgme').addClass("active");
      if($('.learn_more_popup.active').length == 0) {
        lockScroll();
      }
  }
});

var target = document.querySelector(".judme_learn_more");
if (target) {
  var observer = new MutationObserver(() => {
    target.querySelectorAll("img[data-src]").forEach(img => {
      if (!img.src || img.src !== img.dataset.src) { 
        img.src = img.dataset.src;
      }
    });
    document.querySelectorAll(
  '.judme_learn_more .jdgm-sort-dropdown option[value="most-helpful"], .judme_learn_more .jdgm-sort-dropdown option[value="videos-first"]'
    ).forEach(opt => opt.remove());

  });

  observer.observe(target, {
    childList: true,
    subtree: true
  });
}

var scrollY;
function lockScroll() {
  if(localStorage.getItem("scroll_value") == null) {
    scrollY = window.scrollY;
    localStorage.setItem("scroll_value", window.scrollY); 
    document.body.style.top = `-${scrollY}px`;
    document.body.classList.add("lock-scroll");
  } 
}

function unlockScroll() {
  document.body.classList.remove("lock-scroll");
  document.body.style.top = "";
  window.scrollTo(0, localStorage.getItem("scroll_value") != null ? localStorage.getItem("scroll_value") : window.scrollY);
  localStorage.removeItem("scroll_value");
}

function scrollWhenIdle(callback, timeout = 200) {
    let timer;
    window.addEventListener("scroll", function() {
        clearTimeout(timer);
        timer = setTimeout(callback, timeout);
    }, { passive: true });
}

$("body").on("click", ".learmore_product_wrp .jdgm-paginate__page", function() {
    scrollWhenIdle(() => {
        document.querySelector(".learmore_product_wrp .jdgm-row-actions")?.scrollIntoView({ behavior: "smooth" });
    });
});

 
  //  var interval = setInterval(() => {
  //   var el = document.querySelector(".jdgm-rev-widg__body");
  //   if (el && el.getAttribute("style") && el.getAttribute("style").trim() !== "") {
  //     clearInterval(interval);
  //     document.querySelector(".jdgm-row-actions").scrollIntoView({ behavior: "smooth" });
  //   }
  // }, 300); 

    /* custom reviews */

var review_json = [{
   "title": "Awesome product",
   "body": "Can’t believe someone finally thought to make something like this! And it actually works.",
   "rating": 5,
   "review_date": "2021-11-09 18:58:44 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Sarah Marilyn",
   "reviewer_email": "sarahmarilynsocial@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "174.104.141.156",
   "location": "Stow, Ohio, United States",
   "metaobject_handle": "review-14241e0f-1bd0-4360-aa0b-c1455cdd9fb1"
 },
 {
   "title": "KING Yabba’s Feedback",
   "body": "I work with a lot of basketball players on the side in addition to creating Sonic Art! Personally I have never seen some of my players make the moves I saw them make yesterday. I can’t wait to see how they play against competition that don’t have the EDGE! I appreciate the love and we would love to have more product. I WOULD LOVE TO WORK MORE WITH THE EDGE FAMILY! ",
   "rating": 5,
   "review_date": "2021-11-11 17:49:38 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "KING Yabba",
   "reviewer_email": "1king.yabba@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "https://s3.amazonaws.com/me.judge.review-images/edge-traction-spray/1636653236__759A5518-B007-4B00-B973-C85787B01C91__original.jpeg, https://s3.amazonaws.com/me.judge.review-images/edge-traction-spray/1636653237__23F0885D-6C42-4E65-8252-F007C9BD5FCC__original.jpeg",
   "ip_address": "98.207.2.216",
   "location": "Daly City, California, United States",
   "metaobject_handle": "review-de0ba3f5-403e-4dc3-bfad-3c8dc55305c8"
 },
 {
   "title": "Amazing Product",
   "body": "I love the attention to detail from the bottle itself to the packaging. Not only does it look great, it works even better. Way better alternative to the sticky mats and licking your hands.",
   "rating": 5,
   "review_date": "2021-11-17 02:54:26 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Michael Barajas",
   "reviewer_email": "michaelbarajas22@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "76.182.193.217",
   "location": "Carrollton, Texas, United States",
   "metaobject_handle": "review-24749f2b-5dd4-41f3-863d-aca653fcc7af"
 },
 {
   "title": "Awesome spray!",
   "body": "Great traction on slippery floors\nLove the recyclable packaging",
   "rating": 5,
   "review_date": "2021-12-05 16:52:34 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Cynthia",
   "reviewer_email": "keckles2112@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "174.197.140.238",
   "location": "Brooklyn, New York, United States",
   "metaobject_handle": "review-6e55fcac-7cbc-4c55-89bb-646b41998ba1"
 },
 {
   "title": "John hall",
   "body": "I am a college basketball player and I tried this product on some old shoes for practice and the grip on them felt brand new",
   "rating": 5,
   "review_date": "2022-01-20 04:53:39 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "John Hall",
   "reviewer_email": "halljohnathan58@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "65.254.30.118",
   "location": "Lowell, Massachusetts, United States",
   "metaobject_handle": "review-557e63db-3e2a-4a6d-84c6-ecd1c4f2831d"
 },
 {
   "title": "Shoes Feel Like An Indoor Cleat and Safe For Sneakerheads",
   "body": "Edge Spray really allows me to play how I want to play no matter what the surface conditions are or what shoes I'm wearing. I am a frequent club table tennis player and we usually set up tables in a space where floors aren't maintained and there is a lot of foot traffic which means it's like a slip and slide when trying to plant your feet and make aggressive maneuvers. When playing a competitive match we used to get some wet papers towels to clean our shoes between every point and they would go back to slipping in a few seconds with how dusty the floor was. Edge Spray was really incomparable to just cleaning my shoes with water the grip was noticeably stronger, and even after playing a few minutes on a really dusty floor it felt like the shoe was freshly cleaned and the grip is much stronger and lasts much longer than just wiping with water. Another thing I wanted to note is one of my main concerns with this product was if it would affect some of my more expensive sneakers in any way but there have been no changes at all they look and feel exactly the same in my hands as before I applied Edge Spray the only thing that changed is the grip. Magic in a bottle!",
   "rating": 5,
   "review_date": "2022-01-26 23:53:44 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Michael Bronikowski",
   "reviewer_email": "mbronik1@binghamton.edu",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "149.125.21.113",
   "location": "Binghamton, New York, United States",
   "metaobject_handle": "review-b7706672-a8b8-4de4-84b2-82063c1237b5"
 },
 {
   "title": "",
   "body": "amazing",
   "rating": 5,
   "review_date": "2022-02-22 16:04:39 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Jacob Howard",
   "reviewer_email": "jacobhoward47@aol.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "209.175.44.33",
   "location": "Chicago, Illinois, United States",
   "metaobject_handle": "review-69ae9eec-e665-4082-a6bc-ebffe9945b74"
 },
 {
   "title": "Best Product",
   "body": "This product actually works, I was skeptical at first but when I applied I never regretted it. I play D2 NCAA Men’s Volleyball and this product has change my game",
   "rating": 5,
   "review_date": "2022-03-24 01:04:37 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Jamesly Metayer",
   "reviewer_email": "jameslymetayer123@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "50.231.95.206",
   "location": "Jacksonville, Florida, United States",
   "metaobject_handle": "review-a48722a2-6eca-42ee-a398-8fc5c33f86bf"
 },
 {
   "title": "You need this!!!!",
   "body": "Stop your athlete from wiping their feet for traction with their hands and use EDGE SPRAY. It’s the BEST!",
   "rating": 5,
   "review_date": "2022-03-26 21:17:40 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Adriana Sheri",
   "reviewer_email": "adrisheri@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "174.193.130.105",
   "location": "Los Angeles, California, United States",
   "metaobject_handle": "review-59c68660-dd9f-4335-a189-c5ee77f36166"
 },
 {
   "title": "Perfect Buy",
   "body": "First time in a while back on the court & used Edge Spray & let me tell you this stuff works! I was using a very very old Pair of VB shoes with like no grip & they was able to grip & make the scratchy noise from kicking the floor I was so surprised. If they can pick up traction on an old shoe, imagine a new one! Perfect buy!",
   "rating": 5,
   "review_date": "2022-04-07 21:44:47 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Fabiola Garcon",
   "reviewer_email": "fabgar14@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "24.218.247.136",
   "location": "Brockton, Massachusetts, United States",
   "metaobject_handle": "review-a3e1c886-f26a-4ab0-89de-222fc4f72dee"
 },
 {
   "title": "Mind blowing product",
   "body": "This is one of those products that have one of the best materials and this will blow your mind, just 2 sprays and you will be up and running, and this lasts for awhile, you need to buy this, this is no joke it works just like it says.",
   "rating": 5,
   "review_date": "2022-04-28 01:49:38 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Jimmy",
   "reviewer_email": "jimmyninjas2@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "https://s3.amazonaws.com/me.judge.review-images/edge-traction-spray/1651110578__image__original.jpg",
   "ip_address": "96.227.100.175",
   "location": "Allentown, Pennsylvania, United States",
   "metaobject_handle": "review-6ec81bb2-771e-4f21-a4a6-c34a1de22d0d"
 },
 {
   "title": "EDGE Spray",
   "body": "Firstly, I love the box that it came in. It's very nice and safe. I tried it on an indoor court and it worked perfectly. It performed like I expected to be. I could feel the difference with and without it. Overall, great product and would definitely recommend it to my friends and others.",
   "rating": 5,
   "review_date": "2022-05-01 21:15:57 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Jimmy",
   "reviewer_email": "jimmyninjas2@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "174.198.9.227",
   "location": "Philadelphia, Pennsylvania, United States",
   "metaobject_handle": "review-36420699-b5f0-435e-85ce-30221424068c"
 },
 {
   "title": "Better grip",
   "body": "Guys said they started feeling the better grip considering the floor was not always clean.",
   "rating": 5,
   "review_date": "2022-07-20 20:34:34 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Kevin Kovacs",
   "reviewer_email": "kevin.kovacs@gallaudet.edu",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "174.195.200.54",
   "location": "Chino, California, United States",
   "metaobject_handle": "review-fe527cec-e2e2-4179-a3bf-cef5f5ae71eb"
 },
 {
   "title": "Amazing Traction",
   "body": "We went from using a sticky mat over and over every game to always tearing a sheet as they thought it didnt work to using EDGE and it being effective for them on the court. Now they always look to use it before every game.",
   "rating": 5,
   "review_date": "2022-07-31 14:19:21 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Tom Tran",
   "reviewer_email": "coacht2@yahoo.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "73.220.52.162",
   "location": "Rancho Cordova, California, United States",
   "metaobject_handle": "review-c7bf3423-5174-41e0-ab5a-97fc2fc926ed"
 },
 {
   "title": "Drying + Stickiness + Duration",
   "body": "I do a lot of weightlifting with functional training -- EDGE really came in clutch for all of my balance work! A lot of time, I find that it’s not my balance that falters, but the grip on my shoe. Edge really helped with this. No more sliding around. \nThat being said, I’d love for the spray to set faster with a longer duration. You'll have to reapply, but you want to b/c it's worth it.  ;)",
   "rating": 4,
   "review_date": "2022-08-15 16:13:51 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Ariel Schulze",
   "reviewer_email": "arielbschulze@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "24.30.36.110",
   "location": "Atlanta, Georgia, United States",
   "metaobject_handle": "review-039a323e-6fcb-4504-b329-9aba4bdeed41"
 },
 {
   "title": "Edge’s Grip Spray, Game Changer!",
   "body": "This spray adds part to your game you didn’t know was missing. Getting on the court knowing that a whole category of error is eliminated elevates your game in a way you don’t realize until you do it. Knowing you won’t slip and your movements will be more clean and secure will give you a confidence boost. I recommend every athlete that plays on any kind of court to invest in themselves by getting Edge Spray!",
   "rating": 5,
   "review_date": "2022-08-15 21:38:59 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Demonte Denzel Flannigan",
   "reviewer_email": "flannigandemonte@yahoo.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "https://s3.amazonaws.com/me.judge.review-images/edge-traction-spray/1660599777__fdd06f41-b6dc-437e-8d31-c3c2c0f8aa40__original.jpeg",
   "ip_address": "188.27.106.129",
   "location": "Craiova, Dolj, Romania",
   "metaobject_handle": "review-67102e68-7154-4ff6-8e7e-3061e0d87fa5"
 },
 {
   "title": "Great Product",
   "body": "Easy to use, reliable for games on end, adds great traction for dusty surfaces or even semi-worn shoes, portable and accessible making it the best thing I’ve used since…EVER. Nothing on the market compares to this product tbh. Glad I copped",
   "rating": 5,
   "review_date": "2022-10-02 23:19:21 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Zay",
   "reviewer_email": "brolicbyzay@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "167.160.130.80",
   "location": "Washington, District of Columbia, United States",
   "metaobject_handle": "review-c682c69d-34bb-41bf-bdc7-2a52299efd61"
 },
 {
   "title": "Wow",
   "body": "This Stuff is Awesome!!!  They even help older shoes that used to basketball become relevant again!!!  Kobe 5 OG with some really worn down outsoles once again became alive with Edge Spray!!!",
   "rating": 5,
   "review_date": "2022-11-21 19:49:27 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Rod ",
   "reviewer_email": "rbowers@augusta.k12.va.us",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "216.12.45.75",
   "location": "Staunton, Virginia, United States",
   "metaobject_handle": "review-7a25272e-7624-436c-a390-c09ba499c009"
 },
 {
   "title": "Must cop",
   "body": "Love this spray got instant grip after using it on multiple sneaker brands",
   "rating": 5,
   "review_date": "2022-12-05 01:27:50 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Brent Emelander",
   "reviewer_email": "soledoutyt@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-d92ece71-8579-466c-a0eb-7f0bd60dc9bb"
 },
 {
   "title": "Amazing Product",
   "body": "I’ve never tried a grip spray before. This product is amazing. After 3 to 4 sprays to each shoe, the traction improved amazingly and I could feel the confidence I need it.",
   "rating": 5,
   "review_date": "2023-01-07 23:54:41 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Jaime Sotelo",
   "reviewer_email": "jimmy.curry05@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "187.190.5.245",
   "location": "Ciudad Juárez, Chihuahua, Mexico",
   "metaobject_handle": "review-c3295dbe-d914-4677-96ee-91e26ed4e3ea"
 },
 {
   "title": "Must have",
   "body": "The DeSoto Lady Eagles do not take the court without having our Edge;)",
   "rating": 5,
   "review_date": "2023-02-03 04:45:10 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Kadi Creel",
   "reviewer_email": "kadi.creel@desotoisd.org",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "70.143.103.163",
   "location": "DeSoto, Texas, United States",
   "metaobject_handle": "review-0efe7678-3210-4363-898b-d71a9584a0aa"
 },
 {
   "title": "No more slipping!",
   "body": "Everytime my son slips and falls at basketball practice, I hold my breath. I don’t even let him get on the court without spraying his shoes anymore. I just wish it came in a bigger size, we’re almost finished with the first bottle already.",
   "rating": 5,
   "review_date": "2022-01-14 00:20:34 UTC",
   "source": "judge-me",
   "curated": "ok",
   "reviewer_name": "Marie",
   "reviewer_email": "mtkecko16@aol.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-cb18b95b-b1f6-4178-8e46-663eae31ce81"
 },
 {
   "title": "Tested on rock climbing shoes",
   "body": "Outside of its current market - if you are a rock climber struggling with grip indoor or outdoor, Edge Spray may be what you are looking for.\nGrip is no joke, significantly increases grip on very small footchips to climb on, and has this \"sticky\" feel to it without actually being \"sticky.\" Best use is within first 20 mins in my opinion. Can seriously step up your game if needed for a very difficult climb. Quickly dries just like the instruction says, and you’re good to climb with great grip soon after.",
   "rating": 5,
   "review_date": "2022-01-20 00:22:04 UTC",
   "source": "judge-me",
   "curated": "ok",
   "reviewer_name": "Jonathan Kwan",
   "reviewer_email": "jkwan11@binghamton.edu",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-d59105bc-8f00-4e1d-b997-0212497f67d9"
 },
 {
   "title": "Great for Workouts",
   "body": "This product is amazing for when I’m taking workout classes in the gym. I’m always concerned about losing my footing on a move or slipping in plank positions. One less thing to worry about.",
   "rating": 5,
   "review_date": "2022-01-17 16:50:34 UTC",
   "source": "judge-me",
   "curated": "ok",
   "reviewer_name": "James K.",
   "reviewer_email": "jimkeck21@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-6c36f41d-14ac-4439-9267-320bc92ec27e"
 },
 {
   "title": "I like this product",
   "body": "I just tried it and I love it! I like how it works and there is not slippage when I am doing suicides.",
   "rating": 5,
   "review_date": "2023-03-15 17:14:11 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Holly Howard",
   "reviewer_email": "hrhoward@hotmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "50.51.120.186",
   "location": "Huron, Ohio, United States",
   "metaobject_handle": "review-e5acdb4f-93ec-4112-afea-fd849c7bb890"
 },
 {
   "title": "Great improvement on fencing shoe grips",
   "body": "Recently I bought three bottle of the spray and used on my fencing shoes on aluminum strip, the shoe grip was improved dramatically and never slipped. I recommend this product to my team players!",
   "rating": 5,
   "review_date": "2023-03-29 03:47:19 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Hui Liu",
   "reviewer_email": "hui007@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "67.221.143.36",
   "location": "Nevada, Texas, United States",
   "metaobject_handle": "review-aeed1554-65cc-4b38-b67b-f1498b9f342f"
 },
 {
   "title": "Spray Works",
   "body": "Nothing over the top and its gets the job done.",
   "rating": 5,
   "review_date": "2023-04-16 20:40:02 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Tamba Tongu",
   "reviewer_email": "tambatongue@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "76.169.65.24",
   "location": "Los Angeles, California, United States",
   "metaobject_handle": "review-30d65239-bfeb-4619-b0aa-9008b07c4100"
 },
 {
   "title": "Edge Spray",
   "body": "I absolutely love this shirt. When I got it I, no joke, wore it for four days straight. It feels so comfortable and airy. It feels great to wear for lifting. Love this product.",
   "rating": 5,
   "review_date": "2023-04-25 22:57:04 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Josh Weyerhaeuser",
   "reviewer_email": "joshuaweyerhaeuser@gmail.com",
   "product_id": 7579537309848,
   "product_handle": "edge-vintage-crewneck-tee",
   "reply": "Wow, so glad to hear this. We totally geeked out on the material to make them look + feel like a vintage shirt you've had for years, while feeling fresh and clean. Enjoy!",
   "reply_date": "2023-08-04 19:28:50 UTC",
   "picture_urls": "",
   "ip_address": "134.139.201.17",
   "location": "Long Beach, California, United States",
   "metaobject_handle": "review-31b66e3e-552f-464c-91b8-fd79df69d35f"
 },
 {
   "title": "",
   "body": "Shoe Sole Grip Spray",
   "rating": 5,
   "review_date": "2023-05-20 16:51:10 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Vivie Tims",
   "reviewer_email": "vivietims072@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-d77067fa-076d-4548-8a45-1d6d3364f8e7"
 },
 {
   "title": "Love it",
   "body": "Very good quality and sticks very well to surfaces",
   "rating": 5,
   "review_date": "2023-05-25 12:19:41 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Vivie Tims",
   "reviewer_email": "vivietims072@gmail.com",
   "product_id": 7579530559640,
   "product_handle": "stickers",
   "reply": "We love to hear it!",
   "reply_date": "2023-08-04 19:29:49 UTC",
   "picture_urls": "",
   "ip_address": "104.58.145.226",
   "location": "Mobile, Alabama, United States",
   "metaobject_handle": "review-e0b73a72-0b38-49e3-8980-6bd0e18f62da"
 },
 {
   "title": "Great stuff",
   "body": "Very impressive stuff.  Keeps the rubber of your shoes soft and sticky.  I would recommend.",
   "rating": 5,
   "review_date": "2023-07-02 16:45:12 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Ryan Cueni",
   "reviewer_email": "iroscoi@yahoo.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "40.136.120.114",
   "location": "Ashtabula, Ohio, United States",
   "metaobject_handle": "review-eb599a61-0fa5-42c2-ac07-0b5e80a86ae2"
 },
 {
   "title": "Getting better traction while fencing",
   "body": "I have recently started using Edge spray on my fencing shoes for safety reasons. The spray applied to the shoes sole ensured non-slippery fencing and better traction on the strip. Highly recommend it to any fencer who competes.",
   "rating": 5,
   "review_date": "2023-07-06 06:27:19 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Oleg Rusanov",
   "reviewer_email": "ovr_1973@yahoo.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "Awesome to hear. Thank you for taking the time to fill out a review, Oleg!",
   "reply_date": "2023-08-04 19:26:16 UTC",
   "picture_urls": "",
   "ip_address": "70.163.118.56",
   "location": "Phoenix, Arizona, United States",
   "metaobject_handle": "review-48dc64bf-48cc-4b2b-a862-eb027f444ba1"
 },
 {
   "title": "We Are Sticking With Edge!",
   "body": "This has been awesome for our fencing club. We fence on some slicker gym floors and this gives us the confidence and consistency we need. Thank you Zach!\nlowcountry fencers HHI • SC",
   "rating": 5,
   "review_date": "2023-07-12 19:26:00 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Patricia Wilkens",
   "reviewer_email": "wilkenspw@aol.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "We're very happy to hear that EDGE helped you grip the floor better despite the slick conditions. This is exactly why we do what we do. If anything else comes up, feel free to email me: zach@edgespray.com",
   "reply_date": "2023-08-04 19:16:53 UTC",
   "picture_urls": "",
   "ip_address": "173.207.193.46",
   "location": "Hilton Head Island, South Carolina, United States",
   "metaobject_handle": "review-7658792c-6ded-4dc9-836d-752cb542e739"
 },
 {
   "title": "ELITE!",
   "body": "Works like a dream! I'm 100% buying more as SOON as I get low. This is a must at every gym for the rest of my existence. Helps tremendously on bad courts and makes clean court experiences even better. Maybe my best purchase this year. No lie. Don't hesitate. Buy yours NOW!",
   "rating": 5,
   "review_date": "2023-08-03 20:41:10 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Del Von Lott Jr",
   "reviewer_email": "cuseboy211@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "We're so glad to hear this, thanks for taking the time to let us know! If anything else comes up, feel free to email me directly: zach@edgespray.com.",
   "reply_date": "2023-08-04 19:25:40 UTC",
   "picture_urls": "",
   "ip_address": "99.90.19.182",
   "location": "Midwest City, Oklahoma, United States",
   "metaobject_handle": "review-c49841ff-cce4-41af-a69a-8a5b06355318"
 },
 {
   "title": "",
   "body": "This stuff is amazing and truly a game changer for athletes, especially basketball players. We had been using grip spritz in my program, which is solid, but this is next level. Not only is it the most effective grip spray/grip product we have ever used, it is the easiest to use....no mat, no need to dry with a towel after applying, etc. You simply spray the bottom of each shoe 2-3 times, stomp each foot on the court/surface a few times, and BOOM, grip magic!",
   "rating": 5,
   "review_date": "2023-08-30 00:00:00 UTC",
   "source": "direct",
   "curated": "ok",
   "reviewer_name": "Eric Bullis",
   "reviewer_email": "bullis@campwildwood.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "Thanks Eric, we're always happy to hear positive feedback about our formula's drying time! We spent a *ton* of time in the lab to get it right and it's feedback like this that makes it all feel worth it. If anything else comes to mind, don't hesitate to email me at zach@edgespray.com.",
   "reply_date": "2023-09-01 17:51:57 UTC",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-9a4e9827-5866-4e38-8771-049f561c711b"
 },
 {
   "title": "",
   "body": "Great product",
   "rating": 5,
   "review_date": "2023-11-09 12:51:17 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Bernard Bowen",
   "reviewer_email": "bernardbowen825@gmail.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "174.198.6.215",
   "location": "Philadelphia, Pennsylvania, United States",
   "metaobject_handle": "review-57284e75-dbbe-4d31-8a27-0f86d874377e"
 },
 {
   "title": "Ari's Review",
   "body": "I love using EDGE spray for my sport (fencing). I got an order of the wipes as well, and have enjoyed those! I prefer the spray, but that's just me. Definitely worth a try for anyone who plays an indoor court sport.",
   "rating": 5,
   "review_date": "2023-11-19 03:00:56 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Ariel Simmons",
   "reviewer_email": "arieljsimmons@gmail.com",
   "product_id": 7736772952216,
   "product_handle": "edge-wipes-sample",
   "reply": "Thanks for sharing your experience, Ari! And I’m glad to hear that you’re getting use out of both the spray and the wipes!",
   "reply_date": "2023-11-25 22:39:37 UTC",
   "picture_urls": "",
   "ip_address": "74.142.216.242",
   "location": "Cleveland, Ohio, United States",
   "metaobject_handle": "review-013eae7a-d51f-4037-af5d-75e8e09d2c32"
 },
 {
   "title": "Game changer for middle school gyms",
   "body": "This stuff works! Middle school gyms are notoriously awful leaving basketball players sliding all over. This stuff is a game changer even on dusty/dirty MS courts.",
   "rating": 5,
   "review_date": "2023-11-21 13:04:13 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Shelly Hinz",
   "reviewer_email": "hinzshelly@gmail.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "Thanks Shelly! Middle school courts are a nuisance at best, and a liability at worst. I'm glad we could help out!",
   "reply_date": "2023-11-21 20:31:45 UTC",
   "picture_urls": "",
   "ip_address": "216.51.245.168",
   "location": "Maquoketa, Iowa, United States",
   "metaobject_handle": "review-b2c43df7-6f29-40f7-a4ec-a1589ae00faf"
 },
 {
   "title": "",
   "body": "The spray has helped provide greatest grab for my son’s shoes on the basketball court.",
   "rating": 5,
   "review_date": "2023-11-27 19:23:29 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Caleb Smith",
   "reviewer_email": "caleb_s51@hotmail.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "184.151.190.146",
   "location": "Toronto, Ontario, Canada",
   "metaobject_handle": "review-92d2dc29-717f-420c-bd9e-1060af8ee148"
 },
 {
   "title": "Kids love it",
   "body": "My kids love the edge sneaker grip . They say it helps playing basketball so much",
   "rating": 5,
   "review_date": "2023-11-29 15:05:35 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Charlene Thomas",
   "reviewer_email": "charct81@gmail.com",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "68.199.18.122",
   "location": "East Hampton, New York, United States",
   "metaobject_handle": "review-eae7a290-6654-4d32-9ea7-305fc20b65e4"
 },
 {
   "title": "",
   "body": "Works well. The performance might vary depending on the court cleaness but the spray it self provide extra but to the court. Recommended!",
   "rating": 5,
   "review_date": "2023-04-03 17:32:39 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Sunghoon Lee",
   "reviewer_email": "iamsunghoonlee@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-12099108-341b69c7-52ff-4146-9bad-29bad740189f"
 },
 {
   "title": "",
   "body": "I think it doesn’t really make a difference it just picks up more dust. And to small of a bottle",
   "rating": 3,
   "review_date": "2023-05-08 22:59:50 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "PJ MacGregorV",
   "reviewer_email": "pjmacgregorfive@icloud.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-13124406-73dd4312-9ae1-4b09-975c-53be447a292f"
 },
 {
   "title": "",
   "body": "So far it’s awesome. I used it one time for a few hours on Air Max Uptempo 97’s on a pretty dirty wood court and my traction was much better.",
   "rating": 5,
   "review_date": "2023-09-25 16:11:18 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Robert Medina",
   "reviewer_email": "dreu-77@hotmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-37658316-8d054580-5d2d-4b72-a848-c8303fc30631"
 },
 {
   "title": "",
   "body": "This stuff is legit.  Works on the dirtiest, dustiest middle school courts.",
   "rating": 5,
   "review_date": "2023-11-23 21:17:40 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Shelly Hinz",
   "reviewer_email": "hinzshelly@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-53973786-cf4ddc31-cecb-4201-b506-f34f7ba8dec4"
 },
 {
   "title": "",
   "body": "Helpful! Thanks!",
   "rating": 5,
   "review_date": "2023-11-29 00:06:19 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Amanda Fox",
   "reviewer_email": "alover76@yahoo.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-54903301-6b8ca4ca-4c0f-45d3-989e-8fc6c47e31bd"
 },
 {
   "title": "The team loves it!",
   "body": "My son took his bottle of Edge to basketball practice and said everyone wanted to use it.  It's now part of our basketball bag for all games!   Some of these basketball floors have traction issues even for new shoes so this is great to have on hand!",
   "rating": 5,
   "review_date": "2023-12-01 15:25:14 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Caren Drinkard",
   "reviewer_email": "gripper28@yahoo.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "That's amazing to hear that EDGE was in high demand! So glad we can help your son and his team with the traction issues on those floors!",
   "reply_date": "2023-12-08 16:14:22 UTC",
   "picture_urls": "",
   "ip_address": "69.140.144.178",
   "location": "Charlotte Hall, Maryland, United States",
   "metaobject_handle": "review-cb744932-4b74-4a4c-8ba0-258dc710bcac"
 },
 {
   "title": "",
   "body": "Love the bottle and love the grip it provides.",
   "rating": 5,
   "review_date": "2023-12-08 05:37:24 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Justin Naab",
   "reviewer_email": "jnaab@naabtrade.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "107.9.211.81",
   "location": "Newburgh, Indiana, United States",
   "metaobject_handle": "review-32328f73-24f6-48cf-80fd-0931cd8725b0"
 },
 {
   "title": "It Really Works!",
   "body": "Just got this stuff. WOW. It really works. Where I live courts are terrible in the winter with all the salt and dust. I no longer have to worry about thwe poor court conditions now that I'm using Edge!!. A+",
   "rating": 5,
   "review_date": "2023-12-13 01:10:42 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Adrian Hall",
   "reviewer_email": "jeff@empirelocates.com",
   "product_id": 7736772952216,
   "product_handle": "edge-wipes-sample",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "99.83.63.143",
   "location": "Louisville, Kentucky, United States",
   "metaobject_handle": "review-6b64a80e-75d5-4b2b-a067-0c21d441fbb9"
 },
 {
   "title": "",
   "body": "Doesn’t seem to work as well as the video makes it seem. Sprayed on soles of sneakers and didn’t really provide any additional traction.",
   "rating": 1,
   "review_date": "2023-12-14 05:21:25 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Kristen Hanson",
   "reviewer_email": "jerseygrl884@yahoo.com",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "Hey Kristen, \n\nI'm so sorry your experience didn't meet expectations! I tried reaching out a few times to learn more about your experience, but I haven’t heard back from you and I see you left 2 separate reviews back to back.\n\nThere are lots of factors that influence each experience, such as: sneaker outsole material, court conditions, and how long you allow the formula to soak into the rubber, etc. and I can help you get the most out of your purchase.\n\nI take the customer experience very seriously, if you can please reach out! My email is zach@ edgespray .com and I can also send you my cell # if that is easier. \n\nBest,\nZach",
   "reply_date": "2024-01-13 21:54:34 UTC",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-68637879-5b92bba5-3a9f-4a57-b9ca-8d86c07cca5c"
 },
 {
   "title": "",
   "body": "Didn’t seem to make any difference.",
   "rating": 1,
   "review_date": "2023-12-14 05:21:58 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Kristen Hanson",
   "reviewer_email": "jerseygrl884@yahoo.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-68637952-cf530c6b-d8b5-45f5-b330-08d281aff09e"
 },
 {
   "title": "Gift for son",
   "body": "My teen asked for this for Christmas and I’m sure he’s going to be psyched to have a bottle of his own for his next game. Also Zach provided the most amazing customer service any consumer could ask for! ",
   "rating": 5,
   "review_date": "2023-12-22 01:57:54 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Lexi Forrest",
   "reviewer_email": "strykersmomma85@gmail.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "This is great to hear! Feel free to contact me anytime you need anything.\n\nMerry Christmas to you and your family!",
   "reply_date": "2023-12-25 22:57:25 UTC",
   "picture_urls": "",
   "ip_address": "174.168.2.195",
   "location": "Bethel, Connecticut, United States",
   "metaobject_handle": "review-954b7987-1160-43c0-867e-95465fde711e"
 },
 {
   "title": "IT WORKS",
   "body": "My kid said he has great traction and no longer slips on his school’s court (which desperately needs to be waxed).",
   "rating": 5,
   "review_date": "2024-01-05 02:13:16 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Jodie Farrow",
   "reviewer_email": "jodie.farrow@yahoo.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "73.226.42.86",
   "location": "Camden, New Jersey, United States",
   "metaobject_handle": "review-b282871a-3c2d-4b05-99be-97a320fde4b2"
 },
 {
   "title": "",
   "body": "Works well, good grip, cuts through dust",
   "rating": 5,
   "review_date": "2024-01-09 20:16:25 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Jaden Chen",
   "reviewer_email": "jadenchen1213@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-111240793-bb4b9688-a3db-443d-962e-9842dba45df8"
 },
 {
   "title": "Pretty dope product!",
   "body": "I tried this out the other day during my volleyball practice, and I was confused at first because i needed to let it dry for a second. But right when I hit the court, the grip was insane! I actually really enjoy this product!",
   "rating": 4,
   "review_date": "2024-01-13 17:38:07 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "brooke whitlock",
   "reviewer_email": "brookewhitlock5@gmail.com",
   "product_id": 7736772952216,
   "product_handle": "edge-wipes-sample",
   "reply": "Thank you for sharing your feedback, Brooke! You're absolutely right, the formula needs about 15 seconds on average to soak into the rubber outsole, before kicking your sneakers against the floor to lock in the grip.\n\nI'm so glad you're getting use out of the product!",
   "reply_date": "2024-01-19 20:14:58 UTC",
   "picture_urls": "",
   "ip_address": "139.60.13.108",
   "location": "Ogden, Utah, United States",
   "metaobject_handle": "review-3609ce57-dca9-4483-a0c2-f3322d55f224"
 },
 {
   "title": "Edge has made a huge difference for me. Love it!!!",
   "body": "Hi. Im a fencer and this product has made a huge difference for me. \nI represent Puerto Rico and I noticed when I fenced there I was slipping a lot. My thought is that because of the humidity and fencing in open air made the strips slippery. I started using edge and I hardly ever slip anymore. I now use it at every tournament because slipping could mean an injury so if using edge keeps me from getting injured than Im all in. Thanks Edge from Gabi Hwang",
   "rating": 5,
   "review_date": "2024-01-20 09:11:53 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Jamarys Hwang",
   "reviewer_email": "jamarysvaz@yahoo.com",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "Hi Gabi, thank you for taking the time to leave a review for our Sneaker Grip Bundles. I am so glad to hear that our product has made a huge difference for you in your fencing competitions. I understand the importance of having a secure grip on the strips, and we are happy that our product has helped you with that. Thank you for choosing EDGE and we wish you all the best in representing Puerto Rico. Keep on fencing!",
   "reply_date": "2024-02-08 23:08:58 UTC",
   "picture_urls": "https://s3.amazonaws.com/me.judge.review-images/edge-traction-spray/1705767711__img_5674__original.jpeg",
   "ip_address": "174.197.74.93",
   "location": "Dallas, Texas, United States",
   "metaobject_handle": "review-366ede25-3473-43f1-9909-7693f2d6f2c2"
 },
 {
   "title": "Squeak! Squeak!",
   "body": "This product is sensational, my shoes are able to perform on the dustiest basketball courts which helps since most players now have a stop & go playing style, I’m back to bringing the clamps! Thank you.",
   "rating": 5,
   "review_date": "2024-01-26 18:21:53 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Tyshan Jones",
   "reviewer_email": "jones90la@yahoo.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "Thank you for your glowing review of our Sneaker Sole Grip Spray! We're thrilled to hear that it's helping you dominate on the defense, even on the dustiest of surfaces. Keep bringing the clamps and thank you for choosing our product!",
   "reply_date": "2024-02-08 23:25:54 UTC",
   "picture_urls": "",
   "ip_address": "104.28.85.132",
   "location": "Los Angeles, California, United States",
   "metaobject_handle": "review-39ef852d-028c-4849-9273-032e15a66d06"
 },
 {
   "title": "Great product",
   "body": "Great product and customer service even got free wipes for being in the military which is always nice thank you",
   "rating": 5,
   "review_date": "2024-01-28 04:51:35 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Nathaniel McCampbell",
   "reviewer_email": "nathanmccampbell7@gmail.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "Thank you for your review, Nathaniel! It's my pleasure to support our military members and I hope the wipes come in handy for you. Thank you for your service!",
   "reply_date": "2024-02-08 23:06:58 UTC",
   "picture_urls": "",
   "ip_address": "184.188.64.222",
   "location": "Oceanside, California, United States",
   "metaobject_handle": "review-3cc38f11-0d2b-47d3-a263-292acbcd8f75"
 },
 {
   "title": "Great grip, Great CS!",
   "body": "Bought this because my son plays in a league with suboptimal court grip and it really helped him stand out amongst others sliding around. Nothing worse when trying to make a move to the basket while slipping and sliding on the floor. Definitely recommend for anyone trying to gain an edge when courts aren't newly resurfaced. \n\nAlso, absolute great customer service. I emailed Edge asking how long it would take for the grip spray to reach me since I needed it a bit sooner than I had anticipated for my son's game and they upgraded the shipping as a huge favor! My son won his game!!! Thanks Zach!",
   "rating": 5,
   "review_date": "2024-02-07 22:54:57 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Eduard Maldur",
   "reviewer_email": "emaldur@msn.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "Hey Ed! I am so happy to hear that our products helped your son stand out on the court. We understand how frustrating it can be to slip and slide while trying to make a move. Thank you for recommending it to others who may also be dealing with suboptimal court grip. I'm also thrilled to hear that your son won his game - the competition is what we do it for! Thank you for choosing our product and for sharing your experience!\n\n- Zach",
   "reply_date": "2024-02-08 23:11:47 UTC",
   "picture_urls": "",
   "ip_address": "70.93.170.228",
   "location": "Woodland Hills, California, United States",
   "metaobject_handle": "review-5527e5c2-83ba-4022-8b69-f11acad2a7a4"
 },
 {
   "title": "Edge spray X Chula Vista Suns",
   "body": "Game changer look forward to partnering up with edge spray",
   "rating": 5,
   "review_date": "2024-02-10 15:57:05 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Eric Brown",
   "reviewer_email": "chulavistasuns@yahoo.com",
   "product_id": 7736772952216,
   "product_handle": "edge-wipes-sample",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "172.56.188.172",
   "location": "Westminster, California, United States",
   "metaobject_handle": "review-9eed7509-194e-4b9a-9fe6-e078c8276c61"
 },
 {
   "title": "",
   "body": "The entire basketball team says this spray works the best!",
   "rating": 5,
   "review_date": "2024-02-15 21:54:36 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Jessica Knutson",
   "reviewer_email": "jessicaknutson23@yahoo.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "184.83.187.113",
   "location": "Sioux Falls, South Dakota, United States",
   "metaobject_handle": "review-6aecd80a-ac57-4b16-bab9-239d5d6dea7d"
 },
 {
   "title": "",
   "body": "My daughter loves it! Will be purchasing more . The only thing I will have to say is that’s a little pricey so we had to sparingly use it. If it was a little bit cheaper, we would use them more often thus would purchase more faster.",
   "rating": 4,
   "review_date": "2024-03-04 20:53:36 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Benjamin Nguyen",
   "reviewer_email": "johndoe40230@gmail.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-122250067-e3590a63-7877-4ff0-b8a8-9c35eeaf9bd5"
 },
 {
   "title": "Hidden Gems Showcase",
   "body": "I heard nothing but positive reviews from the players all day about how great the product was and the amount of traction that it produced.",
   "rating": 5,
   "review_date": "2024-03-28 13:00:15 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Randford Brooks",
   "reviewer_email": "info@mttsathletics.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "64.251.48.206",
   "location": "Waterbury, Connecticut, United States",
   "metaobject_handle": "review-fc32c50e-7878-4014-999c-530d61d0a4b6"
 },
 {
   "title": "Significant grip",
   "body": "My son is a basketball player and likes the wipes a lot. He says they help the grip on his shoes significantly.",
   "rating": 5,
   "review_date": "2024-02-17 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Brooke Shipbaugh",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-64b666eb-0e5d-4131-af43-96f4fd504d70"
 },
 {
   "title": "Feels great!",
   "body": "Product feels great! Just tried it out and filmed some dunks with it",
   "rating": 5,
   "review_date": "2023-12-21 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Lonnie Reed-Perez",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-5189cd3b-6e36-4d2e-8072-814775f65f3e"
 },
 {
   "title": "Teammates love it too",
   "body": "I really like the product I could definitely feel a difference. My teammates are asking me to not forget to bring the spray",
   "rating": 5,
   "review_date": "2023-11-22 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Romancomvalius",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-ce9c18ff-c8b0-4162-b69c-bd206bcb480a"
 },
 {
   "title": "Works",
   "body": "They actually work very good!",
   "rating": 5,
   "review_date": "2024-02-15 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Logan Ste",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-641111f1-50b1-4a55-8c73-840b72c0e25e"
 },
 {
   "title": "Coach",
   "body": "We love EDGE! My husband is a CYO Basketball Coach for my son’s 6th grade team St Rose. He’s been using the spray on all the boys sneakers throughout the season. This has been a great help for the boys this season. It definitely helps give them more traction. You can see we keep buying bottles!! lol",
   "rating": 5,
   "review_date": "2024-02-24 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Debby Scro",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-1809ebb6-64f7-4f72-aa90-fb4bfeaa1b05"
 },
 {
   "title": "Great product",
   "body": "I’m a retired Marine and now assistant with a Volleyball team. My daughter says it’s a great product. I will recommend this to our team, for sure.",
   "rating": 5,
   "review_date": "2024-02-15 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Rob Hunter",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-3fea81d6-de74-4742-948a-01f74e8bcd48"
 },
 {
   "title": "Strong effect",
   "body": "Really like the product. Definitely can feel the effects strongly for the first 5-10 minutes (with the spray). Used it in game a few times too",
   "rating": 4,
   "review_date": "2023-11-15 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Caleb Williams",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-fe659b36-f550-40f9-9168-6666631b36c6"
 },
 {
   "title": "Works for sure",
   "body": "I got the package yesterday right before practice and used one wipe! They work for sure. My shoes are starting to get slippery so they came just in time. The grip was good all practice and my team scrimmaged so it got the real test.",
   "rating": 5,
   "review_date": "2023-11-09 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Austin Abrams",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-678bc2a3-8472-4421-9ca2-62407d9e9236"
 },
 {
   "title": "Really works",
   "body": "Love the product. The traction really works.",
   "rating": 5,
   "review_date": "2024-03-13 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Adarsh Subra",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-c58b9e98-7cfe-4d99-86f9-c73f8a3644d0"
 },
 {
   "title": "Works",
   "body": "It’s amazing!",
   "rating": 5,
   "review_date": "2023-12-14 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "WYB",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-a3433fa4-b928-4f35-8bd1-93d494687009"
 },
 {
   "title": "Full control",
   "body": "I love the product.. got full control now inside the court",
   "rating": 5,
   "review_date": "2023-11-24 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "dredzkiiisdname",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-84ed1733-f157-4b31-9bff-ccd96815c5f3"
 },
 {
   "title": "Win",
   "body": "Our players enjoy it!",
   "rating": 5,
   "review_date": "2023-11-10 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Chris Diaz",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-92828794-44e2-446a-aacd-e1097f2ead7f"
 },
 {
   "title": "Nothing else is close",
   "body": "EDGE is the best! Nothing else is close",
   "rating": 5,
   "review_date": "2023-09-09 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "floridafan1976",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-860338b1-ff57-408f-b476-7d699be4284f"
 },
 {
   "title": "Can really tell the difference",
   "body": "It’s great, I can really tell the difference between when I’m using it or not! It does what it claims really well! My players have all liked it too. The only thing is that I haven’t gotten a chance to personally use it on a super beat up or unkept floor yet, so I don’t have experience with that. I’ve been on decent to great hardwood and good sportcourt. But it’s definitely elevated my traction on those surfaces. I’ve actually had a couple of my players ask me if I had it on my a certain days if they didn’t like how their shoes were feeling.",
   "rating": 5,
   "review_date": "2023-08-14 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Ethan Khoza",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-c9270ce0-4854-49ee-8dff-aa0edf0b1be1"
 },
 {
   "title": "Works great",
   "body": "This thing is great!",
   "rating": 5,
   "review_date": "2023-08-22 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "George Davey",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-55cf2de2-a6ab-4135-a280-c7c7339150e3"
 },
 {
   "title": "Love it",
   "body": "I LOVEEEEE the spray. It works great! My teammates also wanna start using it",
   "rating": 5,
   "review_date": "2023-08-24 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Jada Sabon",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-76b9d9d6-c2b7-4857-b647-65a0f8950547"
 },
 {
   "title": "No more slipping",
   "body": "Had a dude slipping all game the other day and told him to tryout the spray. Tried it and was sticking the rest the day.",
   "rating": 5,
   "review_date": "2023-10-25 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Jordan Boyd",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-60fd7658-e60f-4d36-82c4-5741215204d1"
 },
 {
   "title": "Passes the test",
   "body": "I’ve had some people test it out with myself included and there’s really good feedback",
   "rating": 4,
   "review_date": "2023-07-02 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Hoopwith’em",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-572c5775-e98b-4c0e-a3ab-757ed05ec921"
 },
 {
   "title": "Amazing",
   "body": "My trainer let me use some of his and it was amazing",
   "rating": 5,
   "review_date": "2023-07-30 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "1kamadou",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-2086a33d-1a30-42e2-97ea-0596e8ec5626"
 },
 {
   "title": "Works great",
   "body": "Been loving the spray this off-season man! Works great, bottle looks great. Love it",
   "rating": 5,
   "review_date": "2023-05-04 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Connor Printz",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-0d89026e-3a2b-41f1-8906-2d37c104ffae"
 },
 {
   "title": "Helped a ton",
   "body": "I was able to use the spray quite a lot over the last week of practices. Our AC has been out in the gym, so it helped a ton with the grip on the floors, and I loved it!",
   "rating": 5,
   "review_date": "2023-07-20 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Drew Thelwell",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-6db725b0-2d07-48e5-ae33-5fa6547a5517"
 },
 {
   "title": "Great",
   "body": "Got two bottles left from last deal. Nothing but great reviews!",
   "rating": 5,
   "review_date": "2023-07-15 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Grit and Grind Hoops",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-d896c05c-24b1-4953-9d7b-381a68813767"
 },
 {
   "title": "Helped with grip",
   "body": "I liked it. Helped with good grip on the court",
   "rating": 4,
   "review_date": "2023-06-14 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Bryce",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-91215d1d-6e26-4b69-97ab-068d4303a85f"
 },
 {
   "title": "Flat out works",
   "body": "I hoop in KD’s so when the floor is wet or starts getting sweaty, having low tops that slip can be detrimental. Let’s just say yesterday, I didn’t have any issues and kept the spray with me.",
   "rating": 5,
   "review_date": "2023-04-24 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Davion Robinson",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-74453255-2922-4a9d-9ec2-cab2d5a09dd3"
 },
 {
   "title": "Good review",
   "body": "I used it on the court at home! It was great",
   "rating": 5,
   "review_date": "2023-09-18 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Chase Adams",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-abb04734-f92b-4f1e-b081-b84da54348c0"
 },
 {
   "title": "Really like it",
   "body": "I really like it, EDGE works very well on the volleyball court!",
   "rating": 5,
   "review_date": "2023-02-19 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Cal Krohn",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-519da695-a0b9-4960-bdca-4d1719fd0775"
 },
 {
   "title": "Definitely noticeable",
   "body": "Honestly I was good with it for a while and definitely noticeable because I purposely went somewhere slippery",
   "rating": 5,
   "review_date": "2023-04-13 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Larry Moreno",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-438c15da-dcc2-4d29-9caf-d9db77c2c488"
 },
 {
   "title": "Can definitely feel the difference",
   "body": "Really like the spray! You definitely can feel a difference first few minutes for sure! Excited to keep using it and see how it spans over a full day of workout & camp sessions!",
   "rating": 5,
   "review_date": "2023-06-11 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Jeremy Hays",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-16e1ed19-52dc-41da-8bb2-614a152942c3"
 },
 {
   "title": "Better than anything else I've tried",
   "body": "EDGE is absolutely amazing! 2-3 pumps per shoe and I grip the whole game 40 min! Dropped 33 points and 20 rebounds. Love it I can say better than the competition on the market",
   "rating": 5,
   "review_date": "2023-05-28 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Lorenzo Ervin",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-62c199e2-8963-4e10-9fb0-738e7aa910e7"
 },
 {
   "title": "Works",
   "body": "it works, rlly appreciate u EDGE",
   "rating": 5,
   "review_date": "2023-03-22 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Adan Diggs",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-04441629-235f-440b-8ee8-987443c62266"
 },
 {
   "title": "So much more traction",
   "body": "I love the product!! It gives me that stop and go I need! My shoes have so much more traction",
   "rating": 5,
   "review_date": "2023-02-06 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Michael Barber",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-de1f1774-79ff-47fb-8dee-2abb64337a6b"
 },
 {
   "title": "Please expand to Europe",
   "body": "I play basketball over here in Monaco and I’m always slipping on courts all across Europe. I found your product review on YouTube and I decided to give it a try. Out of everything out there, you guys definitely stood out to me. The overall vibe of the brand was cool. Also the product itself looked durable and professional. I’ve only been able to use it a few times but it’s been amazing so far. Would love to hear about your expansion plans in Europe etc.",
   "rating": 5,
   "review_date": "2023-01-17 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Jordan Loyd",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-0c073eaa-eccc-41ef-9486-57fd50e2a28d"
 },
 {
   "title": "No product like it",
   "body": "Brother, it’s amazing. No product like it. You’re worth millions",
   "rating": 5,
   "review_date": "2023-05-03 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Brian",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-cd89964e-8a0f-49f1-b5c5-68a5aa8f33ee"
 },
 {
   "title": "People need to know about this",
   "body": "I love the grip on my shoes now … it helps me move freely & sharp. Thank you💪🏾‼️ Great product ‼️ people need to here more about this",
   "rating": 5,
   "review_date": "2023-03-02 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Daveonne Warfield",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-d0541b26-7bfa-4bfc-88a0-38385c20042a"
 },
 {
   "title": "Good product",
   "body": "the coaches from DeSoto high school said it's a good product, so I trust it",
   "rating": 5,
   "review_date": "2023-01-06 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Donny B.",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-94bffd84-00d4-4cc9-b2bb-a38c3a554b89"
 },
 {
   "title": "Better than Court Grip",
   "body": "I didn’t even clean the shoes or anything! I had walked a little bit and the shoes that been on a shelf for at least two months! It definitely shows! The last time I had a product similar was like back in 2011 Dwyane Wade had some kind of product that he was sponsoring to increase grip. I really liked it back then, but obviously that was a long time ago. This is by far the best",
   "rating": 5,
   "review_date": "2022-12-01 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Ricky",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-71c438c7-2ac4-4cd6-b838-24a4390df306"
 },
 {
   "title": "Amazing",
   "body": "it’s a amazing product",
   "rating": 5,
   "review_date": "2022-12-18 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Javier Daire",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-33bebdc6-19a5-430d-9ae7-247830965945"
 },
 {
   "title": "Firends are asking about it",
   "body": "My daughter is using this for indoor field hockey. I just had a mom reach out to me to ask about the product because my daughter has let some of the girls try her bottle.",
   "rating": 5,
   "review_date": "2023-01-24 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Tiffany Hilton",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-8bea9923-5e6b-4f3b-9907-23536dda390c"
 },
 {
   "title": "Helped",
   "body": "I tried it out a small bit yesterday and I think it helped a little bit - there are a number of factors to work against so the jury is still out on how much rubber revival can happen, but I’m hopeful",
   "rating": 4,
   "review_date": "2023-02-23 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Andrew Wittler",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-3d72931a-3909-4ff4-9758-90189a70cfc5"
 },
 {
   "title": "Doesn't get dirty like a sticky mat",
   "body": "It’s great! Definitely improves my grip. The duration of it could possibly be improved but it’s not much of a problem. But other than that it’s simple and easy! Personally, I think this is better cuz it doesn’t get dirty like a sticky mat and is not as big. But ig the one thing that a sticky mat may have an advantage in is the fact that all you have to do is step on it and step off",
   "rating": 4,
   "review_date": "2022-09-06 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Jaylen Wells",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-cad84a0e-3065-4005-a1da-e7b94c82f62d"
 },
 {
   "title": "Loving it",
   "body": "Tried out the product yesterday and loving it so far!! will continue to use it",
   "rating": 5,
   "review_date": "2022-10-24 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Tyler Leclerc",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-dd63840e-9187-461c-a2db-475a62a02a30"
 },
 {
   "title": "Immaculate!",
   "body": "Used it the last few hoop seshes and needless to say i LOVE IT! i tried it on some of the hoopin shoes that i thought did not have the best traction and after the spray they were immaculate!!!",
   "rating": 5,
   "review_date": "2023-01-15 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Parker Reese",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-2a066be9-def5-477c-b384-c4fe551f897f"
 },
 {
   "title": "Extra grip",
   "body": "I like how I get that extra bit of grip that I need in order to perform to the best of my ability",
   "rating": 5,
   "review_date": "2022-11-29 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Jacob Falko",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-84ebc289-266f-4be3-ac93-8e2b3ee5aaec"
 },
 {
   "title": "Son plays basketball, product seems to work well",
   "body": "My son is using it for his basketball games. I always see him wiping his shoes on the court with his hands so I thought this would be a better option. I think it’s good so far!",
   "rating": 4,
   "review_date": "2023-01-17 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Noelle Penna",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-5f2aa5b6-5a80-4443-8da3-f5c491706400"
 },
 {
   "title": "Amazing",
   "body": "This product is amazing",
   "rating": 5,
   "review_date": "2022-04-13 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Lexi Barros",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-091cbb5c-9c27-473c-a02a-3202396819e7"
 },
 {
   "title": "Incredible grip",
   "body": "I just wanted to say the spray as been working great I’ve gotten two people to stumble from How good the grip has been lol",
   "rating": 5,
   "review_date": "2022-08-29 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Mark Winston",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-cee88397-2a16-4ef7-b942-109a7fe6b9c1"
 },
 {
   "title": "Incredible",
   "body": "I firmly believe in your product. I've tried it out, and it is incredible",
   "rating": 5,
   "review_date": "2022-03-22 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Christopher Hoang Anh Nguyen",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-439d9832-e46e-40c0-a442-7504748d29cf"
 },
 {
   "title": "Grip",
   "body": "Bro that EDGE grip is tough brooo",
   "rating": 5,
   "review_date": "2022-02-17 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "AtmBucketzzz",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-5acb96f5-964a-462c-9b1d-f336d6d289d9"
 },
 {
   "title": "Works the best",
   "body": "My twin boys use it for High School Basketball. I bought three different brands of this type of spray. They said EDGE is the only one that actually works. Of course it is the most expensive one. A lot of their teammates have started to use it, so it ran out quickly. I told them to tell their buddies to buy their own. Ha! They like the way it works. My only complaint would be price point.",
   "rating": 4,
   "review_date": "2023-01-24 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Jessica Knutson",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-26433204-7b50-403d-8753-412c9becbf36"
 },
 {
   "title": "Use it daily",
   "body": "Your product is great and I use it daily",
   "rating": 5,
   "review_date": "2023-01-31 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Kennady McQueen",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-37f2011d-e92b-43a9-994f-1ba94f328088"
 },
 {
   "title": "Works really really well",
   "body": "Works really well, had a slippery court a couple of weeks ago and it made my shoes feel brand new",
   "rating": 5,
   "review_date": "2022-06-26 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Jacob De Armas",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-559062e5-ae44-4441-b5bd-577511112c97"
 },
 {
   "title": "Stop on a dime",
   "body": "Tried it again indoor for the first time and it’s great bro! The way you can stop on a dime is incredible! Def gunna be using this product from now on",
   "rating": 5,
   "review_date": "2022-04-06 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Derek West",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-403aeb9f-0304-4a3e-8172-89fc8858e9f3"
 },
 {
   "title": "STELLAR PRODUCT!",
   "body": "Last weekend I shared my Edge wipes with my teammates as we got ready to compete in a tournament.  The Edge wipes had my team stopping on a dime and they made transitioning from offense to defense much easier!  Thank you Edge brand for creating a product that complements athlete’s game!",
   "rating": 5,
   "review_date": "2024-05-22 00:06:29 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Jaylen Williams",
   "reviewer_email": "officiallyjaywill@gmail.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "107.122.225.8",
   "location": "San Antonio, Texas, United States",
   "metaobject_handle": "review-f8310cfa-a75f-481f-9afd-bfc5a2f656f2"
 },
 {
   "title": "Edge Spray is fire!",
   "body": "Love this product. We have bought other grip spray products, but none have been so easy to use and worked the way Edge does! Definitely recommend!",
   "rating": 5,
   "review_date": "2024-06-04 21:23:07 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Jacquelyn King",
   "reviewer_email": "jakb2013@yahoo.com",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "Thank you for taking time to leave a review! We are thrilled to hear that you are loving our Grip Spray. We are committed to making the best grip products out there and I'm happy to hear that it worked better than others on the market.\n\nI appreciate your support and hope to continue providing you with top-notch products!",
   "reply_date": "2024-06-04 21:33:17 UTC",
   "picture_urls": "",
   "ip_address": "174.126.117.134",
   "location": "Prescott, Arizona, United States",
   "metaobject_handle": "review-b1a31b4b-ee76-47e9-8c4f-ace5060bfffa"
 },
 {
   "title": "Good product, grip is dependent on the actual condition of the floor",
   "body": "I used the wipes as directed and found immediate much better traction.  The effect lasts much longer on floors that have t least been swept recently.  On horrible floors the effects were short lived.  Still worth trying.  I’ll keep using them",
   "rating": 4,
   "review_date": "2024-06-07 22:29:53 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Philip Rubenstein",
   "reviewer_email": "par167@yahoo.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "Thank you for the feedback, Philip! You're right - on unusually dusty courts (much more than the typical YMCA or AAU courts), you'll need to use EDGE more often than normal. Our formula soaks directly into rubber, so the improvement in grip is actually coming from the rubber itself. The more dust or dirt that is on the court, the less the rubber can grip the court, no matter how grippy it is.\n\nOur Sneaker Grip Wipes have the added benefit of cleaning the dust off your sneaker outsoles while simultaneously modifying the chemistry of the rubber with our grip formula. We appreciate the feedback!",
   "reply_date": "2024-06-14 14:04:52 UTC",
   "picture_urls": "",
   "ip_address": "73.198.167.80",
   "location": "West Orange, New Jersey, United States",
   "metaobject_handle": "review-47741a0e-151f-42a0-8174-4b37af77e413"
 },
 {
   "title": "Exceptional product.  Better than anything on the market",
   "body": "Lasted the entire basketball game, could hear the shoes squeak in the stands.  Logan played great, he had so much confidence in his agility due to the traction from the Edge product.  29 points as a sophomore on varsity.",
   "rating": 5,
   "review_date": "2024-06-14 03:05:23 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Zac MISSLER",
   "reviewer_email": "zmissler@misslerhomes.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "75.141.164.74",
   "location": "Atascadero, California, United States",
   "metaobject_handle": "review-1ac3884f-b592-4d5d-8f7f-3865b966d708"
 },
 {
   "title": "Awesome",
   "body": "Product has been great to use. Highly recommend for elite athletes.",
   "rating": 5,
   "review_date": "2024-06-20 17:00:41 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Loren Jackson",
   "reviewer_email": "lorenjackson3@gmail.com",
   "product_id": 7736772952216,
   "product_handle": "edge-wipes-sample",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "104.28.57.243",
   "location": "Miami, Florida, United States",
   "metaobject_handle": "review-c0ea29d1-c51f-453d-a516-010c7af4fb86"
 },
 {
   "title": "B-ball Players Dream",
   "body": "I bought this for my son for Christmas and when he ran out he asked me to get him more.  You don't need to use too much of it and each usage lasts pretty long.",
   "rating": 5,
   "review_date": "2024-06-21 14:32:13 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Lori Carelle",
   "reviewer_email": "lori.carelle@gmail.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "I'm glad your son's 2oz bottle lasted from Christmas until June - that's exactly what we intended! We designed our EDGE® Spray bottles to be portable and small without needing to buy a new bottle every month.\n\nThank you for giving us this feedback!",
   "reply_date": "2024-06-21 15:22:52 UTC",
   "picture_urls": "",
   "ip_address": "50.248.80.45",
   "location": "Bridgeville, Pennsylvania, United States",
   "metaobject_handle": "review-6d767ac8-4b58-47fb-a62f-3e1efbb8fc50"
 },
 {
   "title": "Edge wipes",
   "body": "My boys really like the stuff.  They come to me asking me before games to prep their shoes.  It’s funny to watch the other players who don’t use edge sliding all over the floor.",
   "rating": 5,
   "review_date": "2024-06-26 01:56:18 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Ryan Cueni",
   "reviewer_email": "iroscoi@yahoo.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "71.79.146.163",
   "location": "Painesville, Ohio, United States",
   "metaobject_handle": "review-8885fb51-8c44-4c7c-bfef-2a5bd2a9137b"
 },
 {
   "title": "Edge grip wipes",
   "body": "They product actually works I’d use more of it for sure.",
   "rating": 5,
   "review_date": "2024-06-26 22:23:40 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "DJ Freeman",
   "reviewer_email": "superathlete6093@gmail.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "107.115.163.20",
   "location": "Midland, Texas, United States",
   "metaobject_handle": "review-48df1fae-e292-4ac4-ad03-f0316fa0a400"
 },
 {
   "title": "",
   "body": "Amazing product. Must have product for highschool gym floors. Even on a swept clean floor these still add so much better traction even with newer shoes only ever worn inside. 1.00 a wipe per game, worth it!",
   "rating": 5,
   "review_date": "2024-06-30 20:26:22 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Steve Darnell",
   "reviewer_email": "sdarnell2618@gmail.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-147043622-30e1e8b4-df4d-48a2-bdbd-376b45e4d931"
 },
 {
   "title": "",
   "body": "The whipes work GREAT!  They remove the debris on the underside of the shoes and increase traction.  I can't imagine fencing without them.",
   "rating": 5,
   "review_date": "2024-07-03 12:44:38 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "John Tomasi",
   "reviewer_email": "fencingengineer@gmail.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "174.207.230.233",
   "location": "Cincinnati, Ohio, United States",
   "metaobject_handle": "review-4648973a-dcc3-44ef-8cde-ed90b0447937"
 },
 {
   "title": "Great Product. Must Have.",
   "body": "Kept seeing my son with variable traction with new shoes depending on the court. Didn’t want him to get injured. Bought the wipes and he LOVES them. No need to unfold them as they work as directed. Even got his teammates wanting to know where he got them. Going to check out the spray as well. This is a must have!",
   "rating": 5,
   "review_date": "2024-07-07 17:18:58 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Erik Nelson",
   "reviewer_email": "ejnelson06@gmail.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "100.7.87.167",
   "location": "Moseley, Virginia, United States",
   "metaobject_handle": "review-b00adc42-31dc-4432-8479-d5084db84dc4"
 },
 {
   "title": "",
   "body": "'-'",
   "rating": 5,
   "review_date": "2024-07-09 22:34:12 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Glenn Marumoto",
   "reviewer_email": "marumoto.glenn@gmail.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "47.149.222.60",
   "location": "Long Beach, California, United States",
   "metaobject_handle": "review-696d5a1c-9e07-4c47-bbd7-0173da04ac39"
 },
 {
   "title": "Edge’s Sneaker Grip review",
   "body": "For the first time using this product it was great and it really helped with the grip on my shoes",
   "rating": 5,
   "review_date": "2024-07-12 19:17:57 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Carl Taylor",
   "reviewer_email": "carl.taylor615@gmail.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "172.56.219.234",
   "location": "Philadelphia, Pennsylvania, United States",
   "metaobject_handle": "review-b0a5ab9a-68f9-47fe-9f77-e3a0270efd74"
 },
 {
   "title": "Amazing product!",
   "body": "I didn’t realize how much of a difference Edge grip spray made until I tried it for myself. It gives you terrific traction that makes you feel like a better athlete! I play basketball in college and will definitely be using this product! 1000 % recommend!",
   "rating": 5,
   "review_date": "2024-07-23 13:20:51 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Grant Stubbs",
   "reviewer_email": "grant.stubbs0920@gmail.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "Thank you for taking the chance to test our product! Using it yourself is the best way to become a believer in the product and how much of a difference it can make. Thats why we offer the money-back guarantee so you can test it without any risk - we're very confident in the products we've developed!",
   "reply_date": "2024-07-24 02:05:03 UTC",
   "picture_urls": "",
   "ip_address": "172.56.226.122",
   "location": "Birmingham, Alabama, United States",
   "metaobject_handle": "review-e0bdb927-3a06-4adf-9121-b73d3ffdfb70"
 },
 {
   "title": "Very versatile product!",
   "body": "Even though I’m a track and field athlete this product works perfectly!",
   "rating": 5,
   "review_date": "2024-07-23 14:05:06 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Dewayne Johnson",
   "reviewer_email": "dcjohnson0112@gmail.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "98.227.93.120",
   "location": "Park Forest, Illinois, United States",
   "metaobject_handle": "review-68d0f0b4-253f-4f53-8209-11b19acc0a17"
 },
 {
   "title": "Best product",
   "body": "I love this product. As a basketball player I always struggle with my shoes being grippy as the season goes on. I just tried out these wipes and I couldn’t be happier. Unlike the grip boards these wipes take off the dirt on your shoes and actually make your shoes grippy. I can’t wait to continue to use edge and to use them during my season. I am so excited!",
   "rating": 5,
   "review_date": "2024-07-23 21:21:11 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Erika Lane",
   "reviewer_email": "erikalane24@gmail.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "184.61.44.46",
   "location": "Pequot Lakes, Minnesota, United States",
   "metaobject_handle": "review-974f722d-f941-40e2-b5b3-963371df54e4"
 },
 {
   "title": "D1 Athlete",
   "body": "I’m a D1 athlete and I tried these out for the first time on the volleyball court and they made a HUGE difference!",
   "rating": 5,
   "review_date": "2024-07-23 22:03:20 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Keyana Cruse",
   "reviewer_email": "k-cruse@wiu.edu",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "23.81.164.196",
   "location": "San Jose, California, United States",
   "metaobject_handle": "review-4c47b0e2-4492-4a1a-9ccb-ea226f5d6e9a"
 },
 {
   "title": "Game-Changing Grip",
   "body": "Slippery shoes have always been a major hindurance while playing on some basketball courts even at the D1 level. These give my shoes the extra traction I need especially on those courts that just seem to be too slippery. With one wipe, I can give both my shoes extra traction allowing me to cut better and safer.",
   "rating": 5,
   "review_date": "2024-07-23 22:26:49 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Sofie Lowis",
   "reviewer_email": "slowis@siue.edu",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "104.167.152.65",
   "location": "Edwardsville, Illinois, United States",
   "metaobject_handle": "review-42bb9f01-6fc7-4a76-b7ea-46234ece833b"
 },
 {
   "title": "Great product",
   "body": "I loved using this product. The floors I play on are pretty slippery and the wipes are amazing. Easy to use and an absolute must for athletes",
   "rating": 5,
   "review_date": "2024-07-23 23:02:05 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Teagan Thurman",
   "reviewer_email": "teagan1010@icloud.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "Sorry to hear that you deal with slippery floors, but I'm glad our Sneaker Grip Wipes have been helpful for you to counter that problem! Thanks for sharing your feedback, Teagan!",
   "reply_date": "2024-07-24 02:01:31 UTC",
   "picture_urls": "",
   "ip_address": "66.218.40.208",
   "location": "Tehachapi, California, United States",
   "metaobject_handle": "review-f3ce4c59-cd6d-42db-a442-e0f8a309f020"
 },
 {
   "title": "Sneaker Grip Wipes",
   "body": "Amazing product. I am a zumba instructor and recommend this product very much. My students and I were happy with results. After using them we felt secure on the floor while dancing (laminated floors)",
   "rating": 5,
   "review_date": "2024-07-28 20:33:05 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "selene Hinojosa",
   "reviewer_email": "selenehinojosa1981@gmail.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "172.56.81.149",
   "location": "Phoenix, Arizona, United States",
   "metaobject_handle": "review-e0c4c640-bce8-466e-9aea-3d043b9f42da"
 },
 {
   "title": "Product Works But Spray Bottle Clogged",
   "body": "I was unable to use the spray bottle on my footwear. The pump may be clogged. I had to unscrew the bottle and pour a small amount on a paper towel and then apply it to the bottom of my footwear. After it dried I can tell the difference when walking on tiled floors. It does help me to not slip.",
   "rating": 3,
   "review_date": "2024-07-28 23:53:16 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Marsha Jones-Harry",
   "reviewer_email": "marshaharry0118@yahoo.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "24.185.19.74",
   "location": "The Bronx, New York, United States",
   "metaobject_handle": "review-aae56edc-5ba6-4eb0-8a8e-c80656b5ea07"
 },
 {
   "title": "Very good!",
   "body": "The product is exactly what I want. Thank you very much!",
   "rating": 5,
   "review_date": "2024-07-29 18:08:11 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Toshinori Matsuyama",
   "reviewer_email": "tmatsuyama0227@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "68.179.135.124",
   "location": "Canton, Michigan, United States",
   "metaobject_handle": "review-69334a8f-5a44-4a84-a604-253338c783b4"
 },
 {
   "title": "Be a player with the Advant-EDGE",
   "body": "As soon as I put Edge on my sneakers and stepped on the court I noticed a difference right away - it was amazing! This really does work like it says it will. It was easy to use, quick and 100% miraculous. Be the one with the advant-Edge!",
   "rating": 5,
   "review_date": "2024-08-13 00:44:48 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Natalia Hassinger",
   "reviewer_email": "cabrel23@hotmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "69.142.212.58",
   "location": "Moorestown, New Jersey, United States",
   "metaobject_handle": "review-c0b83701-746d-4853-b7f0-28f5b26b775d"
 },
 {
   "title": "Best Product on the Market",
   "body": "Before I used and purchased Edge Wipes my shoe grip was around 4-5 out of 10. With them I feel like I’m at an 12!!!! It’s so simple to use and it works so fast. I’ll be a customer for a lifetime!",
   "rating": 5,
   "review_date": "2024-08-17 23:08:34 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Nate Lewis",
   "reviewer_email": "natel4492@gmail.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "Thank you for your review of our Sneaker Grip Wipes! We are thrilled to hear that you are happy with the improvement to your traction. We are committed to providing the best products on the market and we are grateful to have you as a lifelong customer!",
   "reply_date": "2024-09-03 16:17:58 UTC",
   "picture_urls": "",
   "ip_address": "47.230.97.15",
   "location": "Fort Lee, New Jersey, United States",
   "metaobject_handle": "review-7fe85e34-c4c5-4434-9c65-d612e818b279"
 },
 {
   "title": "Basketball players must USE",
   "body": "Great traction improvement!",
   "rating": 5,
   "review_date": "2024-08-21 17:01:41 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Zac MISSLER",
   "reviewer_email": "zmissler@misslerhomes.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "172.56.208.3",
   "location": "Las Vegas, Nevada, United States",
   "metaobject_handle": "review-c277926c-4de2-43d3-a166-7ba137716634"
 },
 {
   "title": "It really works!",
   "body": "Great Product",
   "rating": 5,
   "review_date": "2024-08-28 20:22:51 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Quincy Todd",
   "reviewer_email": "sonofgoldie@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "76.170.62.42",
   "location": "Los Angeles, California, United States",
   "metaobject_handle": "review-f93665b2-8072-4e51-9653-61b659a75ec0"
 },
 {
   "title": "Great!",
   "body": "100% recommend! Works for all shoes!",
   "rating": 5,
   "review_date": "2024-09-03 02:41:06 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Kendall Hicks",
   "reviewer_email": "kendall.hicks2056@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "104.28.32.195",
   "location": "Atlanta, Georgia, United States",
   "metaobject_handle": "review-fb0ed2fd-bab4-472f-b1cf-cc357c684e74"
 },
 {
   "title": "Repeat customer for a great product",
   "body": "My son has used these wipes for over a year, just reloaded our supply. \nAnyone who travels around playing on various courts knows just how bad the surfaces can get after repeated use and no wipe downs in between. These wipes do the job, creating more grip and traction!",
   "rating": 5,
   "review_date": "2024-09-09 18:00:51 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Ryan Glenn",
   "reviewer_email": "ryanmglenn@gmail.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "Thank you for the support for so long now!\nWe hate that courts are such a liability, but that's exactly why we spent the last 5 years working on this solution. It's feedback like this that keeps us going, so thank you for sharing your review!",
   "reply_date": "2024-09-09 18:13:27 UTC",
   "picture_urls": "",
   "ip_address": "108.16.53.58",
   "location": "Horsham, Pennsylvania, United States",
   "metaobject_handle": "review-739467aa-4695-4aed-b71c-69957d8c259d"
 },
 {
   "title": "Price and product are spot on",
   "body": "This is one of the best products I have ever seen for the court. The bundle prices just make it even easier to make the purchase.",
   "rating": 5,
   "review_date": "2024-09-22 11:22:56 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Marc Morgan",
   "reviewer_email": "mmorgan@warrenjfk.com",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "76.188.147.107",
   "location": "Niles, Ohio, United States",
   "metaobject_handle": "review-ba55361c-4dcb-4845-80ae-b22cc862fb6b"
 },
 {
   "title": "",
   "body": "Great product!! Our BING BONG team loved how fast it worked and made a difference. 10/10!! Highly recommend. Thanks Edge!",
   "rating": 5,
   "review_date": "2024-09-29 14:47:09 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Brian Munoz",
   "reviewer_email": "bmoony42@yahoo.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-160434605-1df798d2-0b82-421d-9b96-74f75c026b91"
 },
 {
   "title": "Changed the game!",
   "body": "No longer worried about slipping, so I can really go for my lunges every time!",
   "rating": 5,
   "review_date": "2024-11-03 02:14:19 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Jessica Dunne",
   "reviewer_email": "jessicadunne17@gmail.com",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "67.81.193.92",
   "location": "Riverside, Connecticut, United States",
   "metaobject_handle": "review-ebf18428-5643-40f2-8fb9-a8bff8f02a0c"
 },
 {
   "title": "",
   "body": "My son loves it!",
   "rating": 5,
   "review_date": "2024-11-07 15:25:46 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Kristin Nelson",
   "reviewer_email": "kristinnelson2@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-166052707-ce4659e8-f52e-4701-8144-fedc1cf9fb1f"
 },
 {
   "title": "Best Stuff on Market!!!",
   "body": "I’m very happy to have been on instagram and randomly found a video for edgespray. I made a decision to check it out and it’s the best decision I’ve made. I’ll be a customer for life .",
   "rating": 5,
   "review_date": "2024-11-12 18:11:09 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Nate Lewis",
   "reviewer_email": "natel4492@gmail.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "12.74.62.35",
   "location": "New York, New York, United States",
   "metaobject_handle": "review-f81ca2a2-5617-4d82-92ec-a353cf9e1496"
 },
 {
   "title": "Never received spray",
   "body": "Never received spray only wipes.",
   "rating": 2,
   "review_date": "2024-11-13 18:23:38 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Dawn Garetson",
   "reviewer_email": "chuckdawn@tds.net",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-b1d8edaf-9b2f-4cc6-9e08-d1b561f53835"
 },
 {
   "title": "Great Product and Company",
   "body": "Great costumer service and my boys love the spray that helps them maintain traction on an older floor they practice on.  Thanks!",
   "rating": 5,
   "review_date": "2024-11-19 23:20:17 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Jake Linden",
   "reviewer_email": "jelinden@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "Thank you for your kind words! I'm glad to hear that our Grip Spray has been a hit with your boys and has helped them maintain traction on the practice floor they struggle with. Customer service is probably our top priority outside of constantly improving our products and I'm happy to know that we've met your expectations. Thank you for supporting us on this journey!",
   "reply_date": "2024-11-20 00:41:37 UTC",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-19d23d5d-1681-43f1-884d-7816e7c31fb9"
 },
 {
   "title": "Works well",
   "body": "I purchased this for my 13 yr of son, he likes it and uses it once a day.  He plays at least 3x a day but said it stays well enough on the hardwood courts that he dosen't need to spray again later in the day.  Bad points for glass container and $$",
   "rating": 5,
   "review_date": "2024-11-21 01:20:53 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "bettie austin",
   "reviewer_email": "bettieaustin23@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "Hey Bettie, I'm so glad to hear your son is getting lots of use out of our Sneaker Grip Spray! We use glass in our 2oz bottles to limit the amount of plastics we use for environmental reasons, but we have recently switched our 4oz spray bottles to plastic. If you're interested in the 4oz for your next order, please reach out and I will send you a discount code as a token of my appreciation for your review feedback!\n\n-Zach",
   "reply_date": "2024-11-21 04:43:20 UTC",
   "picture_urls": "",
   "ip_address": "172.56.92.127",
   "location": "San Antonio, Texas, United States",
   "metaobject_handle": "review-4deac654-8a87-4d05-938f-73fe93003438"
 },
 {
   "title": "Shoe Magic",
   "body": "These wipes really work..!! Have 2 basketball players using them this season and they truly help with better traction on the court..!! Definitely will buy more when they run out..!!",
   "rating": 5,
   "review_date": "2024-11-21 14:14:58 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Joni Thorp",
   "reviewer_email": "bigstartx@yahoo.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "174.197.5.141",
   "location": "Austin, Texas, United States",
   "metaobject_handle": "review-bd2cdce8-28b1-48cf-b647-b9eac7e69247"
 },
 {
   "title": "Don't go to the court without it",
   "body": "Both of my daughters are using Edge now. It's a must have!",
   "rating": 5,
   "review_date": "2024-11-25 00:58:05 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "David Cline",
   "reviewer_email": "dcline@eastcentralcropservice.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "64.184.98.58",
   "location": "Hagerstown, Indiana, United States",
   "metaobject_handle": "review-be82dad8-247c-4c35-b807-499108967a96"
 },
 {
   "title": "Great item to have In Volleyball bag",
   "body": "Love it no need to dust off shoes",
   "rating": 5,
   "review_date": "2024-11-25 15:56:55 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Juan Rivera",
   "reviewer_email": "jrcaal@gmail.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "Great to hear that you're enjoying the product for Volleyball and that it helps you avoid having to constantly wipe the dust off your shoes!\n\nThank you for your feedback!",
   "reply_date": "2024-11-25 16:12:18 UTC",
   "picture_urls": "",
   "ip_address": "24.6.247.190",
   "location": "Pittsburg, California, United States",
   "metaobject_handle": "review-405dc120-2d7f-44ad-ba8f-15662af46797"
 },
 {
   "title": "",
   "body": "The wipe didn’t last for the whole practice",
   "rating": 4,
   "review_date": "2024-11-25 23:56:39 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Jacqueline WilliamsOlango",
   "reviewer_email": "jawill72@hotmail.com",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "Thank you for supporting our company and for reporting back! Some of our athletes do prefer to reapply halfway through games and practices, especially on excessively dusty courts - I'm glad to see you still enjoyed the product though (given the high rating)!\n\nIf you have any questions or need any help, please feel free to chat with us on our website support chat or on social media!",
   "reply_date": "2024-12-05 06:49:43 UTC",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-169564499-0f298769-49c2-44d2-ada4-d0a0310a2a3f"
 },
 {
   "title": "",
   "body": "It’s a gift so it has not been used yet!",
   "rating": 5,
   "review_date": "2024-12-07 16:42:33 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Donell Merchant",
   "reviewer_email": "merchantdonell@gmail.com",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-171769837-50ec50ca-cc0b-40c1-9c00-57b7be9701fe"
 },
 {
   "title": "",
   "body": "Works well, kids like the extra grip to help on the court!",
   "rating": 5,
   "review_date": "2024-12-07 18:56:01 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Tesha Peterman",
   "reviewer_email": "boatman_tesha@live.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-171795845-9c93d88a-e83f-4209-9804-d794153c32cb"
 },
 {
   "title": "Great for Wrestling",
   "body": "I tried this product to see if it would help with grip while wrestling (heavyweight). I found that with the Edge spray I slip less when executing on mat rolls and am able to get more traction during escapes.",
   "rating": 5,
   "review_date": "2024-12-09 00:52:07 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Robert Ward",
   "reviewer_email": "pyorkward@hotmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "This is awesome to hear! So glad we can help you maintain your footing for wrestling!\n\nThank you for the support 🙏",
   "reply_date": "2024-12-09 04:29:48 UTC",
   "picture_urls": "",
   "ip_address": "75.208.106.48",
   "location": "Nashville, Tennessee, United States",
   "metaobject_handle": "review-0fcf6db4-d68f-4342-93ad-2a51366a5d3b"
 },
 {
   "title": "Great product",
   "body": "This spray works really well. I’d only suggest that when you spray your shoes, do it over a towel or completely off the gym floor as it’s pretty slick if left on the floor. Expensive, but works.",
   "rating": 5,
   "review_date": "2024-12-09 18:56:56 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Katie McCoy",
   "reviewer_email": "woodruffkm@yahoo.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "I'm glad you're happy with your purchase, Katie! In case this is helpful - note that if you do get any on the floor, you can kick your sneakers into it to dry it up the same way we do with sweat when someone falls on the court.\n\nThank you for the feedback and for the suggestions!",
   "reply_date": "2024-12-09 23:29:22 UTC",
   "picture_urls": "",
   "ip_address": "73.103.135.119",
   "location": "Indianapolis, Indiana, United States",
   "metaobject_handle": "review-ccb8c93e-6d37-4303-bd1c-51d755cebd9b"
 },
 {
   "title": "It’s Hands Down A Game Changer‼️",
   "body": "Edge Spray Is For Sure A Must Cop‼️",
   "rating": 5,
   "review_date": "2024-12-10 00:46:52 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Clinton Byrd",
   "reviewer_email": "coachbyrd42@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "104.28.126.141",
   "location": "Huntsville, Alabama, United States",
   "metaobject_handle": "review-880d4787-1b65-4747-a7fa-53a7c74138a6"
 },
 {
   "title": "Not as advertused",
   "body": "Product doesn’t work well or last long. Disappointing.",
   "rating": 1,
   "review_date": "2024-12-11 05:54:59 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Eric Barajas",
   "reviewer_email": "ebar21@aol.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "Eric - I'm so sorry to learn about your experience :(\n\nI can usually help you get better use out of the product if you want to reach out to our team@edgespray.com email! If not, I am always happy to honor our money-back guarantee. We are not in the business of taking money from anyone who isn't satisfied with the product!\n\nThank you for the support and let me know if I can help in any other way!",
   "reply_date": "2025-02-17 17:16:52 UTC",
   "picture_urls": "",
   "ip_address": "70.95.192.153",
   "location": "San Diego, California, United States",
   "metaobject_handle": "review-955d1c9c-779b-47ff-8b8e-611453080f7f"
 },
 {
   "title": "",
   "body": "My daughter plays volleyball and I thought this would help her instead of always licking her hands and wiping her shoes, however she says it works but wears off quick.",
   "rating": 2,
   "review_date": "2024-12-11 12:44:05 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Nicole Pelzman",
   "reviewer_email": "nickeyp1980@yahoo.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-172664326-41c35e7b-0b85-4424-a847-c0a7e0892047"
 },
 {
   "title": "Son loves them",
   "body": "Son has used them and loves them. They provide the grip he needs on different surface levels (some gyms more slippier than others) and it helps him get better control.",
   "rating": 5,
   "review_date": "2024-12-11 14:34:17 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Shandy",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-d69c1128-f1ff-406c-9c9d-490a06bd6494"
 },
 {
   "title": "Impressed",
   "body": "My 6’4”, 17 year old son is a serious student athlete. He used them this weekend during the Live Period. A teammate of his saw how well his grip was after using it and asked to test one out. My son loves the product. He can speak performance of the product very well. He was impressed!! His teammate had already asked him multiple times where he bought the product at. I bought the wipes because he had some new shoes that didn’t have the best traction on a few courts but they give him the best comfort for a young man that wears a size 15 shoe and makes an impact all over the floor.",
   "rating": 5,
   "review_date": "2024-12-11 14:34:17 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Erik",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-2567720f-eca8-4964-a46e-26930a7a6a31"
 },
 {
   "title": "Work very well",
   "body": "My son has been using it and he says they work very well. Apparently there is a gym he trains in on Tuesdays that never gets cleaned and is extra dirty and dusty. It works great for him there.",
   "rating": 5,
   "review_date": "2024-12-11 14:34:17 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Jeremy",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-2633b656-33e4-44eb-b89b-75c95f6c2aea"
 },
 {
   "title": "Teammates love them too",
   "body": "My son took two with him to practice tonight so he could try one, and he could have one of his friends/teammates try one out as well. They were in their school's new gymnasium for practice today, which is only a couple of years old, only used exclusively for sports, and very well maintained; however, they could still tell that your product (wipes) made a big difference, traction wise. He said they both really liked it!!! I asked him if he would like me to keep buying them for the season and he immediately answered \"yes\". I will definitely be purchasing more soon, along with the spray (just to try out)",
   "rating": 5,
   "review_date": "2024-12-11 14:34:17 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Jason",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-40e5869e-65ea-4c49-9f91-0b9c55bee0b8"
 },
 {
   "title": "Love both the spray and wipes",
   "body": "Love the spray and wipes.  Every training she uses it and can tell a big difference.  She's won a silver and gold individual medal at the club, and just the weekend finished 5th in the U20 nationals here, and was part of the gold medal team.",
   "rating": 5,
   "review_date": "2024-12-11 14:34:17 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Greg",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-8e044d58-d06e-4591-a8aa-69feed72bddf"
 },
 {
   "title": "Hasn’t worked yet",
   "body": "Followed the steps over and over. Reached out to Zach, sent a few emails and then never responded. Just buy the sticky mats and save your $$ in my opinion",
   "rating": 3,
   "review_date": "2024-12-12 01:25:55 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Rick Leasure",
   "reviewer_email": "rleasure42@live.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "Hey Rick,\n\nI'm sorry to see this, but I'm also confused! We have an email thread of 9 emails back and forth, the very first of which I offered to send you a return label if I couldn't help troubleshoot for you. Your last email is on Dec 1, which responded to on Dec 5, then followed up again on Dec 11 because I hadn't heard from you. They are all in the same thread with my Cofounder CC'd on every one of both yours and mine, so I'm not sure why they wouldn't show up in your inbox.\n\nI'm still happy to give you a refund for the inconvenience, just wanted to share my perspective because I take a lot of pride in my customer service and care deeply about each customer!\n\nIf you have any feedback on how I can improve, please let me know and I appreciate you taking the chance on our product either way",
   "reply_date": "2025-02-17 17:24:46 UTC",
   "picture_urls": "",
   "ip_address": "74.141.90.230",
   "location": "Willoughby, Ohio, United States",
   "metaobject_handle": "review-aeee63fe-a889-4076-bffd-eaf9e2698629"
 },
 {
   "title": "",
   "body": "先週末に使ってみましたが、コートでの違いは特に感じませんでした。",
   "rating": 1,
   "review_date": "2024-12-12 18:53:06 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Michelle Lee",
   "reviewer_email": "michellelee1028@yahoo.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-173012300-8171bc5b-0901-499f-9c60-5bd0e72898c6"
 },
 {
   "title": "Travel ball",
   "body": "My son plays travel ball and middle school ball so Edge will get a lot of use..",
   "rating": 5,
   "review_date": "2024-12-13 00:51:03 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Christopher",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-756047b9-7bc9-4ad6-98fb-163aacb0d76b"
 },
 {
   "title": "Surprised",
   "body": "My son thinks these are great. He was really surprised how well they worked! He said the wipes are super easy to use. He likes that he can easily keep them in his basketball bag. He also appreciated how quick they were to use and how fast it dried so he can wipe down his shoes just prior to games. Awesome product.",
   "rating": 5,
   "review_date": "2024-12-13 00:51:03 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Karen",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-184f9905-3d78-46e3-a08b-30d54ea3e652"
 },
 {
   "title": "Victory!",
   "body": "I got a lot of great feedback last night at volleyball. They pulled out a 3rd set victory and they loved the extra grip while playing. I can't wait to try these Sunday for bball.",
   "rating": 5,
   "review_date": "2024-12-13 00:51:03 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Marc",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-b62f16bf-9168-49f0-8fa5-64c6c89ace1d"
 },
 {
   "title": "Really like them so far",
   "body": "So far, they've really liked them. During training, it made a definite difference when they were going up the warped wall and going through the jumping spider.",
   "rating": 5,
   "review_date": "2024-12-13 00:51:03 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Noah",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-2eebbf92-caf7-4032-b931-267925958653"
 },
 {
   "title": "Rave reviews",
   "body": "my husband coaches travel basketball teams for both girls and boys and has had my children use them and raves about them.",
   "rating": 5,
   "review_date": "2024-12-13 00:51:03 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Stephanie",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-6c4b0695-ba3d-4832-9748-61be8d2fdd2f"
 },
 {
   "title": "Works on smooth granite",
   "body": "I used the wipes on some rubber hiking boots before climbing the cables on Half Dome in Yosemite and felt like I had great traction while others were slipping.",
   "rating": 5,
   "review_date": "2024-12-13 00:51:03 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "David",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-0fd9509c-dde4-43ab-9359-a7e69c0e62ef"
 },
 {
   "title": "",
   "body": "They work great my daughter tried at her game other night",
   "rating": 5,
   "review_date": "2024-12-22 05:31:25 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "WALTER JOHNSON",
   "reviewer_email": "bigwallyjohnson@aol.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-175280890-9beeafc5-9e18-40a4-9f08-c754754702d4"
 },
 {
   "title": "",
   "body": "They are Christmas presents. So I’m not sure yet. Very expensive so far. We’ll see if it lives up to the price tag.",
   "rating": 1,
   "review_date": "2024-12-23 20:31:59 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Nicci Mercado",
   "reviewer_email": "nicciwd40@yahoo.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "Hey Nicci, Bumping this in case you had any updates after your niece and nephews tried the product - thanks so much for your support!",
   "reply_date": "2025-01-16 19:03:05 UTC",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-175577608-5ea7fbb5-ab55-4f06-bc7b-72b54985d868"
 },
 {
   "title": "",
   "body": "Doesn’t last long",
   "rating": 2,
   "review_date": "2024-12-24 00:31:53 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "David Lorence",
   "reviewer_email": "dave32880@aol.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-175628074-83feeafb-8c42-438c-aaa0-1309b32f9277"
 },
 {
   "title": "Several teammates wanted to try, game changer",
   "body": "The edge spray has been a game changer for me. Unfortunately not too long after I used it, I had the bottle in the gym and someone walked off with it. Several of my teammates wanted to try it. We just played a game in an old gym floor that was slippery and I really could have used it.",
   "rating": 5,
   "review_date": "2024-12-24 00:00:00 UTC",
   "source": "judge-me",
   "curated": "ok",
   "reviewer_name": "Ava Reymond",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-5a054531-c528-4e7c-9988-02327c2d3978"
 },
 {
   "title": "Wipes worked super well, friends liked them",
   "body": "wipes worked super well and the girls liked them. Have a tournament this weekend and going to bring for people to try there too!",
   "rating": 5,
   "review_date": "2024-12-24 00:00:00 UTC",
   "source": "judge-me",
   "curated": "ok",
   "reviewer_name": "Ana Stojanovic",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-59cf429e-4eb5-487b-9afc-924cb0ddc777"
 },
 {
   "title": "Works great, improves confidence",
   "body": "It works great! We feel confident knowing we don’t have to worry about slippery floors.",
   "rating": 5,
   "review_date": "2024-12-24 00:00:00 UTC",
   "source": "judge-me",
   "curated": "ok",
   "reviewer_name": "Qeshaun Todd",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-d7f7bff2-59e6-43f1-a6ef-aab4ba8a8227"
 },
 {
   "title": "Game changer, helps with slippery gym floor",
   "body": "Game changer!! Especially because my gyms floor where the bags are is SUPER slippery oddly enough thank you!!",
   "rating": 5,
   "review_date": "2024-12-24 00:00:00 UTC",
   "source": "judge-me",
   "curated": "ok",
   "reviewer_name": "Alaena Vampira",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-c5bb5300-2386-47a0-a75b-c74364f25fcd"
 },
 {
   "title": "Definitely made an improvement",
   "body": "We had a few kids and a few of the experienced fencers try it. I asked them to fence a bout AND then treat their shoes to compare. Definitely made an improvement.",
   "rating": 5,
   "review_date": "2024-12-24 00:00:00 UTC",
   "source": "judge-me",
   "curated": "ok",
   "reviewer_name": "Brad",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-fe79dd9c-d976-43e6-bf59-07cdc2afef22"
 },
 {
   "title": "",
   "body": "Great product! AMAZING customer service!",
   "rating": 5,
   "review_date": "2024-12-26 15:06:31 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Lauren Paquette",
   "reviewer_email": "laurenpaquette77@live.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "Thank you for the feedback and I'm always happy to help!\n-Zach",
   "reply_date": "2025-01-06 19:29:53 UTC",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-176072695-e9f88ad2-3245-427a-bd22-8ade0c880775"
 },
 {
   "title": "",
   "body": "Excellent product..",
   "rating": 5,
   "review_date": "2025-01-11 15:27:30 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Bobby Kovach",
   "reviewer_email": "bobbylitefit12@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-179283675-5616e131-3cc8-4700-8b21-07c652eb2d47"
 },
 {
   "title": "",
   "body": "My boys absolutely love this product, provides the extra traction on the basketball court. Everyone on the team was asking to try it. Would definitely purchase again!",
   "rating": 5,
   "review_date": "2025-01-13 20:50:30 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Kristy Hamm",
   "reviewer_email": "kristy.fischer@hotmail.com",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-179666192-a0fa50af-0f2c-478a-ab31-4ebfe2c25f76"
 },
 {
   "title": "Amazing product and customer service",
   "body": "Both my boys play volleyball and they received edge spray for Christmas and they absolutely love it. Helps with sliding and has increased both of their verticals! Zach is amazing to work with, his customer service is second to none! \n\nRolanda Wii",
   "rating": 5,
   "review_date": "2025-01-31 17:59:33 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Rolanda W Canada ",
   "reviewer_email": "rolandawitt@sasktel.net",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "I'm so glad to hear your boys are getting use out of the product! Thank you so much for taking the time to fill out a review and include some footage!\n\nAnd I appreciate your kind words - feedback like this makes my entire week :)\n\n-Zach",
   "reply_date": "2025-02-04 08:45:36 UTC",
   "picture_urls": "",
   "ip_address": "71.17.210.127",
   "location": "Saskatoon, Saskatchewan, Canada",
   "metaobject_handle": "review-84253be9-2abd-410d-b3d5-044df2641b8b"
 },
 {
   "title": "",
   "body": "My son seems to really like them! Really helpful at his last game when gym floor was very slippery",
   "rating": 4,
   "review_date": "2025-02-13 02:55:50 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Jill Llewellyn",
   "reviewer_email": "jilliellew1601@gmail.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-185433023-bbd3d356-302a-40f5-9268-58834fdff989"
 },
 {
   "title": "Works for golf grips too",
   "body": "I thought if it worked on shoe rubber why not golf grips since that is my summer sport",
   "rating": 5,
   "review_date": "2025-05-21 00:00:00 UTC",
   "source": "judge-me",
   "curated": "ok",
   "reviewer_name": "Kelly R",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "Thank you for sharing!! You are one of the 1st people to test EDGE on your golf grips and that is so freaking cool to hear that the product we made for sneaker grip is helping restore grip to your clubs!",
   "reply_date": "2025-05-23 22:02:42 UTC",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-ad4328f2-d9b7-4931-8994-ea28d26a5772"
 },
 {
   "title": "Football gloves!",
   "body": "I notice a night and day difference becuase usually when I buy football gloves they're grippy like once or twice, with this they're grippy every single time",
   "rating": 5,
   "review_date": "2025-05-20 00:00:00 UTC",
   "source": "judge-me",
   "curated": "ok",
   "reviewer_name": "Drake L",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "Thank you for being one of the first people to test EDGE on your football gloves!! I LOVE hearing new use cases like this and I appreciate you for sharing your feedback!",
   "reply_date": "2025-05-23 22:00:57 UTC",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-1a95f983-1502-4a97-b9e6-64f9c277490d"
 },
 {
   "title": "Great product",
   "body": "Really great product. Does everything it claims and more! Highly recommend it!",
   "rating": 5,
   "review_date": "2025-05-24 07:02:05 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "PK Higa",
   "reviewer_email": "3andoutfitness@gmail.com",
   "product_id": 8573934534808,
   "product_handle": "sneaker-grip-bundles-private-reorder",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "66.8.203.193",
   "location": "Makawao, Hawaii, United States",
   "metaobject_handle": "review-f77ad873-e72d-4a6e-8200-7e0c58283ed9"
 }
];

if (Shopify.locale == 'ko') {
  var review_json = [{
      "title": "정말 대박 제품이에요!",
      "body": "드디어 이런 제품을 누군가가 만들어 냈군요.진짜 효과 좋습니다.",
      "rating": 5,
      "review_date": "2021-11-09 18:58:44 UTC",
      "source": "email",
      "curated": "ok",
      "reviewer_name": "Sarah Marilyn",
      "reviewer_email": "sarahmarilynsocial@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "174.104.141.156",
      "location": "Stow, Ohio, United States",
      "metaobject_handle": "review-14241e0f-1bd0-4360-aa0b-c1455cdd9fb1"
    },
    {
      "title": "KING Yabba의 후기",
      "body": "Sonic Art 작업과 함께 농구 선수들과도 협업하고 있습니다. 이번에는 선수들이 전에 못 보던 새로운 움직임을 보여주는 걸 목격했어요. EDGE를 사용하지 않는 팀과 경기할 때 어떤 차이를 보여 줄지 기대됩니다. 앞으로도 꾸준히 사용하고 싶네요!",
      "rating": 5,
      "review_date": "2021-11-11 17:49:38 UTC",
      "source": "email",
      "curated": "ok",
      "reviewer_name": "KING Yabba",
      "reviewer_email": "1king.yabba@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "https://s3.amazonaws.com/me.judge.review-images/edge-traction-spray/1636653236__759A5518-B007-4B00-B973-C85787B01C91__original.jpeg, https://s3.amazonaws.com/me.judge.review-images/edge-traction-spray/1636653237__23F0885D-6C42-4E65-8252-F007C9BD5FCC__original.jpeg",
      "ip_address": "98.207.2.216",
      "location": "Daly City, California, United States",
      "metaobject_handle": "review-de0ba3f5-403e-4dc3-bfad-3c8dc55305c8"
    },
    {
      "title": "디테일부터 완벽한 제품!",
      "body": "용기 디자인부터 포장까지 세심하게 신경 쓴 게 티가 납니다. 겉 보기에도 멋지지만 성능은 그보다 더 좋아요. 이제 끈적한 매트에 신발을 문지르거나 손바닥에 침 묻혀 신발 바닥을 닦는 짓을 안해도 되서 너무 좋습니다. ",
      "rating": 5,
      "review_date": "2021-11-17 02:54:26 UTC",
      "source": "email",
      "curated": "ok",
      "reviewer_name": "Michael Barajas",
      "reviewer_email": "michaelbarajas22@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "76.182.193.217",
      "location": "Carrollton, Texas, United States",
      "metaobject_handle": "review-24749f2b-5dd4-41f3-863d-aca653fcc7af"
    },
    {
      "title": "Awesome spray!",
      "body": "Great traction on slippery floors\nLove the recyclable packaging",
      "rating": 5,
      "review_date": "2021-12-05 16:52:34 UTC",
      "source": "email",
      "curated": "ok",
      "reviewer_name": "Cynthia",
      "reviewer_email": "keckles2112@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "174.197.140.238",
      "location": "Brooklyn, New York, United States",
      "metaobject_handle": "review-6e55fcac-7cbc-4c55-89bb-646b41998ba1"
    },
    {
      "title": "존 홀",
      "body": "대학교 농구 선수입니다. 연습할 때 낡은 운동화에 이 제품을 사용해 봤는데, 완전 새 신발처럼 밑창 접지력이 살아나더라고요.",
      "rating": 5,
      "review_date": "2022-01-20 04:53:39 UTC",
      "source": "email",
      "curated": "ok",
      "reviewer_name": "John Hall",
      "reviewer_email": "halljohnathan58@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "65.254.30.118",
      "location": "Lowell, Massachusetts, United States",
      "metaobject_handle": "review-557e63db-3e2a-4a6d-84c6-ecd1c4f2831d"
    },
    {
      "title": "실내용 클리트처럼 착 붙는 접지력, 스니커헤드도 안심하고 쓸 수 있는 제품.",
      "body": "Edge 스프레이 덕분에 이제 어떤 바닥이든, 어떤 신발을 신든 제가 원하는 대로 자유자재로 플레이할 수 있어요.  저는 탁구 동호회에서 주로 활동하는데, 바닥 관리가 잘 안 된 곳이 많아서 늘 미끄럽고 먼지도 많거든요. 예전엔 경기 중간마다 젖은 휴지로 신발 밑창 닦고 얼마 뒤에 다시 미끄러지고 하는 게 일상이었죠. 근데 Edge 스프레이를 쓰고는 상황이 완전 180도 변했습니다.  물로 신발 바닥을 닦는 것과는 비교도 안 돼요. 접지력이 강해지고, 먼지 많은 바닥에서도 편하게 잘 움직일 수 있습니다. 처음엔 혹시 비싼 운동화가 스프레이 때문에 손상되지 않을까 걱정했는데,  신발 모양도 감촉도 그대로예요. 달라진 건 오직 ‘접지력’ 하나 뿐!",
      "rating": 5,
      "review_date": "2022-01-26 23:53:44 UTC",
      "source": "web",
      "curated": "ok",
      "reviewer_name": "Michael Bronikowski",
      "reviewer_email": "mbronik1@binghamton.edu",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "149.125.21.113",
      "location": "Binghamton, New York, United States",
      "metaobject_handle": "review-b7706672-a8b8-4de4-84b2-82063c1237b5"
    },
    {
      "title": "",
      "body": "대박",
      "rating": 5,
      "review_date": "2022-02-22 16:04:39 UTC",
      "source": "email",
      "curated": "ok",
      "reviewer_name": "Jacob Howard",
      "reviewer_email": "jacobhoward47@aol.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "209.175.44.33",
      "location": "Chicago, Illinois, United States",
      "metaobject_handle": "review-69ae9eec-e665-4082-a6bc-ebffe9945b74"
    },
    {
      "title": "제품 좋네요",
      "body": "처음엔 반신반의했는데, 한 번 써보고 바로 의심하던 마음을 접었습니다. NCAA 2부 리그에서 배구 경기를 뛰면서 이 제품 덕을 많이 봤습니다.",
      "rating": 5,
      "review_date": "2022-03-24 01:04:37 UTC",
      "source": "web",
      "curated": "ok",
      "reviewer_name": "Jamesly Metayer",
      "reviewer_email": "jameslymetayer123@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "50.231.95.206",
      "location": "Jacksonville, Florida, United States",
      "metaobject_handle": "review-a48722a2-6eca-42ee-a398-8fc5c33f86bf"
    },
    {
      "title": "이건 진짜 꼭 써 봐야 돼요!!!!",
      "body": "손으로 바닥으로 신발 밑창을 문지르는 건 이제 그만하세요. EDGE 스프레이 하나면 끝입니다. 진짜 최고예요!",
      "rating": 5,
      "review_date": "2022-03-26 21:17:40 UTC",
      "source": "web",
      "curated": "ok",
      "reviewer_name": "Adriana Sheri",
      "reviewer_email": "adrisheri@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "174.193.130.105",
      "location": "Los Angeles, California, United States",
      "metaobject_handle": "review-59c68660-dd9f-4335-a189-c5ee77f36166"
    },
    {
      "title": "완전 득템했어요!",
      "body": "오랜만에 코트에 나가서 EDGE 스프레이를 써봤는데, 진짜 효과가 좋더라고요. 완전 낡은 배구화라 접지력이 거의 없었는데, 바닥을 찰 때 끼익 소리까지 날 정도였어요. 낡은 신발에 사용했을 때 이정돈데, 새 신발에 사용하면 더 대박일 것 같아요.",
      "rating": 5,
      "review_date": "2022-04-07 21:44:47 UTC",
      "source": "web",
      "curated": "ok",
      "reviewer_name": "Fabiola Garcon",
      "reviewer_email": "fabgar14@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "24.218.247.136",
      "location": "Brockton, Massachusetts, United States",
      "metaobject_handle": "review-a3e1c886-f26a-4ab0-89de-222fc4f72dee"
    },
    {
      "title": "진짜가 나타났다.",
      "body": "이거 진짜 물건이네요. 딱 두 번 뿌렸는데 바로 접지력이 살아납니다. 효과도 오래가고, 광고에서 본  그대로예요. 장난 아닙니다. 꼭 사세요 — 진짜 후회 안 하실 겁니다!",
      "rating": 5,
      "review_date": "2022-04-28 01:49:38 UTC",
      "source": "web",
      "curated": "ok",
      "reviewer_name": "Jimmy",
      "reviewer_email": "jimmyninjas2@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "https://s3.amazonaws.com/me.judge.review-images/edge-traction-spray/1651110578__image__original.jpg",
      "ip_address": "96.227.100.175",
      "location": "Allentown, Pennsylvania, United States",
      "metaobject_handle": "review-6ec81bb2-771e-4f21-a4a6-c34a1de22d0d"
    },
    {
      "title": "EDGE 스프레이 후기",
      "body": "포장부터 마음에 쏙 들었어요. 깨끗하고 안전하게 잘 도착했습니다. 실내 코트에서 써봤는데 진짜 효과가 좋더라고요. 사용 전후 차이가 확실히 느껴졌어요. 전체적으로 퀄리티가 정말 좋아서 친구들이랑 팀원들한테도 강력 추천했습니다.",
      "rating": 5,
      "review_date": "2022-05-01 21:15:57 UTC",
      "source": "email",
      "curated": "ok",
      "reviewer_name": "Jimmy",
      "reviewer_email": "jimmyninjas2@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "174.198.9.227",
      "location": "Philadelphia, Pennsylvania, United States",
      "metaobject_handle": "review-36420699-b5f0-435e-85ce-30221424068c"
    },
    {
      "title": "확실히 접지력이 좋아졌어요",
      "body": "실내 경기장 바닥이 늘 깨끗한 편은 아닌데도, 다들 이 제품을 사용하고 나면 효과가 좋은 걸 느낄 수 있다고 하더라구요.",
      "rating": 5,
      "review_date": "2022-07-20 20:34:34 UTC",
      "source": "email",
      "curated": "ok",
      "reviewer_name": "Kevin Kovacs",
      "reviewer_email": "kevin.kovacs@gallaudet.edu",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "174.195.200.54",
      "location": "Chino, California, United States",
      "metaobject_handle": "review-fe527cec-e2e2-4179-a3bf-cef5f5ae71eb"
    },
    {
      "title": "접지력 장난 아니네요.",
      "body": "매 경기마다 신발 밑창에 끈적한 매트 붙였다 떼는 게 일상이었는데, 이제는 EDGE만 씁니다. 효과가 확실하니까 경기 전엔 다들 이거 먼저 찾아요.",
      "rating": 5,
      "review_date": "2022-07-31 14:19:21 UTC",
      "source": "email",
      "curated": "ok",
      "reviewer_name": "Tom Tran",
      "reviewer_email": "coacht2@yahoo.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "73.220.52.162",
      "location": "Rancho Cordova, California, United States",
      "metaobject_handle": "review-c7bf3423-5174-41e0-ab5a-97fc2fc926ed"
    },
    {
      "title": "빠른 건조 + 접착력 + 지속력",
      "body": "웨이트랑 기능성 운동을 자주 하는데, EDGE 덕분에 밸런스 훈련할 때 훨씬 안정적이에요. 예전엔 제 몸 균형보다 신발 접지력이 문제였는데, 이제는 미끄러질 일이 없어요. 굳이 아쉬운 점을 꼽자면, 좀 더 빨리 마르고 오래 갔으면 좋겠다는 거?  그래도 또 뿌릴 만큼 만족스럽습니다 — 진짜 그만한 값은 해요 ;)",
      "rating": 4,
      "review_date": "2022-08-15 16:13:51 UTC",
      "source": "email",
      "curated": "ok",
      "reviewer_name": "Ariel Schulze",
      "reviewer_email": "arielbschulze@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "24.30.36.110",
      "location": "Atlanta, Georgia, United States",
      "metaobject_handle": "review-039a323e-6fcb-4504-b329-9aba4bdeed41"
    },
    {
      "title": "Edge’s Grip Spray, Game Changer!",
      "body": "This spray adds part to your game you didn’t know was missing. Getting on the court knowing that a whole category of error is eliminated elevates your game in a way you don’t realize until you do it. Knowing you won’t slip and your movements will be more clean and secure will give you a confidence boost. I recommend every athlete that plays on any kind of court to invest in themselves by getting Edge Spray!",
      "rating": 5,
      "review_date": "2022-08-15 21:38:59 UTC",
      "source": "email",
      "curated": "ok",
      "reviewer_name": "Demonte Denzel Flannigan",
      "reviewer_email": "flannigandemonte@yahoo.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "https://s3.amazonaws.com/me.judge.review-images/edge-traction-spray/1660599777__fdd06f41-b6dc-437e-8d31-c3c2c0f8aa40__original.jpeg",
      "ip_address": "188.27.106.129",
      "location": "Craiova, Dolj, Romania",
      "metaobject_handle": "review-67102e68-7154-4ff6-8e7e-3061e0d87fa5"
    },
    {
      "title": "Great Product",
      "body": "Easy to use, reliable for games on end, adds great traction for dusty surfaces or even semi-worn shoes, portable and accessible making it the best thing I’ve used since…EVER. Nothing on the market compares to this product tbh. Glad I copped",
      "rating": 5,
      "review_date": "2022-10-02 23:19:21 UTC",
      "source": "email",
      "curated": "ok",
      "reviewer_name": "Zay",
      "reviewer_email": "brolicbyzay@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "167.160.130.80",
      "location": "Washington, District of Columbia, United States",
      "metaobject_handle": "review-c682c69d-34bb-41bf-bdc7-2a52299efd61"
    },
    {
      "title": "Wow",
      "body": "This Stuff is Awesome!!!  They even help older shoes that used to basketball become relevant again!!!  Kobe 5 OG with some really worn down outsoles once again became alive with Edge Spray!!!",
      "rating": 5,
      "review_date": "2022-11-21 19:49:27 UTC",
      "source": "email",
      "curated": "ok",
      "reviewer_name": "Rod ",
      "reviewer_email": "rbowers@augusta.k12.va.us",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "216.12.45.75",
      "location": "Staunton, Virginia, United States",
      "metaobject_handle": "review-7a25272e-7624-436c-a390-c09ba499c009"
    },
    {
      "title": "Must cop",
      "body": "Love this spray got instant grip after using it on multiple sneaker brands",
      "rating": 5,
      "review_date": "2022-12-05 01:27:50 UTC",
      "source": "email",
      "curated": "ok",
      "reviewer_name": "Brent Emelander",
      "reviewer_email": "soledoutyt@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-d92ece71-8579-466c-a0eb-7f0bd60dc9bb"
    },
    {
      "title": "Amazing Product",
      "body": "I’ve never tried a grip spray before. This product is amazing. After 3 to 4 sprays to each shoe, the traction improved amazingly and I could feel the confidence I need it.",
      "rating": 5,
      "review_date": "2023-01-07 23:54:41 UTC",
      "source": "email",
      "curated": "ok",
      "reviewer_name": "Jaime Sotelo",
      "reviewer_email": "jimmy.curry05@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "187.190.5.245",
      "location": "Ciudad Juárez, Chihuahua, Mexico",
      "metaobject_handle": "review-c3295dbe-d914-4677-96ee-91e26ed4e3ea"
    },
    {
      "title": "Must have",
      "body": "The DeSoto Lady Eagles do not take the court without having our Edge;)",
      "rating": 5,
      "review_date": "2023-02-03 04:45:10 UTC",
      "source": "email",
      "curated": "ok",
      "reviewer_name": "Kadi Creel",
      "reviewer_email": "kadi.creel@desotoisd.org",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "70.143.103.163",
      "location": "DeSoto, Texas, United States",
      "metaobject_handle": "review-0efe7678-3210-4363-898b-d71a9584a0aa"
    },
    {
      "title": "No more slipping!",
      "body": "Everytime my son slips and falls at basketball practice, I hold my breath. I don’t even let him get on the court without spraying his shoes anymore. I just wish it came in a bigger size, we’re almost finished with the first bottle already.",
      "rating": 5,
      "review_date": "2022-01-14 00:20:34 UTC",
      "source": "judge-me",
      "curated": "ok",
      "reviewer_name": "Marie",
      "reviewer_email": "mtkecko16@aol.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-cb18b95b-b1f6-4178-8e46-663eae31ce81"
    },
    {
      "title": "Tested on rock climbing shoes",
      "body": "Outside of its current market - if you are a rock climber struggling with grip indoor or outdoor, Edge Spray may be what you are looking for.\nGrip is no joke, significantly increases grip on very small footchips to climb on, and has this \"sticky\" feel to it without actually being \"sticky.\" Best use is within first 20 mins in my opinion. Can seriously step up your game if needed for a very difficult climb. Quickly dries just like the instruction says, and you’re good to climb with great grip soon after.",
      "rating": 5,
      "review_date": "2022-01-20 00:22:04 UTC",
      "source": "judge-me",
      "curated": "ok",
      "reviewer_name": "Jonathan Kwan",
      "reviewer_email": "jkwan11@binghamton.edu",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-d59105bc-8f00-4e1d-b997-0212497f67d9"
    },
    {
      "title": "Great for Workouts",
      "body": "This product is amazing for when I’m taking workout classes in the gym. I’m always concerned about losing my footing on a move or slipping in plank positions. One less thing to worry about.",
      "rating": 5,
      "review_date": "2022-01-17 16:50:34 UTC",
      "source": "judge-me",
      "curated": "ok",
      "reviewer_name": "James K.",
      "reviewer_email": "jimkeck21@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-6c36f41d-14ac-4439-9267-320bc92ec27e"
    },
    {
      "title": "I like this product",
      "body": "I just tried it and I love it! I like how it works and there is not slippage when I am doing suicides.",
      "rating": 5,
      "review_date": "2023-03-15 17:14:11 UTC",
      "source": "web",
      "curated": "ok",
      "reviewer_name": "Holly Howard",
      "reviewer_email": "hrhoward@hotmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "50.51.120.186",
      "location": "Huron, Ohio, United States",
      "metaobject_handle": "review-e5acdb4f-93ec-4112-afea-fd849c7bb890"
    },
    {
      "title": "Great improvement on fencing shoe grips",
      "body": "Recently I bought three bottle of the spray and used on my fencing shoes on aluminum strip, the shoe grip was improved dramatically and never slipped. I recommend this product to my team players!",
      "rating": 5,
      "review_date": "2023-03-29 03:47:19 UTC",
      "source": "email",
      "curated": "ok",
      "reviewer_name": "Hui Liu",
      "reviewer_email": "hui007@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "67.221.143.36",
      "location": "Nevada, Texas, United States",
      "metaobject_handle": "review-aeed1554-65cc-4b38-b67b-f1498b9f342f"
    },
    {
      "title": "Spray Works",
      "body": "Nothing over the top and its gets the job done.",
      "rating": 5,
      "review_date": "2023-04-16 20:40:02 UTC",
      "source": "email",
      "curated": "ok",
      "reviewer_name": "Tamba Tongu",
      "reviewer_email": "tambatongue@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "76.169.65.24",
      "location": "Los Angeles, California, United States",
      "metaobject_handle": "review-30d65239-bfeb-4619-b0aa-9008b07c4100"
    },
    {
      "title": "Edge Spray",
      "body": "I absolutely love this shirt. When I got it I, no joke, wore it for four days straight. It feels so comfortable and airy. It feels great to wear for lifting. Love this product.",
      "rating": 5,
      "review_date": "2023-04-25 22:57:04 UTC",
      "source": "email",
      "curated": "ok",
      "reviewer_name": "Josh Weyerhaeuser",
      "reviewer_email": "joshuaweyerhaeuser@gmail.com",
      "product_id": 7579537309848,
      "product_handle": "edge-vintage-crewneck-tee",
      "reply": "Wow, so glad to hear this. We totally geeked out on the material to make them look + feel like a vintage shirt you've had for years, while feeling fresh and clean. Enjoy!",
      "reply_date": "2023-08-04 19:28:50 UTC",
      "picture_urls": "",
      "ip_address": "134.139.201.17",
      "location": "Long Beach, California, United States",
      "metaobject_handle": "review-31b66e3e-552f-464c-91b8-fd79df69d35f"
    },
    {
      "title": "",
      "body": "Shoe Sole Grip Spray",
      "rating": 5,
      "review_date": "2023-05-20 16:51:10 UTC",
      "source": "email",
      "curated": "ok",
      "reviewer_name": "Vivie Tims",
      "reviewer_email": "vivietims072@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-d77067fa-076d-4548-8a45-1d6d3364f8e7"
    },
    {
      "title": "Love it",
      "body": "Very good quality and sticks very well to surfaces",
      "rating": 5,
      "review_date": "2023-05-25 12:19:41 UTC",
      "source": "email",
      "curated": "ok",
      "reviewer_name": "Vivie Tims",
      "reviewer_email": "vivietims072@gmail.com",
      "product_id": 7579530559640,
      "product_handle": "stickers",
      "reply": "We love to hear it!",
      "reply_date": "2023-08-04 19:29:49 UTC",
      "picture_urls": "",
      "ip_address": "104.58.145.226",
      "location": "Mobile, Alabama, United States",
      "metaobject_handle": "review-e0b73a72-0b38-49e3-8980-6bd0e18f62da"
    },
    {
      "title": "Great stuff",
      "body": "Very impressive stuff.  Keeps the rubber of your shoes soft and sticky.  I would recommend.",
      "rating": 5,
      "review_date": "2023-07-02 16:45:12 UTC",
      "source": "email",
      "curated": "ok",
      "reviewer_name": "Ryan Cueni",
      "reviewer_email": "iroscoi@yahoo.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "40.136.120.114",
      "location": "Ashtabula, Ohio, United States",
      "metaobject_handle": "review-eb599a61-0fa5-42c2-ac07-0b5e80a86ae2"
    },
    {
      "title": "Getting better traction while fencing",
      "body": "I have recently started using Edge spray on my fencing shoes for safety reasons. The spray applied to the shoes sole ensured non-slippery fencing and better traction on the strip. Highly recommend it to any fencer who competes.",
      "rating": 5,
      "review_date": "2023-07-06 06:27:19 UTC",
      "source": "email",
      "curated": "ok",
      "reviewer_name": "Oleg Rusanov",
      "reviewer_email": "ovr_1973@yahoo.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "Awesome to hear. Thank you for taking the time to fill out a review, Oleg!",
      "reply_date": "2023-08-04 19:26:16 UTC",
      "picture_urls": "",
      "ip_address": "70.163.118.56",
      "location": "Phoenix, Arizona, United States",
      "metaobject_handle": "review-48dc64bf-48cc-4b2b-a862-eb027f444ba1"
    },
    {
      "title": "We Are Sticking With Edge!",
      "body": "This has been awesome for our fencing club. We fence on some slicker gym floors and this gives us the confidence and consistency we need. Thank you Zach!\nlowcountry fencers HHI • SC",
      "rating": 5,
      "review_date": "2023-07-12 19:26:00 UTC",
      "source": "email",
      "curated": "ok",
      "reviewer_name": "Patricia Wilkens",
      "reviewer_email": "wilkenspw@aol.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "We're very happy to hear that EDGE helped you grip the floor better despite the slick conditions. This is exactly why we do what we do. If anything else comes up, feel free to email me: zach@edgespray.com",
      "reply_date": "2023-08-04 19:16:53 UTC",
      "picture_urls": "",
      "ip_address": "173.207.193.46",
      "location": "Hilton Head Island, South Carolina, United States",
      "metaobject_handle": "review-7658792c-6ded-4dc9-836d-752cb542e739"
    },
    {
      "title": "ELITE!",
      "body": "Works like a dream! I'm 100% buying more as SOON as I get low. This is a must at every gym for the rest of my existence. Helps tremendously on bad courts and makes clean court experiences even better. Maybe my best purchase this year. No lie. Don't hesitate. Buy yours NOW!",
      "rating": 5,
      "review_date": "2023-08-03 20:41:10 UTC",
      "source": "email",
      "curated": "ok",
      "reviewer_name": "Del Von Lott Jr",
      "reviewer_email": "cuseboy211@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "We're so glad to hear this, thanks for taking the time to let us know! If anything else comes up, feel free to email me directly: zach@edgespray.com.",
      "reply_date": "2023-08-04 19:25:40 UTC",
      "picture_urls": "",
      "ip_address": "99.90.19.182",
      "location": "Midwest City, Oklahoma, United States",
      "metaobject_handle": "review-c49841ff-cce4-41af-a69a-8a5b06355318"
    },
    {
      "title": "",
      "body": "This stuff is amazing and truly a game changer for athletes, especially basketball players. We had been using grip spritz in my program, which is solid, but this is next level. Not only is it the most effective grip spray/grip product we have ever used, it is the easiest to use....no mat, no need to dry with a towel after applying, etc. You simply spray the bottom of each shoe 2-3 times, stomp each foot on the court/surface a few times, and BOOM, grip magic!",
      "rating": 5,
      "review_date": "2023-08-30 00:00:00 UTC",
      "source": "direct",
      "curated": "ok",
      "reviewer_name": "Eric Bullis",
      "reviewer_email": "bullis@campwildwood.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "Thanks Eric, we're always happy to hear positive feedback about our formula's drying time! We spent a *ton* of time in the lab to get it right and it's feedback like this that makes it all feel worth it. If anything else comes to mind, don't hesitate to email me at zach@edgespray.com.",
      "reply_date": "2023-09-01 17:51:57 UTC",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-9a4e9827-5866-4e38-8771-049f561c711b"
    },
    {
      "title": "",
      "body": "Great product",
      "rating": 5,
      "review_date": "2023-11-09 12:51:17 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Bernard Bowen",
      "reviewer_email": "bernardbowen825@gmail.com",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "174.198.6.215",
      "location": "Philadelphia, Pennsylvania, United States",
      "metaobject_handle": "review-57284e75-dbbe-4d31-8a27-0f86d874377e"
    },
    {
      "title": "Ari's Review",
      "body": "I love using EDGE spray for my sport (fencing). I got an order of the wipes as well, and have enjoyed those! I prefer the spray, but that's just me. Definitely worth a try for anyone who plays an indoor court sport.",
      "rating": 5,
      "review_date": "2023-11-19 03:00:56 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Ariel Simmons",
      "reviewer_email": "arieljsimmons@gmail.com",
      "product_id": 7736772952216,
      "product_handle": "edge-wipes-sample",
      "reply": "Thanks for sharing your experience, Ari! And I’m glad to hear that you’re getting use out of both the spray and the wipes!",
      "reply_date": "2023-11-25 22:39:37 UTC",
      "picture_urls": "",
      "ip_address": "74.142.216.242",
      "location": "Cleveland, Ohio, United States",
      "metaobject_handle": "review-013eae7a-d51f-4037-af5d-75e8e09d2c32"
    },
    {
      "title": "Game changer for middle school gyms",
      "body": "This stuff works! Middle school gyms are notoriously awful leaving basketball players sliding all over. This stuff is a game changer even on dusty/dirty MS courts.",
      "rating": 5,
      "review_date": "2023-11-21 13:04:13 UTC",
      "source": "web",
      "curated": "ok",
      "reviewer_name": "Shelly Hinz",
      "reviewer_email": "hinzshelly@gmail.com",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "Thanks Shelly! Middle school courts are a nuisance at best, and a liability at worst. I'm glad we could help out!",
      "reply_date": "2023-11-21 20:31:45 UTC",
      "picture_urls": "",
      "ip_address": "216.51.245.168",
      "location": "Maquoketa, Iowa, United States",
      "metaobject_handle": "review-b2c43df7-6f29-40f7-a4ec-a1589ae00faf"
    },
    {
      "title": "",
      "body": "The spray has helped provide greatest grab for my son’s shoes on the basketball court.",
      "rating": 5,
      "review_date": "2023-11-27 19:23:29 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Caleb Smith",
      "reviewer_email": "caleb_s51@hotmail.com",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "184.151.190.146",
      "location": "Toronto, Ontario, Canada",
      "metaobject_handle": "review-92d2dc29-717f-420c-bd9e-1060af8ee148"
    },
    {
      "title": "Kids love it",
      "body": "My kids love the edge sneaker grip . They say it helps playing basketball so much",
      "rating": 5,
      "review_date": "2023-11-29 15:05:35 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Charlene Thomas",
      "reviewer_email": "charct81@gmail.com",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "68.199.18.122",
      "location": "East Hampton, New York, United States",
      "metaobject_handle": "review-eae7a290-6654-4d32-9ea7-305fc20b65e4"
    },
    {
      "title": "",
      "body": "Works well. The performance might vary depending on the court cleaness but the spray it self provide extra but to the court. Recommended!",
      "rating": 5,
      "review_date": "2023-04-03 17:32:39 UTC",
      "source": "shop-app",
      "curated": "ok",
      "reviewer_name": "Sunghoon Lee",
      "reviewer_email": "iamsunghoonlee@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "shop-2519111-12099108-341b69c7-52ff-4146-9bad-29bad740189f"
    },
    {
      "title": "",
      "body": "I think it doesn’t really make a difference it just picks up more dust. And to small of a bottle",
      "rating": 3,
      "review_date": "2023-05-08 22:59:50 UTC",
      "source": "shop-app",
      "curated": "ok",
      "reviewer_name": "PJ MacGregorV",
      "reviewer_email": "pjmacgregorfive@icloud.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "shop-2519111-13124406-73dd4312-9ae1-4b09-975c-53be447a292f"
    },
    {
      "title": "",
      "body": "So far it’s awesome. I used it one time for a few hours on Air Max Uptempo 97’s on a pretty dirty wood court and my traction was much better.",
      "rating": 5,
      "review_date": "2023-09-25 16:11:18 UTC",
      "source": "shop-app",
      "curated": "ok",
      "reviewer_name": "Robert Medina",
      "reviewer_email": "dreu-77@hotmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "shop-2519111-37658316-8d054580-5d2d-4b72-a848-c8303fc30631"
    },
    {
      "title": "",
      "body": "This stuff is legit.  Works on the dirtiest, dustiest middle school courts.",
      "rating": 5,
      "review_date": "2023-11-23 21:17:40 UTC",
      "source": "shop-app",
      "curated": "ok",
      "reviewer_name": "Shelly Hinz",
      "reviewer_email": "hinzshelly@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "shop-2519111-53973786-cf4ddc31-cecb-4201-b506-f34f7ba8dec4"
    },
    {
      "title": "",
      "body": "Helpful! Thanks!",
      "rating": 5,
      "review_date": "2023-11-29 00:06:19 UTC",
      "source": "shop-app",
      "curated": "ok",
      "reviewer_name": "Amanda Fox",
      "reviewer_email": "alover76@yahoo.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "shop-2519111-54903301-6b8ca4ca-4c0f-45d3-989e-8fc6c47e31bd"
    },
    {
      "title": "The team loves it!",
      "body": "My son took his bottle of Edge to basketball practice and said everyone wanted to use it.  It's now part of our basketball bag for all games!   Some of these basketball floors have traction issues even for new shoes so this is great to have on hand!",
      "rating": 5,
      "review_date": "2023-12-01 15:25:14 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Caren Drinkard",
      "reviewer_email": "gripper28@yahoo.com",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "That's amazing to hear that EDGE was in high demand! So glad we can help your son and his team with the traction issues on those floors!",
      "reply_date": "2023-12-08 16:14:22 UTC",
      "picture_urls": "",
      "ip_address": "69.140.144.178",
      "location": "Charlotte Hall, Maryland, United States",
      "metaobject_handle": "review-cb744932-4b74-4a4c-8ba0-258dc710bcac"
    },
    {
      "title": "",
      "body": "Love the bottle and love the grip it provides.",
      "rating": 5,
      "review_date": "2023-12-08 05:37:24 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Justin Naab",
      "reviewer_email": "jnaab@naabtrade.com",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "107.9.211.81",
      "location": "Newburgh, Indiana, United States",
      "metaobject_handle": "review-32328f73-24f6-48cf-80fd-0931cd8725b0"
    },
    {
      "title": "It Really Works!",
      "body": "Just got this stuff. WOW. It really works. Where I live courts are terrible in the winter with all the salt and dust. I no longer have to worry about thwe poor court conditions now that I'm using Edge!!. A+",
      "rating": 5,
      "review_date": "2023-12-13 01:10:42 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Adrian Hall",
      "reviewer_email": "jeff@empirelocates.com",
      "product_id": 7736772952216,
      "product_handle": "edge-wipes-sample",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "99.83.63.143",
      "location": "Louisville, Kentucky, United States",
      "metaobject_handle": "review-6b64a80e-75d5-4b2b-a067-0c21d441fbb9"
    },
    {
      "title": "",
      "body": "Doesn’t seem to work as well as the video makes it seem. Sprayed on soles of sneakers and didn’t really provide any additional traction.",
      "rating": 1,
      "review_date": "2023-12-14 05:21:25 UTC",
      "source": "shop-app",
      "curated": "ok",
      "reviewer_name": "Kristen Hanson",
      "reviewer_email": "jerseygrl884@yahoo.com",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "Hey Kristen, \n\nI'm so sorry your experience didn't meet expectations! I tried reaching out a few times to learn more about your experience, but I haven’t heard back from you and I see you left 2 separate reviews back to back.\n\nThere are lots of factors that influence each experience, such as: sneaker outsole material, court conditions, and how long you allow the formula to soak into the rubber, etc. and I can help you get the most out of your purchase.\n\nI take the customer experience very seriously, if you can please reach out! My email is zach@ edgespray .com and I can also send you my cell # if that is easier. \n\nBest,\nZach",
      "reply_date": "2024-01-13 21:54:34 UTC",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "shop-2519111-68637879-5b92bba5-3a9f-4a57-b9ca-8d86c07cca5c"
    },
    {
      "title": "",
      "body": "Didn’t seem to make any difference.",
      "rating": 1,
      "review_date": "2023-12-14 05:21:58 UTC",
      "source": "shop-app",
      "curated": "ok",
      "reviewer_name": "Kristen Hanson",
      "reviewer_email": "jerseygrl884@yahoo.com",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "shop-2519111-68637952-cf530c6b-d8b5-45f5-b330-08d281aff09e"
    },
    {
      "title": "Gift for son",
      "body": "My teen asked for this for Christmas and I’m sure he’s going to be psyched to have a bottle of his own for his next game. Also Zach provided the most amazing customer service any consumer could ask for! ",
      "rating": 5,
      "review_date": "2023-12-22 01:57:54 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Lexi Forrest",
      "reviewer_email": "strykersmomma85@gmail.com",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "This is great to hear! Feel free to contact me anytime you need anything.\n\nMerry Christmas to you and your family!",
      "reply_date": "2023-12-25 22:57:25 UTC",
      "picture_urls": "",
      "ip_address": "174.168.2.195",
      "location": "Bethel, Connecticut, United States",
      "metaobject_handle": "review-954b7987-1160-43c0-867e-95465fde711e"
    },
    {
      "title": "IT WORKS",
      "body": "My kid said he has great traction and no longer slips on his school’s court (which desperately needs to be waxed).",
      "rating": 5,
      "review_date": "2024-01-05 02:13:16 UTC",
      "source": "web",
      "curated": "ok",
      "reviewer_name": "Jodie Farrow",
      "reviewer_email": "jodie.farrow@yahoo.com",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "73.226.42.86",
      "location": "Camden, New Jersey, United States",
      "metaobject_handle": "review-b282871a-3c2d-4b05-99be-97a320fde4b2"
    },
    {
      "title": "",
      "body": "Works well, good grip, cuts through dust",
      "rating": 5,
      "review_date": "2024-01-09 20:16:25 UTC",
      "source": "shop-app",
      "curated": "ok",
      "reviewer_name": "Jaden Chen",
      "reviewer_email": "jadenchen1213@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "shop-2519111-111240793-bb4b9688-a3db-443d-962e-9842dba45df8"
    },
    {
      "title": "Pretty dope product!",
      "body": "I tried this out the other day during my volleyball practice, and I was confused at first because i needed to let it dry for a second. But right when I hit the court, the grip was insane! I actually really enjoy this product!",
      "rating": 4,
      "review_date": "2024-01-13 17:38:07 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "brooke whitlock",
      "reviewer_email": "brookewhitlock5@gmail.com",
      "product_id": 7736772952216,
      "product_handle": "edge-wipes-sample",
      "reply": "Thank you for sharing your feedback, Brooke! You're absolutely right, the formula needs about 15 seconds on average to soak into the rubber outsole, before kicking your sneakers against the floor to lock in the grip.\n\nI'm so glad you're getting use out of the product!",
      "reply_date": "2024-01-19 20:14:58 UTC",
      "picture_urls": "",
      "ip_address": "139.60.13.108",
      "location": "Ogden, Utah, United States",
      "metaobject_handle": "review-3609ce57-dca9-4483-a0c2-f3322d55f224"
    },
    {
      "title": "Edge has made a huge difference for me. Love it!!!",
      "body": "Hi. Im a fencer and this product has made a huge difference for me. \nI represent Puerto Rico and I noticed when I fenced there I was slipping a lot. My thought is that because of the humidity and fencing in open air made the strips slippery. I started using edge and I hardly ever slip anymore. I now use it at every tournament because slipping could mean an injury so if using edge keeps me from getting injured than Im all in. Thanks Edge from Gabi Hwang",
      "rating": 5,
      "review_date": "2024-01-20 09:11:53 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Jamarys Hwang",
      "reviewer_email": "jamarysvaz@yahoo.com",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "Hi Gabi, thank you for taking the time to leave a review for our Sneaker Grip Bundles. I am so glad to hear that our product has made a huge difference for you in your fencing competitions. I understand the importance of having a secure grip on the strips, and we are happy that our product has helped you with that. Thank you for choosing EDGE and we wish you all the best in representing Puerto Rico. Keep on fencing!",
      "reply_date": "2024-02-08 23:08:58 UTC",
      "picture_urls": "https://s3.amazonaws.com/me.judge.review-images/edge-traction-spray/1705767711__img_5674__original.jpeg",
      "ip_address": "174.197.74.93",
      "location": "Dallas, Texas, United States",
      "metaobject_handle": "review-366ede25-3473-43f1-9909-7693f2d6f2c2"
    },
    {
      "title": "Squeak! Squeak!",
      "body": "This product is sensational, my shoes are able to perform on the dustiest basketball courts which helps since most players now have a stop & go playing style, I’m back to bringing the clamps! Thank you.",
      "rating": 5,
      "review_date": "2024-01-26 18:21:53 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Tyshan Jones",
      "reviewer_email": "jones90la@yahoo.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "Thank you for your glowing review of our Sneaker Sole Grip Spray! We're thrilled to hear that it's helping you dominate on the defense, even on the dustiest of surfaces. Keep bringing the clamps and thank you for choosing our product!",
      "reply_date": "2024-02-08 23:25:54 UTC",
      "picture_urls": "",
      "ip_address": "104.28.85.132",
      "location": "Los Angeles, California, United States",
      "metaobject_handle": "review-39ef852d-028c-4849-9273-032e15a66d06"
    },
    {
      "title": "Great product",
      "body": "Great product and customer service even got free wipes for being in the military which is always nice thank you",
      "rating": 5,
      "review_date": "2024-01-28 04:51:35 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Nathaniel McCampbell",
      "reviewer_email": "nathanmccampbell7@gmail.com",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "Thank you for your review, Nathaniel! It's my pleasure to support our military members and I hope the wipes come in handy for you. Thank you for your service!",
      "reply_date": "2024-02-08 23:06:58 UTC",
      "picture_urls": "",
      "ip_address": "184.188.64.222",
      "location": "Oceanside, California, United States",
      "metaobject_handle": "review-3cc38f11-0d2b-47d3-a263-292acbcd8f75"
    },
    {
      "title": "Great grip, Great CS!",
      "body": "Bought this because my son plays in a league with suboptimal court grip and it really helped him stand out amongst others sliding around. Nothing worse when trying to make a move to the basket while slipping and sliding on the floor. Definitely recommend for anyone trying to gain an edge when courts aren't newly resurfaced. \n\nAlso, absolute great customer service. I emailed Edge asking how long it would take for the grip spray to reach me since I needed it a bit sooner than I had anticipated for my son's game and they upgraded the shipping as a huge favor! My son won his game!!! Thanks Zach!",
      "rating": 5,
      "review_date": "2024-02-07 22:54:57 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Eduard Maldur",
      "reviewer_email": "emaldur@msn.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "Hey Ed! I am so happy to hear that our products helped your son stand out on the court. We understand how frustrating it can be to slip and slide while trying to make a move. Thank you for recommending it to others who may also be dealing with suboptimal court grip. I'm also thrilled to hear that your son won his game - the competition is what we do it for! Thank you for choosing our product and for sharing your experience!\n\n- Zach",
      "reply_date": "2024-02-08 23:11:47 UTC",
      "picture_urls": "",
      "ip_address": "70.93.170.228",
      "location": "Woodland Hills, California, United States",
      "metaobject_handle": "review-5527e5c2-83ba-4022-8b69-f11acad2a7a4"
    },
    {
      "title": "Edge spray X Chula Vista Suns",
      "body": "Game changer look forward to partnering up with edge spray",
      "rating": 5,
      "review_date": "2024-02-10 15:57:05 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Eric Brown",
      "reviewer_email": "chulavistasuns@yahoo.com",
      "product_id": 7736772952216,
      "product_handle": "edge-wipes-sample",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "172.56.188.172",
      "location": "Westminster, California, United States",
      "metaobject_handle": "review-9eed7509-194e-4b9a-9fe6-e078c8276c61"
    },
    {
      "title": "",
      "body": "The entire basketball team says this spray works the best!",
      "rating": 5,
      "review_date": "2024-02-15 21:54:36 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Jessica Knutson",
      "reviewer_email": "jessicaknutson23@yahoo.com",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "184.83.187.113",
      "location": "Sioux Falls, South Dakota, United States",
      "metaobject_handle": "review-6aecd80a-ac57-4b16-bab9-239d5d6dea7d"
    },
    {
      "title": "",
      "body": "My daughter loves it! Will be purchasing more . The only thing I will have to say is that’s a little pricey so we had to sparingly use it. If it was a little bit cheaper, we would use them more often thus would purchase more faster.",
      "rating": 4,
      "review_date": "2024-03-04 20:53:36 UTC",
      "source": "shop-app",
      "curated": "ok",
      "reviewer_name": "Benjamin Nguyen",
      "reviewer_email": "johndoe40230@gmail.com",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "shop-2519111-122250067-e3590a63-7877-4ff0-b8a8-9c35eeaf9bd5"
    },
    {
      "title": "Hidden Gems Showcase",
      "body": "I heard nothing but positive reviews from the players all day about how great the product was and the amount of traction that it produced.",
      "rating": 5,
      "review_date": "2024-03-28 13:00:15 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Randford Brooks",
      "reviewer_email": "info@mttsathletics.com",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "64.251.48.206",
      "location": "Waterbury, Connecticut, United States",
      "metaobject_handle": "review-fc32c50e-7878-4014-999c-530d61d0a4b6"
    },
    {
      "title": "Significant grip",
      "body": "My son is a basketball player and likes the wipes a lot. He says they help the grip on his shoes significantly.",
      "rating": 5,
      "review_date": "2024-02-17 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Brooke Shipbaugh",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-64b666eb-0e5d-4131-af43-96f4fd504d70"
    },
    {
      "title": "Feels great!",
      "body": "Product feels great! Just tried it out and filmed some dunks with it",
      "rating": 5,
      "review_date": "2023-12-21 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Lonnie Reed-Perez",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-5189cd3b-6e36-4d2e-8072-814775f65f3e"
    },
    {
      "title": "Teammates love it too",
      "body": "I really like the product I could definitely feel a difference. My teammates are asking me to not forget to bring the spray",
      "rating": 5,
      "review_date": "2023-11-22 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Romancomvalius",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-ce9c18ff-c8b0-4162-b69c-bd206bcb480a"
    },
    {
      "title": "Works",
      "body": "They actually work very good!",
      "rating": 5,
      "review_date": "2024-02-15 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Logan Ste",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-641111f1-50b1-4a55-8c73-840b72c0e25e"
    },
    {
      "title": "Coach",
      "body": "We love EDGE! My husband is a CYO Basketball Coach for my son’s 6th grade team St Rose. He’s been using the spray on all the boys sneakers throughout the season. This has been a great help for the boys this season. It definitely helps give them more traction. You can see we keep buying bottles!! lol",
      "rating": 5,
      "review_date": "2024-02-24 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Debby Scro",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-1809ebb6-64f7-4f72-aa90-fb4bfeaa1b05"
    },
    {
      "title": "Great product",
      "body": "I’m a retired Marine and now assistant with a Volleyball team. My daughter says it’s a great product. I will recommend this to our team, for sure.",
      "rating": 5,
      "review_date": "2024-02-15 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Rob Hunter",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-3fea81d6-de74-4742-948a-01f74e8bcd48"
    },
    {
      "title": "Strong effect",
      "body": "Really like the product. Definitely can feel the effects strongly for the first 5-10 minutes (with the spray). Used it in game a few times too",
      "rating": 4,
      "review_date": "2023-11-15 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Caleb Williams",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-fe659b36-f550-40f9-9168-6666631b36c6"
    },
    {
      "title": "Works for sure",
      "body": "I got the package yesterday right before practice and used one wipe! They work for sure. My shoes are starting to get slippery so they came just in time. The grip was good all practice and my team scrimmaged so it got the real test.",
      "rating": 5,
      "review_date": "2023-11-09 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Austin Abrams",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-678bc2a3-8472-4421-9ca2-62407d9e9236"
    },
    {
      "title": "Really works",
      "body": "Love the product. The traction really works.",
      "rating": 5,
      "review_date": "2024-03-13 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Adarsh Subra",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-c58b9e98-7cfe-4d99-86f9-c73f8a3644d0"
    },
    {
      "title": "Works",
      "body": "It’s amazing!",
      "rating": 5,
      "review_date": "2023-12-14 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "WYB",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-a3433fa4-b928-4f35-8bd1-93d494687009"
    },
    {
      "title": "Full control",
      "body": "I love the product.. got full control now inside the court",
      "rating": 5,
      "review_date": "2023-11-24 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "dredzkiiisdname",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-84ed1733-f157-4b31-9bff-ccd96815c5f3"
    },
    {
      "title": "Win",
      "body": "Our players enjoy it!",
      "rating": 5,
      "review_date": "2023-11-10 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Chris Diaz",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-92828794-44e2-446a-aacd-e1097f2ead7f"
    },
    {
      "title": "Nothing else is close",
      "body": "EDGE is the best! Nothing else is close",
      "rating": 5,
      "review_date": "2023-09-09 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "floridafan1976",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-860338b1-ff57-408f-b476-7d699be4284f"
    },
    {
      "title": "Can really tell the difference",
      "body": "It’s great, I can really tell the difference between when I’m using it or not! It does what it claims really well! My players have all liked it too. The only thing is that I haven’t gotten a chance to personally use it on a super beat up or unkept floor yet, so I don’t have experience with that. I’ve been on decent to great hardwood and good sportcourt. But it’s definitely elevated my traction on those surfaces. I’ve actually had a couple of my players ask me if I had it on my a certain days if they didn’t like how their shoes were feeling.",
      "rating": 5,
      "review_date": "2023-08-14 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Ethan Khoza",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-c9270ce0-4854-49ee-8dff-aa0edf0b1be1"
    },
    {
      "title": "Works great",
      "body": "This thing is great!",
      "rating": 5,
      "review_date": "2023-08-22 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "George Davey",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-55cf2de2-a6ab-4135-a280-c7c7339150e3"
    },
    {
      "title": "Love it",
      "body": "I LOVEEEEE the spray. It works great! My teammates also wanna start using it",
      "rating": 5,
      "review_date": "2023-08-24 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Jada Sabon",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-76b9d9d6-c2b7-4857-b647-65a0f8950547"
    },
    {
      "title": "No more slipping",
      "body": "Had a dude slipping all game the other day and told him to tryout the spray. Tried it and was sticking the rest the day.",
      "rating": 5,
      "review_date": "2023-10-25 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Jordan Boyd",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-60fd7658-e60f-4d36-82c4-5741215204d1"
    },
    {
      "title": "Passes the test",
      "body": "I’ve had some people test it out with myself included and there’s really good feedback",
      "rating": 4,
      "review_date": "2023-07-02 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Hoopwith’em",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-572c5775-e98b-4c0e-a3ab-757ed05ec921"
    },
    {
      "title": "Amazing",
      "body": "My trainer let me use some of his and it was amazing",
      "rating": 5,
      "review_date": "2023-07-30 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "1kamadou",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-2086a33d-1a30-42e2-97ea-0596e8ec5626"
    },
    {
      "title": "Works great",
      "body": "Been loving the spray this off-season man! Works great, bottle looks great. Love it",
      "rating": 5,
      "review_date": "2023-05-04 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Connor Printz",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-0d89026e-3a2b-41f1-8906-2d37c104ffae"
    },
    {
      "title": "Helped a ton",
      "body": "I was able to use the spray quite a lot over the last week of practices. Our AC has been out in the gym, so it helped a ton with the grip on the floors, and I loved it!",
      "rating": 5,
      "review_date": "2023-07-20 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Drew Thelwell",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-6db725b0-2d07-48e5-ae33-5fa6547a5517"
    },
    {
      "title": "Great",
      "body": "Got two bottles left from last deal. Nothing but great reviews!",
      "rating": 5,
      "review_date": "2023-07-15 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Grit and Grind Hoops",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-d896c05c-24b1-4953-9d7b-381a68813767"
    },
    {
      "title": "Helped with grip",
      "body": "I liked it. Helped with good grip on the court",
      "rating": 4,
      "review_date": "2023-06-14 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Bryce",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-91215d1d-6e26-4b69-97ab-068d4303a85f"
    },
    {
      "title": "Flat out works",
      "body": "I hoop in KD’s so when the floor is wet or starts getting sweaty, having low tops that slip can be detrimental. Let’s just say yesterday, I didn’t have any issues and kept the spray with me.",
      "rating": 5,
      "review_date": "2023-04-24 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Davion Robinson",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-74453255-2922-4a9d-9ec2-cab2d5a09dd3"
    },
    {
      "title": "Good review",
      "body": "I used it on the court at home! It was great",
      "rating": 5,
      "review_date": "2023-09-18 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Chase Adams",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-abb04734-f92b-4f1e-b081-b84da54348c0"
    },
    {
      "title": "Really like it",
      "body": "I really like it, EDGE works very well on the volleyball court!",
      "rating": 5,
      "review_date": "2023-02-19 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Cal Krohn",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-519da695-a0b9-4960-bdca-4d1719fd0775"
    },
    {
      "title": "Definitely noticeable",
      "body": "Honestly I was good with it for a while and definitely noticeable because I purposely went somewhere slippery",
      "rating": 5,
      "review_date": "2023-04-13 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Larry Moreno",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-438c15da-dcc2-4d29-9caf-d9db77c2c488"
    },
    {
      "title": "Can definitely feel the difference",
      "body": "Really like the spray! You definitely can feel a difference first few minutes for sure! Excited to keep using it and see how it spans over a full day of workout & camp sessions!",
      "rating": 5,
      "review_date": "2023-06-11 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Jeremy Hays",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-16e1ed19-52dc-41da-8bb2-614a152942c3"
    },
    {
      "title": "Better than anything else I've tried",
      "body": "EDGE is absolutely amazing! 2-3 pumps per shoe and I grip the whole game 40 min! Dropped 33 points and 20 rebounds. Love it I can say better than the competition on the market",
      "rating": 5,
      "review_date": "2023-05-28 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Lorenzo Ervin",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-62c199e2-8963-4e10-9fb0-738e7aa910e7"
    },
    {
      "title": "Works",
      "body": "it works, rlly appreciate u EDGE",
      "rating": 5,
      "review_date": "2023-03-22 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Adan Diggs",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-04441629-235f-440b-8ee8-987443c62266"
    },
    {
      "title": "So much more traction",
      "body": "I love the product!! It gives me that stop and go I need! My shoes have so much more traction",
      "rating": 5,
      "review_date": "2023-02-06 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Michael Barber",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-de1f1774-79ff-47fb-8dee-2abb64337a6b"
    },
    {
      "title": "Please expand to Europe",
      "body": "I play basketball over here in Monaco and I’m always slipping on courts all across Europe. I found your product review on YouTube and I decided to give it a try. Out of everything out there, you guys definitely stood out to me. The overall vibe of the brand was cool. Also the product itself looked durable and professional. I’ve only been able to use it a few times but it’s been amazing so far. Would love to hear about your expansion plans in Europe etc.",
      "rating": 5,
      "review_date": "2023-01-17 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Jordan Loyd",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-0c073eaa-eccc-41ef-9486-57fd50e2a28d"
    },
    {
      "title": "No product like it",
      "body": "Brother, it’s amazing. No product like it. You’re worth millions",
      "rating": 5,
      "review_date": "2023-05-03 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Brian",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-cd89964e-8a0f-49f1-b5c5-68a5aa8f33ee"
    },
    {
      "title": "People need to know about this",
      "body": "I love the grip on my shoes now … it helps me move freely & sharp. Thank you💪🏾‼️ Great product ‼️ people need to here more about this",
      "rating": 5,
      "review_date": "2023-03-02 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Daveonne Warfield",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-d0541b26-7bfa-4bfc-88a0-38385c20042a"
    },
    {
      "title": "Good product",
      "body": "the coaches from DeSoto high school said it's a good product, so I trust it",
      "rating": 5,
      "review_date": "2023-01-06 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Donny B.",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-94bffd84-00d4-4cc9-b2bb-a38c3a554b89"
    },
    {
      "title": "Better than Court Grip",
      "body": "I didn’t even clean the shoes or anything! I had walked a little bit and the shoes that been on a shelf for at least two months! It definitely shows! The last time I had a product similar was like back in 2011 Dwyane Wade had some kind of product that he was sponsoring to increase grip. I really liked it back then, but obviously that was a long time ago. This is by far the best",
      "rating": 5,
      "review_date": "2022-12-01 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Ricky",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-71c438c7-2ac4-4cd6-b838-24a4390df306"
    },
    {
      "title": "Amazing",
      "body": "it’s a amazing product",
      "rating": 5,
      "review_date": "2022-12-18 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Javier Daire",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-33bebdc6-19a5-430d-9ae7-247830965945"
    },
    {
      "title": "Firends are asking about it",
      "body": "My daughter is using this for indoor field hockey. I just had a mom reach out to me to ask about the product because my daughter has let some of the girls try her bottle.",
      "rating": 5,
      "review_date": "2023-01-24 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Tiffany Hilton",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-8bea9923-5e6b-4f3b-9907-23536dda390c"
    },
    {
      "title": "Helped",
      "body": "I tried it out a small bit yesterday and I think it helped a little bit - there are a number of factors to work against so the jury is still out on how much rubber revival can happen, but I’m hopeful",
      "rating": 4,
      "review_date": "2023-02-23 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Andrew Wittler",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-3d72931a-3909-4ff4-9758-90189a70cfc5"
    },
    {
      "title": "Doesn't get dirty like a sticky mat",
      "body": "It’s great! Definitely improves my grip. The duration of it could possibly be improved but it’s not much of a problem. But other than that it’s simple and easy! Personally, I think this is better cuz it doesn’t get dirty like a sticky mat and is not as big. But ig the one thing that a sticky mat may have an advantage in is the fact that all you have to do is step on it and step off",
      "rating": 4,
      "review_date": "2022-09-06 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Jaylen Wells",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-cad84a0e-3065-4005-a1da-e7b94c82f62d"
    },
    {
      "title": "Loving it",
      "body": "Tried out the product yesterday and loving it so far!! will continue to use it",
      "rating": 5,
      "review_date": "2022-10-24 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Tyler Leclerc",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-dd63840e-9187-461c-a2db-475a62a02a30"
    },
    {
      "title": "Immaculate!",
      "body": "Used it the last few hoop seshes and needless to say i LOVE IT! i tried it on some of the hoopin shoes that i thought did not have the best traction and after the spray they were immaculate!!!",
      "rating": 5,
      "review_date": "2023-01-15 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Parker Reese",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-2a066be9-def5-477c-b384-c4fe551f897f"
    },
    {
      "title": "Extra grip",
      "body": "I like how I get that extra bit of grip that I need in order to perform to the best of my ability",
      "rating": 5,
      "review_date": "2022-11-29 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Jacob Falko",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-84ebc289-266f-4be3-ac93-8e2b3ee5aaec"
    },
    {
      "title": "Son plays basketball, product seems to work well",
      "body": "My son is using it for his basketball games. I always see him wiping his shoes on the court with his hands so I thought this would be a better option. I think it’s good so far!",
      "rating": 4,
      "review_date": "2023-01-17 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Noelle Penna",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-5f2aa5b6-5a80-4443-8da3-f5c491706400"
    },
    {
      "title": "Amazing",
      "body": "This product is amazing",
      "rating": 5,
      "review_date": "2022-04-13 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Lexi Barros",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-091cbb5c-9c27-473c-a02a-3202396819e7"
    },
    {
      "title": "Incredible grip",
      "body": "I just wanted to say the spray as been working great I’ve gotten two people to stumble from How good the grip has been lol",
      "rating": 5,
      "review_date": "2022-08-29 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Mark Winston",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-cee88397-2a16-4ef7-b942-109a7fe6b9c1"
    },
    {
      "title": "Incredible",
      "body": "I firmly believe in your product. I've tried it out, and it is incredible",
      "rating": 5,
      "review_date": "2022-03-22 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Christopher Hoang Anh Nguyen",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-439d9832-e46e-40c0-a442-7504748d29cf"
    },
    {
      "title": "Grip",
      "body": "Bro that EDGE grip is tough brooo",
      "rating": 5,
      "review_date": "2022-02-17 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "AtmBucketzzz",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-5acb96f5-964a-462c-9b1d-f336d6d289d9"
    },
    {
      "title": "Works the best",
      "body": "My twin boys use it for High School Basketball. I bought three different brands of this type of spray. They said EDGE is the only one that actually works. Of course it is the most expensive one. A lot of their teammates have started to use it, so it ran out quickly. I told them to tell their buddies to buy their own. Ha! They like the way it works. My only complaint would be price point.",
      "rating": 4,
      "review_date": "2023-01-24 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Jessica Knutson",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-26433204-7b50-403d-8753-412c9becbf36"
    },
    {
      "title": "Use it daily",
      "body": "Your product is great and I use it daily",
      "rating": 5,
      "review_date": "2023-01-31 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Kennady McQueen",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-37f2011d-e92b-43a9-994f-1ba94f328088"
    },
    {
      "title": "Works really really well",
      "body": "Works really well, had a slippery court a couple of weeks ago and it made my shoes feel brand new",
      "rating": 5,
      "review_date": "2022-06-26 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Jacob De Armas",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-559062e5-ae44-4441-b5bd-577511112c97"
    },
    {
      "title": "Stop on a dime",
      "body": "Tried it again indoor for the first time and it’s great bro! The way you can stop on a dime is incredible! Def gunna be using this product from now on",
      "rating": 5,
      "review_date": "2022-04-06 17:00:00 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Derek West",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-403aeb9f-0304-4a3e-8172-89fc8858e9f3"
    },
    {
      "title": "STELLAR PRODUCT!",
      "body": "Last weekend I shared my Edge wipes with my teammates as we got ready to compete in a tournament.  The Edge wipes had my team stopping on a dime and they made transitioning from offense to defense much easier!  Thank you Edge brand for creating a product that complements athlete’s game!",
      "rating": 5,
      "review_date": "2024-05-22 00:06:29 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Jaylen Williams",
      "reviewer_email": "officiallyjaywill@gmail.com",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "107.122.225.8",
      "location": "San Antonio, Texas, United States",
      "metaobject_handle": "review-f8310cfa-a75f-481f-9afd-bfc5a2f656f2"
    },
    {
      "title": "Edge Spray is fire!",
      "body": "Love this product. We have bought other grip spray products, but none have been so easy to use and worked the way Edge does! Definitely recommend!",
      "rating": 5,
      "review_date": "2024-06-04 21:23:07 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Jacquelyn King",
      "reviewer_email": "jakb2013@yahoo.com",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "Thank you for taking time to leave a review! We are thrilled to hear that you are loving our Grip Spray. We are committed to making the best grip products out there and I'm happy to hear that it worked better than others on the market.\n\nI appreciate your support and hope to continue providing you with top-notch products!",
      "reply_date": "2024-06-04 21:33:17 UTC",
      "picture_urls": "",
      "ip_address": "174.126.117.134",
      "location": "Prescott, Arizona, United States",
      "metaobject_handle": "review-b1a31b4b-ee76-47e9-8c4f-ace5060bfffa"
    },
    {
      "title": "Good product, grip is dependent on the actual condition of the floor",
      "body": "I used the wipes as directed and found immediate much better traction.  The effect lasts much longer on floors that have t least been swept recently.  On horrible floors the effects were short lived.  Still worth trying.  I’ll keep using them",
      "rating": 4,
      "review_date": "2024-06-07 22:29:53 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Philip Rubenstein",
      "reviewer_email": "par167@yahoo.com",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "Thank you for the feedback, Philip! You're right - on unusually dusty courts (much more than the typical YMCA or AAU courts), you'll need to use EDGE more often than normal. Our formula soaks directly into rubber, so the improvement in grip is actually coming from the rubber itself. The more dust or dirt that is on the court, the less the rubber can grip the court, no matter how grippy it is.\n\nOur Sneaker Grip Wipes have the added benefit of cleaning the dust off your sneaker outsoles while simultaneously modifying the chemistry of the rubber with our grip formula. We appreciate the feedback!",
      "reply_date": "2024-06-14 14:04:52 UTC",
      "picture_urls": "",
      "ip_address": "73.198.167.80",
      "location": "West Orange, New Jersey, United States",
      "metaobject_handle": "review-47741a0e-151f-42a0-8174-4b37af77e413"
    },
    {
      "title": "Exceptional product.  Better than anything on the market",
      "body": "Lasted the entire basketball game, could hear the shoes squeak in the stands.  Logan played great, he had so much confidence in his agility due to the traction from the Edge product.  29 points as a sophomore on varsity.",
      "rating": 5,
      "review_date": "2024-06-14 03:05:23 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Zac MISSLER",
      "reviewer_email": "zmissler@misslerhomes.com",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "75.141.164.74",
      "location": "Atascadero, California, United States",
      "metaobject_handle": "review-1ac3884f-b592-4d5d-8f7f-3865b966d708"
    },
    {
      "title": "Awesome",
      "body": "Product has been great to use. Highly recommend for elite athletes.",
      "rating": 5,
      "review_date": "2024-06-20 17:00:41 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Loren Jackson",
      "reviewer_email": "lorenjackson3@gmail.com",
      "product_id": 7736772952216,
      "product_handle": "edge-wipes-sample",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "104.28.57.243",
      "location": "Miami, Florida, United States",
      "metaobject_handle": "review-c0ea29d1-c51f-453d-a516-010c7af4fb86"
    },
    {
      "title": "B-ball Players Dream",
      "body": "I bought this for my son for Christmas and when he ran out he asked me to get him more.  You don't need to use too much of it and each usage lasts pretty long.",
      "rating": 5,
      "review_date": "2024-06-21 14:32:13 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Lori Carelle",
      "reviewer_email": "lori.carelle@gmail.com",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "I'm glad your son's 2oz bottle lasted from Christmas until June - that's exactly what we intended! We designed our EDGE® Spray bottles to be portable and small without needing to buy a new bottle every month.\n\nThank you for giving us this feedback!",
      "reply_date": "2024-06-21 15:22:52 UTC",
      "picture_urls": "",
      "ip_address": "50.248.80.45",
      "location": "Bridgeville, Pennsylvania, United States",
      "metaobject_handle": "review-6d767ac8-4b58-47fb-a62f-3e1efbb8fc50"
    },
    {
      "title": "Edge wipes",
      "body": "My boys really like the stuff.  They come to me asking me before games to prep their shoes.  It’s funny to watch the other players who don’t use edge sliding all over the floor.",
      "rating": 5,
      "review_date": "2024-06-26 01:56:18 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Ryan Cueni",
      "reviewer_email": "iroscoi@yahoo.com",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "71.79.146.163",
      "location": "Painesville, Ohio, United States",
      "metaobject_handle": "review-8885fb51-8c44-4c7c-bfef-2a5bd2a9137b"
    },
    {
      "title": "Edge grip wipes",
      "body": "They product actually works I’d use more of it for sure.",
      "rating": 5,
      "review_date": "2024-06-26 22:23:40 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "DJ Freeman",
      "reviewer_email": "superathlete6093@gmail.com",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "107.115.163.20",
      "location": "Midland, Texas, United States",
      "metaobject_handle": "review-48df1fae-e292-4ac4-ad03-f0316fa0a400"
    },
    {
      "title": "",
      "body": "Amazing product. Must have product for highschool gym floors. Even on a swept clean floor these still add so much better traction even with newer shoes only ever worn inside. 1.00 a wipe per game, worth it!",
      "rating": 5,
      "review_date": "2024-06-30 20:26:22 UTC",
      "source": "shop-app",
      "curated": "ok",
      "reviewer_name": "Steve Darnell",
      "reviewer_email": "sdarnell2618@gmail.com",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "shop-2519111-147043622-30e1e8b4-df4d-48a2-bdbd-376b45e4d931"
    },
    {
      "title": "",
      "body": "The whipes work GREAT!  They remove the debris on the underside of the shoes and increase traction.  I can't imagine fencing without them.",
      "rating": 5,
      "review_date": "2024-07-03 12:44:38 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "John Tomasi",
      "reviewer_email": "fencingengineer@gmail.com",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "174.207.230.233",
      "location": "Cincinnati, Ohio, United States",
      "metaobject_handle": "review-4648973a-dcc3-44ef-8cde-ed90b0447937"
    },
    {
      "title": "Great Product. Must Have.",
      "body": "Kept seeing my son with variable traction with new shoes depending on the court. Didn’t want him to get injured. Bought the wipes and he LOVES them. No need to unfold them as they work as directed. Even got his teammates wanting to know where he got them. Going to check out the spray as well. This is a must have!",
      "rating": 5,
      "review_date": "2024-07-07 17:18:58 UTC",
      "source": "web",
      "curated": "ok",
      "reviewer_name": "Erik Nelson",
      "reviewer_email": "ejnelson06@gmail.com",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "100.7.87.167",
      "location": "Moseley, Virginia, United States",
      "metaobject_handle": "review-b00adc42-31dc-4432-8479-d5084db84dc4"
    },
    {
      "title": "",
      "body": "'-'",
      "rating": 5,
      "review_date": "2024-07-09 22:34:12 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Glenn Marumoto",
      "reviewer_email": "marumoto.glenn@gmail.com",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "47.149.222.60",
      "location": "Long Beach, California, United States",
      "metaobject_handle": "review-696d5a1c-9e07-4c47-bbd7-0173da04ac39"
    },
    {
      "title": "Edge’s Sneaker Grip review",
      "body": "For the first time using this product it was great and it really helped with the grip on my shoes",
      "rating": 5,
      "review_date": "2024-07-12 19:17:57 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Carl Taylor",
      "reviewer_email": "carl.taylor615@gmail.com",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "172.56.219.234",
      "location": "Philadelphia, Pennsylvania, United States",
      "metaobject_handle": "review-b0a5ab9a-68f9-47fe-9f77-e3a0270efd74"
    },
    {
      "title": "Amazing product!",
      "body": "I didn’t realize how much of a difference Edge grip spray made until I tried it for myself. It gives you terrific traction that makes you feel like a better athlete! I play basketball in college and will definitely be using this product! 1000 % recommend!",
      "rating": 5,
      "review_date": "2024-07-23 13:20:51 UTC",
      "source": "web",
      "curated": "ok",
      "reviewer_name": "Grant Stubbs",
      "reviewer_email": "grant.stubbs0920@gmail.com",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "Thank you for taking the chance to test our product! Using it yourself is the best way to become a believer in the product and how much of a difference it can make. Thats why we offer the money-back guarantee so you can test it without any risk - we're very confident in the products we've developed!",
      "reply_date": "2024-07-24 02:05:03 UTC",
      "picture_urls": "",
      "ip_address": "172.56.226.122",
      "location": "Birmingham, Alabama, United States",
      "metaobject_handle": "review-e0bdb927-3a06-4adf-9121-b73d3ffdfb70"
    },
    {
      "title": "Very versatile product!",
      "body": "Even though I’m a track and field athlete this product works perfectly!",
      "rating": 5,
      "review_date": "2024-07-23 14:05:06 UTC",
      "source": "web",
      "curated": "ok",
      "reviewer_name": "Dewayne Johnson",
      "reviewer_email": "dcjohnson0112@gmail.com",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "98.227.93.120",
      "location": "Park Forest, Illinois, United States",
      "metaobject_handle": "review-68d0f0b4-253f-4f53-8209-11b19acc0a17"
    },
    {
      "title": "Best product",
      "body": "I love this product. As a basketball player I always struggle with my shoes being grippy as the season goes on. I just tried out these wipes and I couldn’t be happier. Unlike the grip boards these wipes take off the dirt on your shoes and actually make your shoes grippy. I can’t wait to continue to use edge and to use them during my season. I am so excited!",
      "rating": 5,
      "review_date": "2024-07-23 21:21:11 UTC",
      "source": "web",
      "curated": "ok",
      "reviewer_name": "Erika Lane",
      "reviewer_email": "erikalane24@gmail.com",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "184.61.44.46",
      "location": "Pequot Lakes, Minnesota, United States",
      "metaobject_handle": "review-974f722d-f941-40e2-b5b3-963371df54e4"
    },
    {
      "title": "D1 Athlete",
      "body": "I’m a D1 athlete and I tried these out for the first time on the volleyball court and they made a HUGE difference!",
      "rating": 5,
      "review_date": "2024-07-23 22:03:20 UTC",
      "source": "web",
      "curated": "ok",
      "reviewer_name": "Keyana Cruse",
      "reviewer_email": "k-cruse@wiu.edu",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "23.81.164.196",
      "location": "San Jose, California, United States",
      "metaobject_handle": "review-4c47b0e2-4492-4a1a-9ccb-ea226f5d6e9a"
    },
    {
      "title": "Game-Changing Grip",
      "body": "Slippery shoes have always been a major hindurance while playing on some basketball courts even at the D1 level. These give my shoes the extra traction I need especially on those courts that just seem to be too slippery. With one wipe, I can give both my shoes extra traction allowing me to cut better and safer.",
      "rating": 5,
      "review_date": "2024-07-23 22:26:49 UTC",
      "source": "web",
      "curated": "ok",
      "reviewer_name": "Sofie Lowis",
      "reviewer_email": "slowis@siue.edu",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "104.167.152.65",
      "location": "Edwardsville, Illinois, United States",
      "metaobject_handle": "review-42bb9f01-6fc7-4a76-b7ea-46234ece833b"
    },
    {
      "title": "Great product",
      "body": "I loved using this product. The floors I play on are pretty slippery and the wipes are amazing. Easy to use and an absolute must for athletes",
      "rating": 5,
      "review_date": "2024-07-23 23:02:05 UTC",
      "source": "web",
      "curated": "ok",
      "reviewer_name": "Teagan Thurman",
      "reviewer_email": "teagan1010@icloud.com",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "Sorry to hear that you deal with slippery floors, but I'm glad our Sneaker Grip Wipes have been helpful for you to counter that problem! Thanks for sharing your feedback, Teagan!",
      "reply_date": "2024-07-24 02:01:31 UTC",
      "picture_urls": "",
      "ip_address": "66.218.40.208",
      "location": "Tehachapi, California, United States",
      "metaobject_handle": "review-f3ce4c59-cd6d-42db-a442-e0f8a309f020"
    },
    {
      "title": "Sneaker Grip Wipes",
      "body": "Amazing product. I am a zumba instructor and recommend this product very much. My students and I were happy with results. After using them we felt secure on the floor while dancing (laminated floors)",
      "rating": 5,
      "review_date": "2024-07-28 20:33:05 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "selene Hinojosa",
      "reviewer_email": "selenehinojosa1981@gmail.com",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "172.56.81.149",
      "location": "Phoenix, Arizona, United States",
      "metaobject_handle": "review-e0c4c640-bce8-466e-9aea-3d043b9f42da"
    },
    {
      "title": "Product Works But Spray Bottle Clogged",
      "body": "I was unable to use the spray bottle on my footwear. The pump may be clogged. I had to unscrew the bottle and pour a small amount on a paper towel and then apply it to the bottom of my footwear. After it dried I can tell the difference when walking on tiled floors. It does help me to not slip.",
      "rating": 3,
      "review_date": "2024-07-28 23:53:16 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Marsha Jones-Harry",
      "reviewer_email": "marshaharry0118@yahoo.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "24.185.19.74",
      "location": "The Bronx, New York, United States",
      "metaobject_handle": "review-aae56edc-5ba6-4eb0-8a8e-c80656b5ea07"
    },
    {
      "title": "Very good!",
      "body": "The product is exactly what I want. Thank you very much!",
      "rating": 5,
      "review_date": "2024-07-29 18:08:11 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Toshinori Matsuyama",
      "reviewer_email": "tmatsuyama0227@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "68.179.135.124",
      "location": "Canton, Michigan, United States",
      "metaobject_handle": "review-69334a8f-5a44-4a84-a604-253338c783b4"
    },
    {
      "title": "Be a player with the Advant-EDGE",
      "body": "As soon as I put Edge on my sneakers and stepped on the court I noticed a difference right away - it was amazing! This really does work like it says it will. It was easy to use, quick and 100% miraculous. Be the one with the advant-Edge!",
      "rating": 5,
      "review_date": "2024-08-13 00:44:48 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Natalia Hassinger",
      "reviewer_email": "cabrel23@hotmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "69.142.212.58",
      "location": "Moorestown, New Jersey, United States",
      "metaobject_handle": "review-c0b83701-746d-4853-b7f0-28f5b26b775d"
    },
    {
      "title": "Best Product on the Market",
      "body": "Before I used and purchased Edge Wipes my shoe grip was around 4-5 out of 10. With them I feel like I’m at an 12!!!! It’s so simple to use and it works so fast. I’ll be a customer for a lifetime!",
      "rating": 5,
      "review_date": "2024-08-17 23:08:34 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Nate Lewis",
      "reviewer_email": "natel4492@gmail.com",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "Thank you for your review of our Sneaker Grip Wipes! We are thrilled to hear that you are happy with the improvement to your traction. We are committed to providing the best products on the market and we are grateful to have you as a lifelong customer!",
      "reply_date": "2024-09-03 16:17:58 UTC",
      "picture_urls": "",
      "ip_address": "47.230.97.15",
      "location": "Fort Lee, New Jersey, United States",
      "metaobject_handle": "review-7fe85e34-c4c5-4434-9c65-d612e818b279"
    },
    {
      "title": "Basketball players must USE",
      "body": "Great traction improvement!",
      "rating": 5,
      "review_date": "2024-08-21 17:01:41 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Zac MISSLER",
      "reviewer_email": "zmissler@misslerhomes.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "172.56.208.3",
      "location": "Las Vegas, Nevada, United States",
      "metaobject_handle": "review-c277926c-4de2-43d3-a166-7ba137716634"
    },
    {
      "title": "It really works!",
      "body": "Great Product",
      "rating": 5,
      "review_date": "2024-08-28 20:22:51 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Quincy Todd",
      "reviewer_email": "sonofgoldie@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "76.170.62.42",
      "location": "Los Angeles, California, United States",
      "metaobject_handle": "review-f93665b2-8072-4e51-9653-61b659a75ec0"
    },
    {
      "title": "Great!",
      "body": "100% recommend! Works for all shoes!",
      "rating": 5,
      "review_date": "2024-09-03 02:41:06 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Kendall Hicks",
      "reviewer_email": "kendall.hicks2056@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "104.28.32.195",
      "location": "Atlanta, Georgia, United States",
      "metaobject_handle": "review-fb0ed2fd-bab4-472f-b1cf-cc357c684e74"
    },
    {
      "title": "Repeat customer for a great product",
      "body": "My son has used these wipes for over a year, just reloaded our supply. \nAnyone who travels around playing on various courts knows just how bad the surfaces can get after repeated use and no wipe downs in between. These wipes do the job, creating more grip and traction!",
      "rating": 5,
      "review_date": "2024-09-09 18:00:51 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Ryan Glenn",
      "reviewer_email": "ryanmglenn@gmail.com",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "Thank you for the support for so long now!\nWe hate that courts are such a liability, but that's exactly why we spent the last 5 years working on this solution. It's feedback like this that keeps us going, so thank you for sharing your review!",
      "reply_date": "2024-09-09 18:13:27 UTC",
      "picture_urls": "",
      "ip_address": "108.16.53.58",
      "location": "Horsham, Pennsylvania, United States",
      "metaobject_handle": "review-739467aa-4695-4aed-b71c-69957d8c259d"
    },
    {
      "title": "Price and product are spot on",
      "body": "This is one of the best products I have ever seen for the court. The bundle prices just make it even easier to make the purchase.",
      "rating": 5,
      "review_date": "2024-09-22 11:22:56 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Marc Morgan",
      "reviewer_email": "mmorgan@warrenjfk.com",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "76.188.147.107",
      "location": "Niles, Ohio, United States",
      "metaobject_handle": "review-ba55361c-4dcb-4845-80ae-b22cc862fb6b"
    },
    {
      "title": "",
      "body": "Great product!! Our BING BONG team loved how fast it worked and made a difference. 10/10!! Highly recommend. Thanks Edge!",
      "rating": 5,
      "review_date": "2024-09-29 14:47:09 UTC",
      "source": "shop-app",
      "curated": "ok",
      "reviewer_name": "Brian Munoz",
      "reviewer_email": "bmoony42@yahoo.com",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "shop-2519111-160434605-1df798d2-0b82-421d-9b96-74f75c026b91"
    },
    {
      "title": "Changed the game!",
      "body": "No longer worried about slipping, so I can really go for my lunges every time!",
      "rating": 5,
      "review_date": "2024-11-03 02:14:19 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Jessica Dunne",
      "reviewer_email": "jessicadunne17@gmail.com",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "67.81.193.92",
      "location": "Riverside, Connecticut, United States",
      "metaobject_handle": "review-ebf18428-5643-40f2-8fb9-a8bff8f02a0c"
    },
    {
      "title": "",
      "body": "My son loves it!",
      "rating": 5,
      "review_date": "2024-11-07 15:25:46 UTC",
      "source": "shop-app",
      "curated": "ok",
      "reviewer_name": "Kristin Nelson",
      "reviewer_email": "kristinnelson2@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "shop-2519111-166052707-ce4659e8-f52e-4701-8144-fedc1cf9fb1f"
    },
    {
      "title": "Best Stuff on Market!!!",
      "body": "I’m very happy to have been on instagram and randomly found a video for edgespray. I made a decision to check it out and it’s the best decision I’ve made. I’ll be a customer for life .",
      "rating": 5,
      "review_date": "2024-11-12 18:11:09 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Nate Lewis",
      "reviewer_email": "natel4492@gmail.com",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "12.74.62.35",
      "location": "New York, New York, United States",
      "metaobject_handle": "review-f81ca2a2-5617-4d82-92ec-a353cf9e1496"
    },
    {
      "title": "Never received spray",
      "body": "Never received spray only wipes.",
      "rating": 2,
      "review_date": "2024-11-13 18:23:38 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Dawn Garetson",
      "reviewer_email": "chuckdawn@tds.net",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-b1d8edaf-9b2f-4cc6-9e08-d1b561f53835"
    },
    {
      "title": "Great Product and Company",
      "body": "Great costumer service and my boys love the spray that helps them maintain traction on an older floor they practice on.  Thanks!",
      "rating": 5,
      "review_date": "2024-11-19 23:20:17 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Jake Linden",
      "reviewer_email": "jelinden@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "Thank you for your kind words! I'm glad to hear that our Grip Spray has been a hit with your boys and has helped them maintain traction on the practice floor they struggle with. Customer service is probably our top priority outside of constantly improving our products and I'm happy to know that we've met your expectations. Thank you for supporting us on this journey!",
      "reply_date": "2024-11-20 00:41:37 UTC",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-19d23d5d-1681-43f1-884d-7816e7c31fb9"
    },
    {
      "title": "Works well",
      "body": "I purchased this for my 13 yr of son, he likes it and uses it once a day.  He plays at least 3x a day but said it stays well enough on the hardwood courts that he dosen't need to spray again later in the day.  Bad points for glass container and $$",
      "rating": 5,
      "review_date": "2024-11-21 01:20:53 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "bettie austin",
      "reviewer_email": "bettieaustin23@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "Hey Bettie, I'm so glad to hear your son is getting lots of use out of our Sneaker Grip Spray! We use glass in our 2oz bottles to limit the amount of plastics we use for environmental reasons, but we have recently switched our 4oz spray bottles to plastic. If you're interested in the 4oz for your next order, please reach out and I will send you a discount code as a token of my appreciation for your review feedback!\n\n-Zach",
      "reply_date": "2024-11-21 04:43:20 UTC",
      "picture_urls": "",
      "ip_address": "172.56.92.127",
      "location": "San Antonio, Texas, United States",
      "metaobject_handle": "review-4deac654-8a87-4d05-938f-73fe93003438"
    },
    {
      "title": "Shoe Magic",
      "body": "These wipes really work..!! Have 2 basketball players using them this season and they truly help with better traction on the court..!! Definitely will buy more when they run out..!!",
      "rating": 5,
      "review_date": "2024-11-21 14:14:58 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Joni Thorp",
      "reviewer_email": "bigstartx@yahoo.com",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "174.197.5.141",
      "location": "Austin, Texas, United States",
      "metaobject_handle": "review-bd2cdce8-28b1-48cf-b647-b9eac7e69247"
    },
    {
      "title": "Don't go to the court without it",
      "body": "Both of my daughters are using Edge now. It's a must have!",
      "rating": 5,
      "review_date": "2024-11-25 00:58:05 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "David Cline",
      "reviewer_email": "dcline@eastcentralcropservice.com",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "64.184.98.58",
      "location": "Hagerstown, Indiana, United States",
      "metaobject_handle": "review-be82dad8-247c-4c35-b807-499108967a96"
    },
    {
      "title": "Great item to have In Volleyball bag",
      "body": "Love it no need to dust off shoes",
      "rating": 5,
      "review_date": "2024-11-25 15:56:55 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Juan Rivera",
      "reviewer_email": "jrcaal@gmail.com",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "Great to hear that you're enjoying the product for Volleyball and that it helps you avoid having to constantly wipe the dust off your shoes!\n\nThank you for your feedback!",
      "reply_date": "2024-11-25 16:12:18 UTC",
      "picture_urls": "",
      "ip_address": "24.6.247.190",
      "location": "Pittsburg, California, United States",
      "metaobject_handle": "review-405dc120-2d7f-44ad-ba8f-15662af46797"
    },
    {
      "title": "",
      "body": "The wipe didn’t last for the whole practice",
      "rating": 4,
      "review_date": "2024-11-25 23:56:39 UTC",
      "source": "shop-app",
      "curated": "ok",
      "reviewer_name": "Jacqueline WilliamsOlango",
      "reviewer_email": "jawill72@hotmail.com",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "Thank you for supporting our company and for reporting back! Some of our athletes do prefer to reapply halfway through games and practices, especially on excessively dusty courts - I'm glad to see you still enjoyed the product though (given the high rating)!\n\nIf you have any questions or need any help, please feel free to chat with us on our website support chat or on social media!",
      "reply_date": "2024-12-05 06:49:43 UTC",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "shop-2519111-169564499-0f298769-49c2-44d2-ada4-d0a0310a2a3f"
    },
    {
      "title": "",
      "body": "It’s a gift so it has not been used yet!",
      "rating": 5,
      "review_date": "2024-12-07 16:42:33 UTC",
      "source": "shop-app",
      "curated": "ok",
      "reviewer_name": "Donell Merchant",
      "reviewer_email": "merchantdonell@gmail.com",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "shop-2519111-171769837-50ec50ca-cc0b-40c1-9c00-57b7be9701fe"
    },
    {
      "title": "",
      "body": "Works well, kids like the extra grip to help on the court!",
      "rating": 5,
      "review_date": "2024-12-07 18:56:01 UTC",
      "source": "shop-app",
      "curated": "ok",
      "reviewer_name": "Tesha Peterman",
      "reviewer_email": "boatman_tesha@live.com",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "shop-2519111-171795845-9c93d88a-e83f-4209-9804-d794153c32cb"
    },
    {
      "title": "Great for Wrestling",
      "body": "I tried this product to see if it would help with grip while wrestling (heavyweight). I found that with the Edge spray I slip less when executing on mat rolls and am able to get more traction during escapes.",
      "rating": 5,
      "review_date": "2024-12-09 00:52:07 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Robert Ward",
      "reviewer_email": "pyorkward@hotmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "This is awesome to hear! So glad we can help you maintain your footing for wrestling!\n\nThank you for the support 🙏",
      "reply_date": "2024-12-09 04:29:48 UTC",
      "picture_urls": "",
      "ip_address": "75.208.106.48",
      "location": "Nashville, Tennessee, United States",
      "metaobject_handle": "review-0fcf6db4-d68f-4342-93ad-2a51366a5d3b"
    },
    {
      "title": "Great product",
      "body": "This spray works really well. I’d only suggest that when you spray your shoes, do it over a towel or completely off the gym floor as it’s pretty slick if left on the floor. Expensive, but works.",
      "rating": 5,
      "review_date": "2024-12-09 18:56:56 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Katie McCoy",
      "reviewer_email": "woodruffkm@yahoo.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "I'm glad you're happy with your purchase, Katie! In case this is helpful - note that if you do get any on the floor, you can kick your sneakers into it to dry it up the same way we do with sweat when someone falls on the court.\n\nThank you for the feedback and for the suggestions!",
      "reply_date": "2024-12-09 23:29:22 UTC",
      "picture_urls": "",
      "ip_address": "73.103.135.119",
      "location": "Indianapolis, Indiana, United States",
      "metaobject_handle": "review-ccb8c93e-6d37-4303-bd1c-51d755cebd9b"
    },
    {
      "title": "It’s Hands Down A Game Changer‼️",
      "body": "Edge Spray Is For Sure A Must Cop‼️",
      "rating": 5,
      "review_date": "2024-12-10 00:46:52 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Clinton Byrd",
      "reviewer_email": "coachbyrd42@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "104.28.126.141",
      "location": "Huntsville, Alabama, United States",
      "metaobject_handle": "review-880d4787-1b65-4747-a7fa-53a7c74138a6"
    },
    {
      "title": "Not as advertused",
      "body": "Product doesn’t work well or last long. Disappointing.",
      "rating": 1,
      "review_date": "2024-12-11 05:54:59 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Eric Barajas",
      "reviewer_email": "ebar21@aol.com",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "Eric - I'm so sorry to learn about your experience :(\n\nI can usually help you get better use out of the product if you want to reach out to our team@edgespray.com email! If not, I am always happy to honor our money-back guarantee. We are not in the business of taking money from anyone who isn't satisfied with the product!\n\nThank you for the support and let me know if I can help in any other way!",
      "reply_date": "2025-02-17 17:16:52 UTC",
      "picture_urls": "",
      "ip_address": "70.95.192.153",
      "location": "San Diego, California, United States",
      "metaobject_handle": "review-955d1c9c-779b-47ff-8b8e-611453080f7f"
    },
    {
      "title": "",
      "body": "My daughter plays volleyball and I thought this would help her instead of always licking her hands and wiping her shoes, however she says it works but wears off quick.",
      "rating": 2,
      "review_date": "2024-12-11 12:44:05 UTC",
      "source": "shop-app",
      "curated": "ok",
      "reviewer_name": "Nicole Pelzman",
      "reviewer_email": "nickeyp1980@yahoo.com",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "shop-2519111-172664326-41c35e7b-0b85-4424-a847-c0a7e0892047"
    },
    {
      "title": "Son loves them",
      "body": "Son has used them and loves them. They provide the grip he needs on different surface levels (some gyms more slippier than others) and it helps him get better control.",
      "rating": 5,
      "review_date": "2024-12-11 14:34:17 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Shandy",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-d69c1128-f1ff-406c-9c9d-490a06bd6494"
    },
    {
      "title": "Impressed",
      "body": "My 6’4”, 17 year old son is a serious student athlete. He used them this weekend during the Live Period. A teammate of his saw how well his grip was after using it and asked to test one out. My son loves the product. He can speak performance of the product very well. He was impressed!! His teammate had already asked him multiple times where he bought the product at. I bought the wipes because he had some new shoes that didn’t have the best traction on a few courts but they give him the best comfort for a young man that wears a size 15 shoe and makes an impact all over the floor.",
      "rating": 5,
      "review_date": "2024-12-11 14:34:17 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Erik",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-2567720f-eca8-4964-a46e-26930a7a6a31"
    },
    {
      "title": "Work very well",
      "body": "My son has been using it and he says they work very well. Apparently there is a gym he trains in on Tuesdays that never gets cleaned and is extra dirty and dusty. It works great for him there.",
      "rating": 5,
      "review_date": "2024-12-11 14:34:17 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Jeremy",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-2633b656-33e4-44eb-b89b-75c95f6c2aea"
    },
    {
      "title": "Teammates love them too",
      "body": "My son took two with him to practice tonight so he could try one, and he could have one of his friends/teammates try one out as well. They were in their school's new gymnasium for practice today, which is only a couple of years old, only used exclusively for sports, and very well maintained; however, they could still tell that your product (wipes) made a big difference, traction wise. He said they both really liked it!!! I asked him if he would like me to keep buying them for the season and he immediately answered \"yes\". I will definitely be purchasing more soon, along with the spray (just to try out)",
      "rating": 5,
      "review_date": "2024-12-11 14:34:17 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Jason",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-40e5869e-65ea-4c49-9f91-0b9c55bee0b8"
    },
    {
      "title": "Love both the spray and wipes",
      "body": "Love the spray and wipes.  Every training she uses it and can tell a big difference.  She's won a silver and gold individual medal at the club, and just the weekend finished 5th in the U20 nationals here, and was part of the gold medal team.",
      "rating": 5,
      "review_date": "2024-12-11 14:34:17 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Greg",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-8e044d58-d06e-4591-a8aa-69feed72bddf"
    },
    {
      "title": "Hasn’t worked yet",
      "body": "Followed the steps over and over. Reached out to Zach, sent a few emails and then never responded. Just buy the sticky mats and save your $$ in my opinion",
      "rating": 3,
      "review_date": "2024-12-12 01:25:55 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "Rick Leasure",
      "reviewer_email": "rleasure42@live.com",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "Hey Rick,\n\nI'm sorry to see this, but I'm also confused! We have an email thread of 9 emails back and forth, the very first of which I offered to send you a return label if I couldn't help troubleshoot for you. Your last email is on Dec 1, which responded to on Dec 5, then followed up again on Dec 11 because I hadn't heard from you. They are all in the same thread with my Cofounder CC'd on every one of both yours and mine, so I'm not sure why they wouldn't show up in your inbox.\n\nI'm still happy to give you a refund for the inconvenience, just wanted to share my perspective because I take a lot of pride in my customer service and care deeply about each customer!\n\nIf you have any feedback on how I can improve, please let me know and I appreciate you taking the chance on our product either way",
      "reply_date": "2025-02-17 17:24:46 UTC",
      "picture_urls": "",
      "ip_address": "74.141.90.230",
      "location": "Willoughby, Ohio, United States",
      "metaobject_handle": "review-aeee63fe-a889-4076-bffd-eaf9e2698629"
    },
    {
      "title": "",
      "body": "先週末に使ってみましたが、コートでの違いは特に感じませんでした。",
      "rating": 1,
      "review_date": "2024-12-12 18:53:06 UTC",
      "source": "shop-app",
      "curated": "ok",
      "reviewer_name": "Michelle Lee",
      "reviewer_email": "michellelee1028@yahoo.com",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "shop-2519111-173012300-8171bc5b-0901-499f-9c60-5bd0e72898c6"
    },
    {
      "title": "Travel ball",
      "body": "My son plays travel ball and middle school ball so Edge will get a lot of use..",
      "rating": 5,
      "review_date": "2024-12-13 00:51:03 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Christopher",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-756047b9-7bc9-4ad6-98fb-163aacb0d76b"
    },
    {
      "title": "Surprised",
      "body": "My son thinks these are great. He was really surprised how well they worked! He said the wipes are super easy to use. He likes that he can easily keep them in his basketball bag. He also appreciated how quick they were to use and how fast it dried so he can wipe down his shoes just prior to games. Awesome product.",
      "rating": 5,
      "review_date": "2024-12-13 00:51:03 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Karen",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-184f9905-3d78-46e3-a08b-30d54ea3e652"
    },
    {
      "title": "Victory!",
      "body": "I got a lot of great feedback last night at volleyball. They pulled out a 3rd set victory and they loved the extra grip while playing. I can't wait to try these Sunday for bball.",
      "rating": 5,
      "review_date": "2024-12-13 00:51:03 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Marc",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-b62f16bf-9168-49f0-8fa5-64c6c89ace1d"
    },
    {
      "title": "Really like them so far",
      "body": "So far, they've really liked them. During training, it made a definite difference when they were going up the warped wall and going through the jumping spider.",
      "rating": 5,
      "review_date": "2024-12-13 00:51:03 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Noah",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-2eebbf92-caf7-4032-b931-267925958653"
    },
    {
      "title": "Rave reviews",
      "body": "my husband coaches travel basketball teams for both girls and boys and has had my children use them and raves about them.",
      "rating": 5,
      "review_date": "2024-12-13 00:51:03 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "Stephanie",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-6c4b0695-ba3d-4832-9748-61be8d2fdd2f"
    },
    {
      "title": "Works on smooth granite",
      "body": "I used the wipes on some rubber hiking boots before climbing the cables on Half Dome in Yosemite and felt like I had great traction while others were slipping.",
      "rating": 5,
      "review_date": "2024-12-13 00:51:03 UTC",
      "source": "wizard",
      "curated": "ok",
      "reviewer_name": "David",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-0fd9509c-dde4-43ab-9359-a7e69c0e62ef"
    },
    {
      "title": "",
      "body": "They work great my daughter tried at her game other night",
      "rating": 5,
      "review_date": "2024-12-22 05:31:25 UTC",
      "source": "shop-app",
      "curated": "ok",
      "reviewer_name": "WALTER JOHNSON",
      "reviewer_email": "bigwallyjohnson@aol.com",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "shop-2519111-175280890-9beeafc5-9e18-40a4-9f08-c754754702d4"
    },
    {
      "title": "",
      "body": "They are Christmas presents. So I’m not sure yet. Very expensive so far. We’ll see if it lives up to the price tag.",
      "rating": 1,
      "review_date": "2024-12-23 20:31:59 UTC",
      "source": "shop-app",
      "curated": "ok",
      "reviewer_name": "Nicci Mercado",
      "reviewer_email": "nicciwd40@yahoo.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "Hey Nicci, Bumping this in case you had any updates after your niece and nephews tried the product - thanks so much for your support!",
      "reply_date": "2025-01-16 19:03:05 UTC",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "shop-2519111-175577608-5ea7fbb5-ab55-4f06-bc7b-72b54985d868"
    },
    {
      "title": "",
      "body": "제품 효력이 그리 오래 가진 않는 듯",
      "rating": 2,
      "review_date": "2024-12-24 00:31:53 UTC",
      "source": "shop-app",
      "curated": "ok",
      "reviewer_name": "David Lorence",
      "reviewer_email": "dave32880@aol.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "shop-2519111-175628074-83feeafb-8c42-438c-aaa0-1309b32f9277"
    },
    {
      "title": "Several teammates wanted to try, game changer",
      "body": "The edge spray has been a game changer for me. Unfortunately not too long after I used it, I had the bottle in the gym and someone walked off with it. Several of my teammates wanted to try it. We just played a game in an old gym floor that was slippery and I really could have used it.",
      "rating": 5,
      "review_date": "2024-12-24 00:00:00 UTC",
      "source": "judge-me",
      "curated": "ok",
      "reviewer_name": "Ava Reymond",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-5a054531-c528-4e7c-9988-02327c2d3978"
    },
    {
      "title": "Wipes worked super well, friends liked them",
      "body": "wipes worked super well and the girls liked them. Have a tournament this weekend and going to bring for people to try there too!",
      "rating": 5,
      "review_date": "2024-12-24 00:00:00 UTC",
      "source": "judge-me",
      "curated": "ok",
      "reviewer_name": "Ana Stojanovic",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-59cf429e-4eb5-487b-9afc-924cb0ddc777"
    },
    {
      "title": "Works great, improves confidence",
      "body": "It works great! We feel confident knowing we don’t have to worry about slippery floors.",
      "rating": 5,
      "review_date": "2024-12-24 00:00:00 UTC",
      "source": "judge-me",
      "curated": "ok",
      "reviewer_name": "Qeshaun Todd",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-d7f7bff2-59e6-43f1-a6ef-aab4ba8a8227"
    },
    {
      "title": "Game changer, helps with slippery gym floor",
      "body": "Game changer!! Especially because my gyms floor where the bags are is SUPER slippery oddly enough thank you!!",
      "rating": 5,
      "review_date": "2024-12-24 00:00:00 UTC",
      "source": "judge-me",
      "curated": "ok",
      "reviewer_name": "Alaena Vampira",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-c5bb5300-2386-47a0-a75b-c74364f25fcd"
    },
    {
      "title": "Definitely made an improvement",
      "body": "We had a few kids and a few of the experienced fencers try it. I asked them to fence a bout AND then treat their shoes to compare. Definitely made an improvement.",
      "rating": 5,
      "review_date": "2024-12-24 00:00:00 UTC",
      "source": "judge-me",
      "curated": "ok",
      "reviewer_name": "Brad",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-fe79dd9c-d976-43e6-bf59-07cdc2afef22"
    },
    {
      "title": "",
      "body": "제품도 좋고 고객 응대도 최고였습니다!",
      "rating": 5,
      "review_date": "2024-12-26 15:06:31 UTC",
      "source": "shop-app",
      "curated": "ok",
      "reviewer_name": "Lauren Paquette",
      "reviewer_email": "laurenpaquette77@live.com",
      "product_id": 7734929129624,
      "product_handle": "sneaker-sole-grip-spray-4oz",
      "reply": "피드백을 남겨 주셔서 감사합니다. 고객님의 문의 사항에 응대하는 건 저희의 즐거움이죠! \n-Zach",
      "reply_date": "2025-01-06 19:29:53 UTC",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "shop-2519111-176072695-e9f88ad2-3245-427a-bd22-8ade0c880775"
    },
    {
      "title": "",
      "body": "제품 정말 좋네요..",
      "rating": 5,
      "review_date": "2025-01-11 15:27:30 UTC",
      "source": "shop-app",
      "curated": "ok",
      "reviewer_name": "Bobby Kovach",
      "reviewer_email": "bobbylitefit12@gmail.com",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "shop-2519111-179283675-5616e131-3cc8-4700-8b21-07c652eb2d47"
    },
    {
      "title": "",
      "body": "우리 아들들이 이 제품을 완전 좋아해요. 농구 코트에서 미끄럽지 않게 해주거든요. 같은 팀 친구들까지 다 써보고 싶다고 난리였어요. 무조건 재구매할 겁니다!",
      "rating": 5,
      "review_date": "2025-01-13 20:50:30 UTC",
      "source": "shop-app",
      "curated": "ok",
      "reviewer_name": "Kristy Hamm",
      "reviewer_email": "kristy.fischer@hotmail.com",
      "product_id": 7738116505752,
      "product_handle": "sneaker-sole-grip-bundles",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "shop-2519111-179666192-a0fa50af-0f2c-478a-ab31-4ebfe2c25f76"
    },
    {
      "title": "성능은 두 말할 것도 없고 고객 서비스도 최고네요",
      "body": "우리 집 두 아들이 모두 배구를 하는데, 크리스마스 선물로 이 EDGE 스프레이를 받고 나서 사용하더니 완전 푹 빠졌습니다. 미끄럼 방지 효과는 물론 점프력까지 좋아졌다네요. 그리고 문의에도 잘 응대해주고 고객 서비스도 최고였습니다.  \n\nRolanda Wii",
      "rating": 5,
      "review_date": "2025-01-31 17:59:33 UTC",
      "source": "web",
      "curated": "ok",
      "reviewer_name": "Rolanda W Canada ",
      "reviewer_email": "rolandawitt@sasktel.net",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "아드님들이 제품을 잘 활용하고 있다니 정말 기쁩니다!  이렇게 직접 후기 남겨주시고 영상까지 첨부해 주셔서 정말 감사드려요. 친절한 피드백 덕분에 제 한 주가 환해지는 기분입니다. -Zach ",
      "reply_date": "2025-02-04 08:45:36 UTC",
      "picture_urls": "",
      "ip_address": "71.17.210.127",
      "location": "Saskatoon, Saskatchewan, Canada",
      "metaobject_handle": "review-84253be9-2abd-410d-b3d5-044df2641b8b"
    },
    {
      "title": "",
      "body": "사줬더니 제 아들 녀석이 진짜 좋아합니다. 지난 번 마지막 경기 때는 바닥이 미끄러웠는데도 이 스프레이 덕분에 멀쩡할 수 있었죠.",
      "rating": 4,
      "review_date": "2025-02-13 02:55:50 UTC",
      "source": "shop-app",
      "curated": "ok",
      "reviewer_name": "Jill Llewellyn",
      "reviewer_email": "jilliellew1601@gmail.com",
      "product_id": 7728439034008,
      "product_handle": "sneaker-sole-grip-wipes",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "shop-2519111-185433023-bbd3d356-302a-40f5-9268-58834fdff989"
    },
    {
      "title": "골프 그립에 써도 좋습니다",
      "body": "신발 밑창에 그립력을 높여 준다고 하니 골프 그립에도 되지 않을까 해서 써봤습니다. 여름엔 골프만 치거든요 ㅎㅎ ",
      "rating": 5,
      "review_date": "2025-05-21 00:00:00 UTC",
      "source": "judge-me",
      "curated": "ok",
      "reviewer_name": "Kelly R",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "피드백을 공유해주셔서 감사합니다!! 골프 그립에 EDGE를 써본 거의 첫 번째 고객님이시네요. 저희 제품이 골프 클럽 그립력 향상에 도움이 되었다니 감사할 따름입니다.",
      "reply_date": "2025-05-23 22:02:42 UTC",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-ad4328f2-d9b7-4931-8994-ea28d26a5772"
    },
    {
      "title": "축구 장갑에도 효과가 완전 좋아요! ",
      "body": "보통 축구 장갑은 새로 샀을 때만 한두 번 그립감이 좋고 마는데, 이 스프레이 덕분에 이제는 장갑을 쓸 때마다 매번 처음 산 것처럼 공이 손에 촥촥 달라 붙는 걸 느껴요.",
      "rating": 5,
      "review_date": "2025-05-20 00:00:00 UTC",
      "source": "judge-me",
      "curated": "ok",
      "reviewer_name": "Drake L",
      "reviewer_email": "support+anonymous@judge.me",
      "product_id": 6754115092632,
      "product_handle": "sneaker-sole-grip-spray",
      "reply": "소중한 피드백 남겨주셔서 감사합니다!",
      "reply_date": "2025-05-23 22:00:57 UTC",
      "picture_urls": "",
      "ip_address": "",
      "location": "",
      "metaobject_handle": "review-1a95f983-1502-4a97-b9e6-64f9c277490d"
    },
    {
      "title": "진짜 좋아요",
      "body": "정말 좋은 제품입니다. 상세 페이지에 나와 있던 설명 그대로예요. 강력 추천합니다. ",
      "rating": 5,
      "review_date": "2025-05-24 07:02:05 UTC",
      "source": "new-rre-flow",
      "curated": "ok",
      "reviewer_name": "PK Higa",
      "reviewer_email": "3andoutfitness@gmail.com",
      "product_id": 8573934534808,
      "product_handle": "sneaker-grip-bundles-private-reorder",
      "reply": "",
      "reply_date": "",
      "picture_urls": "",
      "ip_address": "66.8.203.193",
      "location": "Makawao, Hawaii, United States",
      "metaobject_handle": "review-f77ad873-e72d-4a6e-8200-7e0c58283ed9"
    }
  ];
}
 
if (Shopify.locale == 'ja') {
  var review_json = [{
   "title": "最高の商品",
   "body": "この商品を作ろうと思いついた人に感謝です！本当に効果があります。",
   "rating": 5,
   "review_date": "2021-11-09 18:58:44 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Sarah Marilyn",
   "reviewer_email": "sarahmarilynsocial@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "174.104.141.156",
   "location": "Stow, Ohio, United States",
   "metaobject_handle": "review-14241e0f-1bd0-4360-aa0b-c1455cdd9fb1"
 },
 {
   "title": "KING Yabbaのフィードバック",
   "body": "私はSonic Artを作る傍ら、多くのバスケットボール選手とも関わっています！個人的に、昨日見た選手たちのいくつかのプレーは、今まで見たことのないものでした。EDGEを使っていない相手と対戦するのを見るのが楽しみです！LOVEをありがとうございます。もっと商品を使っていきたいですし、もっとEDGEファミリーと関わっていけたら嬉しいです！",
   "rating": 5,
   "review_date": "2021-11-11 17:49:38 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "KING Yabba",
   "reviewer_email": "1king.yabba@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "https://s3.amazonaws.com/me.judge.review-images/edge-traction-spray/1636653236__759A5518-B007-4B00-B973-C85787B01C91__original.jpeg, https://s3.amazonaws.com/me.judge.review-images/edge-traction-spray/1636653237__23F0885D-6C42-4E65-8252-F007C9BD5FCC__original.jpeg",
   "ip_address": "98.207.2.216",
   "location": "Daly City, California, United States",
   "metaobject_handle": "review-de0ba3f5-403e-4dc3-bfad-3c8dc55305c8"
 },
 {
   "title": "すばらしい製品！",
   "body": "ボトルからパッケージまで、細部へのこだわりが感じられて気に入っています。見た目が良いだけでなく、効果はそれ以上です。粘着マットや手をなめる方法よりもずっと優れた選択肢です。",
   "rating": 5,
   "review_date": "2021-11-17 02:54:26 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Michael Barajas",
   "reviewer_email": "michaelbarajas22@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "76.182.193.217",
   "location": "Carrollton, Texas, United States",
   "metaobject_handle": "review-24749f2b-5dd4-41f3-863d-aca653fcc7af"
 },
 {
   "title": "最高のスプレー！",
   "body": "すべりやすい床でもしっかりグリップします。リサイクル可能なパッケージも気に入っています。",
   "rating": 5,
   "review_date": "2021-12-05 16:52:34 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Cynthia",
   "reviewer_email": "keckles2112@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "174.197.140.238",
   "location": "Brooklyn, New York, United States",
   "metaobject_handle": "review-6e55fcac-7cbc-4c55-89bb-646b41998ba1"
 },
 {
   "title": "John hall",
   "body": "私は大学のバスケットボール選手です。練習用の古い靴でこの製品を試してみたところ、グリップが新品のように感じられました。",
   "rating": 5,
   "review_date": "2022-01-20 04:53:39 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "John Hall",
   "reviewer_email": "halljohnathan58@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "65.254.30.118",
   "location": "Lowell, Massachusetts, United States",
   "metaobject_handle": "review-557e63db-3e2a-4a6d-84c6-ecd1c4f2831d"
 },
 {
   "title": "普通の靴が室内用スパイクのような履き心地に、スニーカー好きも安心",
   "body": "Edgeスプレーのおかげで、どんな床の状態でも、どんな靴を履いていても、自分らしいプレーができます。私はよく卓球クラブに参加しますが、床の手入れが行き届いていない場所でプレーすることが多いです。人の出入りも多いので滑りやすく、足をしっかり踏ん張って鋭い動きをするのは、まるで滑り台の上に立っているような状態です。試合中は点を取るごとにウェットティッシュで靴の裏を拭いていましたが、ホコリっぽい床のせいですぐにまた滑りやすくなっていました。Edgeスプレーを使うと、水で靴を拭くのとは比べものにならないほどグリップ力が強くなります。ホコリっぽい床で数分プレーした後も、靴を拭いたばかりのようにグリップが効き、しかも水拭きするよりも長持ちします。より高い靴に使うのは、なにか影響がないか心配していましたが、スプレーする前と見た目も履き心地もまったく変わらず、変わったのはグリップ力だけでした。まさに魔法のボトルです！",
   "rating": 5,
   "review_date": "2022-01-26 23:53:44 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Michael Bronikowski",
   "reviewer_email": "mbronik1@binghamton.edu",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "149.125.21.113",
   "location": "Binghamton, New York, United States",
   "metaobject_handle": "review-b7706672-a8b8-4de4-84b2-82063c1237b5"
 },
 {
   "title": "",
   "body": "最高",
   "rating": 5,
   "review_date": "2022-02-22 16:04:39 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Jacob Howard",
   "reviewer_email": "jacobhoward47@aol.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "209.175.44.33",
   "location": "Chicago, Illinois, United States",
   "metaobject_handle": "review-69ae9eec-e665-4082-a6bc-ebffe9945b74"
 },
 {
   "title": "最高の製品",
   "body": "最初は半信半疑でしたが、本当に効果があり、使ってみてよかったと思いました。私はD2 NCAA男子バレーでプレーしていますが、この製品のおかげでプレーが変わりました。",
   "rating": 5,
   "review_date": "2022-03-24 01:04:37 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Jamesly Metayer",
   "reviewer_email": "jameslymetayer123@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "50.231.95.206",
   "location": "Jacksonville, Florida, United States",
   "metaobject_handle": "review-a48722a2-6eca-42ee-a398-8fc5c33f86bf"
 },
 {
   "title": "絶対に使うべきです！！！！",
   "body": "選手たちがグリップのために手で靴底をこするのをやめさせて、EDGEスプレーを使ってください。これが一番です！",
   "rating": 5,
   "review_date": "2022-03-26 21:17:40 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Adriana Sheri",
   "reviewer_email": "adrisheri@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "174.193.130.105",
   "location": "Los Angeles, California, United States",
   "metaobject_handle": "review-59c68660-dd9f-4335-a189-c5ee77f36166"
 },
 {
   "title": "完璧な購入品",
   "body": "久しぶりにコートに戻り、Edgeスプレーを使ってみましたが、本当に効果抜群です！グリップ力がほとんどなくなったかなり古いバレーボールシューズを使っていましたが、しっかりグリップして、床を蹴るときの「キュッ」という音まで鳴って、驚きました。古い靴でこれだけグリップが効くようになるなら、新しい靴ならさらにすごいはずです！完璧な購入品です！",
   "rating": 5,
   "review_date": "2022-04-07 21:44:47 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Fabiola Garcon",
   "reviewer_email": "fabgar14@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "24.218.247.136",
   "location": "Brockton, Massachusetts, United States",
   "metaobject_handle": "review-a3e1c886-f26a-4ab0-89de-222fc4f72dee"
 },
 {
   "title": "衝撃的な商品",
   "body": "最高の素材で作られた商品のひとつで、本当に度肝を抜かれます。たった2回スプレーするだけで準備が完了し走り出すことができて、しかも効果はしばらく続きます。絶対に買うべきです。冗談抜きで、商品説明の通りしっかり効果があります。",
   "rating": 5,
   "review_date": "2022-04-28 01:49:38 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Jimmy",
   "reviewer_email": "jimmyninjas2@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "https://s3.amazonaws.com/me.judge.review-images/edge-traction-spray/1651110578__image__original.jpg",
   "ip_address": "96.227.100.175",
   "location": "Allentown, Pennsylvania, United States",
   "metaobject_handle": "review-6ec81bb2-771e-4f21-a4a6-c34a1de22d0d"
 },
 {
   "title": "EDGEスプレー",
   "body": "まず、パッケージがとても気に入りました。とてもステキで安全な作りです。屋内コートで試してみましたが、完璧に期待通りの効果を実感しました。使用前と使用後で違いをはっきり感じます。総じて素晴らしい製品で、友人たちにも絶対におすすめします。",
   "rating": 5,
   "review_date": "2022-05-01 21:15:57 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Jimmy",
   "reviewer_email": "jimmyninjas2@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "174.198.9.227",
   "location": "Philadelphia, Pennsylvania, United States",
   "metaobject_handle": "review-36420699-b5f0-435e-85ce-30221424068c"
 },
 {
   "title": "よりよいグリップ",
   "body": "床が常にきれいとは限らない中でも、グリップ力が向上したのを実感できたそうです。",
   "rating": 5,
   "review_date": "2022-07-20 20:34:34 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Kevin Kovacs",
   "reviewer_email": "kevin.kovacs@gallaudet.edu",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "174.195.200.54",
   "location": "Chino, California, United States",
   "metaobject_handle": "review-fe527cec-e2e2-4179-a3bf-cef5f5ae71eb"
 },
 {
   "title": "驚きのグリップ力",
   "body": "これまでは毎試合、粘着マットを繰り返し使ったり、効果がないと思ってシートを破ってしまったりしていましたが、EDGE を使うようになってからは、コート上でも効果をしっかり実感できるようになりました。今では毎試合前にいつも使うようになっています。",
   "rating": 5,
   "review_date": "2022-07-31 14:19:21 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Tom Tran",
   "reviewer_email": "coacht2@yahoo.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "73.220.52.162",
   "location": "Rancho Cordova, California, United States",
   "metaobject_handle": "review-c7bf3423-5174-41e0-ab5a-97fc2fc926ed"
 },
 {
   "title": "乾き＋グリップ＋持続力",
   "body": "私は機能的トレーニングを取り入れたウェイトリフティングをよく行うのですが、EDGEはバランス系のトレーニングで大活躍しました！多くの場合、バランスが崩れる原因は自分の体ではなく、靴のグリップにあると思います。EDGE を使うことで、その問題を解決できます。もう滑ってしまうことはありません。ただ、スプレーの乾きがより早く、持続時間がより長くなるといいなと思います。再度スプレーする必要はありますが、その価値は十分あります ;)",
   "rating": 4,
   "review_date": "2022-08-15 16:13:51 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Ariel Schulze",
   "reviewer_email": "arielbschulze@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "24.30.36.110",
   "location": "Atlanta, Georgia, United States",
   "metaobject_handle": "review-039a323e-6fcb-4504-b329-9aba4bdeed41"
 },
 {
   "title": "Edgeのグリップスプレー、ゲームチェンジャー！",
   "body": "このスプレーは、自分のプレーに足りなかったものをプラスしてくれます。コートに立ったとき、ミスの原因になる要素が一つ消えることで、プレー全体のレベルが上がるのを実感します。滑らないという安心感と、動きの正確さ、安定感が自信につながります。どんなコートでプレーするアスリートにも、自分への投資としてEdgeスプレーを強くおすすめします！",
   "rating": 5,
   "review_date": "2022-08-15 21:38:59 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Demonte Denzel Flannigan",
   "reviewer_email": "flannigandemonte@yahoo.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "https://s3.amazonaws.com/me.judge.review-images/edge-traction-spray/1660599777__fdd06f41-b6dc-437e-8d31-c3c2c0f8aa40__original.jpeg",
   "ip_address": "188.27.106.129",
   "location": "Craiova, Dolj, Romania",
   "metaobject_handle": "review-67102e68-7154-4ff6-8e7e-3061e0d87fa5"
 },
 {
   "title": "Great Product",
   "body": "Easy to use, reliable for games on end, adds great traction for dusty surfaces or even semi-worn shoes, portable and accessible making it the best thing I’ve used since…EVER. Nothing on the market compares to this product tbh. Glad I copped",
   "rating": 5,
   "review_date": "2022-10-02 23:19:21 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Zay",
   "reviewer_email": "brolicbyzay@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "167.160.130.80",
   "location": "Washington, District of Columbia, United States",
   "metaobject_handle": "review-c682c69d-34bb-41bf-bdc7-2a52299efd61"
 },
 {
   "title": "Wow",
   "body": "This Stuff is Awesome!!!  They even help older shoes that used to basketball become relevant again!!!  Kobe 5 OG with some really worn down outsoles once again became alive with Edge Spray!!!",
   "rating": 5,
   "review_date": "2022-11-21 19:49:27 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Rod ",
   "reviewer_email": "rbowers@augusta.k12.va.us",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "216.12.45.75",
   "location": "Staunton, Virginia, United States",
   "metaobject_handle": "review-7a25272e-7624-436c-a390-c09ba499c009"
 },
 {
   "title": "Must cop",
   "body": "Love this spray got instant grip after using it on multiple sneaker brands",
   "rating": 5,
   "review_date": "2022-12-05 01:27:50 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Brent Emelander",
   "reviewer_email": "soledoutyt@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-d92ece71-8579-466c-a0eb-7f0bd60dc9bb"
 },
 {
   "title": "Amazing Product",
   "body": "I’ve never tried a grip spray before. This product is amazing. After 3 to 4 sprays to each shoe, the traction improved amazingly and I could feel the confidence I need it.",
   "rating": 5,
   "review_date": "2023-01-07 23:54:41 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Jaime Sotelo",
   "reviewer_email": "jimmy.curry05@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "187.190.5.245",
   "location": "Ciudad Juárez, Chihuahua, Mexico",
   "metaobject_handle": "review-c3295dbe-d914-4677-96ee-91e26ed4e3ea"
 },
 {
   "title": "Must have",
   "body": "The DeSoto Lady Eagles do not take the court without having our Edge;)",
   "rating": 5,
   "review_date": "2023-02-03 04:45:10 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Kadi Creel",
   "reviewer_email": "kadi.creel@desotoisd.org",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "70.143.103.163",
   "location": "DeSoto, Texas, United States",
   "metaobject_handle": "review-0efe7678-3210-4363-898b-d71a9584a0aa"
 },
 {
   "title": "No more slipping!",
   "body": "Everytime my son slips and falls at basketball practice, I hold my breath. I don’t even let him get on the court without spraying his shoes anymore. I just wish it came in a bigger size, we’re almost finished with the first bottle already.",
   "rating": 5,
   "review_date": "2022-01-14 00:20:34 UTC",
   "source": "judge-me",
   "curated": "ok",
   "reviewer_name": "Marie",
   "reviewer_email": "mtkecko16@aol.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-cb18b95b-b1f6-4178-8e46-663eae31ce81"
 },
 {
   "title": "Tested on rock climbing shoes",
   "body": "Outside of its current market - if you are a rock climber struggling with grip indoor or outdoor, Edge Spray may be what you are looking for.\nGrip is no joke, significantly increases grip on very small footchips to climb on, and has this \"sticky\" feel to it without actually being \"sticky.\" Best use is within first 20 mins in my opinion. Can seriously step up your game if needed for a very difficult climb. Quickly dries just like the instruction says, and you’re good to climb with great grip soon after.",
   "rating": 5,
   "review_date": "2022-01-20 00:22:04 UTC",
   "source": "judge-me",
   "curated": "ok",
   "reviewer_name": "Jonathan Kwan",
   "reviewer_email": "jkwan11@binghamton.edu",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-d59105bc-8f00-4e1d-b997-0212497f67d9"
 },
 {
   "title": "Great for Workouts",
   "body": "This product is amazing for when I’m taking workout classes in the gym. I’m always concerned about losing my footing on a move or slipping in plank positions. One less thing to worry about.",
   "rating": 5,
   "review_date": "2022-01-17 16:50:34 UTC",
   "source": "judge-me",
   "curated": "ok",
   "reviewer_name": "James K.",
   "reviewer_email": "jimkeck21@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-6c36f41d-14ac-4439-9267-320bc92ec27e"
 },
 {
   "title": "I like this product",
   "body": "I just tried it and I love it! I like how it works and there is not slippage when I am doing suicides.",
   "rating": 5,
   "review_date": "2023-03-15 17:14:11 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Holly Howard",
   "reviewer_email": "hrhoward@hotmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "50.51.120.186",
   "location": "Huron, Ohio, United States",
   "metaobject_handle": "review-e5acdb4f-93ec-4112-afea-fd849c7bb890"
 },
 {
   "title": "Great improvement on fencing shoe grips",
   "body": "Recently I bought three bottle of the spray and used on my fencing shoes on aluminum strip, the shoe grip was improved dramatically and never slipped. I recommend this product to my team players!",
   "rating": 5,
   "review_date": "2023-03-29 03:47:19 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Hui Liu",
   "reviewer_email": "hui007@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "67.221.143.36",
   "location": "Nevada, Texas, United States",
   "metaobject_handle": "review-aeed1554-65cc-4b38-b67b-f1498b9f342f"
 },
 {
   "title": "Spray Works",
   "body": "Nothing over the top and its gets the job done.",
   "rating": 5,
   "review_date": "2023-04-16 20:40:02 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Tamba Tongu",
   "reviewer_email": "tambatongue@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "76.169.65.24",
   "location": "Los Angeles, California, United States",
   "metaobject_handle": "review-30d65239-bfeb-4619-b0aa-9008b07c4100"
 },
 {
   "title": "Edge Spray",
   "body": "I absolutely love this shirt. When I got it I, no joke, wore it for four days straight. It feels so comfortable and airy. It feels great to wear for lifting. Love this product.",
   "rating": 5,
   "review_date": "2023-04-25 22:57:04 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Josh Weyerhaeuser",
   "reviewer_email": "joshuaweyerhaeuser@gmail.com",
   "product_id": 7579537309848,
   "product_handle": "edge-vintage-crewneck-tee",
   "reply": "Wow, so glad to hear this. We totally geeked out on the material to make them look + feel like a vintage shirt you've had for years, while feeling fresh and clean. Enjoy!",
   "reply_date": "2023-08-04 19:28:50 UTC",
   "picture_urls": "",
   "ip_address": "134.139.201.17",
   "location": "Long Beach, California, United States",
   "metaobject_handle": "review-31b66e3e-552f-464c-91b8-fd79df69d35f"
 },
 {
   "title": "",
   "body": "Shoe Sole Grip Spray",
   "rating": 5,
   "review_date": "2023-05-20 16:51:10 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Vivie Tims",
   "reviewer_email": "vivietims072@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-d77067fa-076d-4548-8a45-1d6d3364f8e7"
 },
 {
   "title": "Love it",
   "body": "Very good quality and sticks very well to surfaces",
   "rating": 5,
   "review_date": "2023-05-25 12:19:41 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Vivie Tims",
   "reviewer_email": "vivietims072@gmail.com",
   "product_id": 7579530559640,
   "product_handle": "stickers",
   "reply": "We love to hear it!",
   "reply_date": "2023-08-04 19:29:49 UTC",
   "picture_urls": "",
   "ip_address": "104.58.145.226",
   "location": "Mobile, Alabama, United States",
   "metaobject_handle": "review-e0b73a72-0b38-49e3-8980-6bd0e18f62da"
 },
 {
   "title": "Great stuff",
   "body": "Very impressive stuff.  Keeps the rubber of your shoes soft and sticky.  I would recommend.",
   "rating": 5,
   "review_date": "2023-07-02 16:45:12 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Ryan Cueni",
   "reviewer_email": "iroscoi@yahoo.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "40.136.120.114",
   "location": "Ashtabula, Ohio, United States",
   "metaobject_handle": "review-eb599a61-0fa5-42c2-ac07-0b5e80a86ae2"
 },
 {
   "title": "Getting better traction while fencing",
   "body": "I have recently started using Edge spray on my fencing shoes for safety reasons. The spray applied to the shoes sole ensured non-slippery fencing and better traction on the strip. Highly recommend it to any fencer who competes.",
   "rating": 5,
   "review_date": "2023-07-06 06:27:19 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Oleg Rusanov",
   "reviewer_email": "ovr_1973@yahoo.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "Awesome to hear. Thank you for taking the time to fill out a review, Oleg!",
   "reply_date": "2023-08-04 19:26:16 UTC",
   "picture_urls": "",
   "ip_address": "70.163.118.56",
   "location": "Phoenix, Arizona, United States",
   "metaobject_handle": "review-48dc64bf-48cc-4b2b-a862-eb027f444ba1"
 },
 {
   "title": "We Are Sticking With Edge!",
   "body": "This has been awesome for our fencing club. We fence on some slicker gym floors and this gives us the confidence and consistency we need. Thank you Zach!\nlowcountry fencers HHI • SC",
   "rating": 5,
   "review_date": "2023-07-12 19:26:00 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Patricia Wilkens",
   "reviewer_email": "wilkenspw@aol.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "We're very happy to hear that EDGE helped you grip the floor better despite the slick conditions. This is exactly why we do what we do. If anything else comes up, feel free to email me: zach@edgespray.com",
   "reply_date": "2023-08-04 19:16:53 UTC",
   "picture_urls": "",
   "ip_address": "173.207.193.46",
   "location": "Hilton Head Island, South Carolina, United States",
   "metaobject_handle": "review-7658792c-6ded-4dc9-836d-752cb542e739"
 },
 {
   "title": "ELITE!",
   "body": "Works like a dream! I'm 100% buying more as SOON as I get low. This is a must at every gym for the rest of my existence. Helps tremendously on bad courts and makes clean court experiences even better. Maybe my best purchase this year. No lie. Don't hesitate. Buy yours NOW!",
   "rating": 5,
   "review_date": "2023-08-03 20:41:10 UTC",
   "source": "email",
   "curated": "ok",
   "reviewer_name": "Del Von Lott Jr",
   "reviewer_email": "cuseboy211@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "We're so glad to hear this, thanks for taking the time to let us know! If anything else comes up, feel free to email me directly: zach@edgespray.com.",
   "reply_date": "2023-08-04 19:25:40 UTC",
   "picture_urls": "",
   "ip_address": "99.90.19.182",
   "location": "Midwest City, Oklahoma, United States",
   "metaobject_handle": "review-c49841ff-cce4-41af-a69a-8a5b06355318"
 },
 {
   "title": "",
   "body": "This stuff is amazing and truly a game changer for athletes, especially basketball players. We had been using grip spritz in my program, which is solid, but this is next level. Not only is it the most effective grip spray/grip product we have ever used, it is the easiest to use....no mat, no need to dry with a towel after applying, etc. You simply spray the bottom of each shoe 2-3 times, stomp each foot on the court/surface a few times, and BOOM, grip magic!",
   "rating": 5,
   "review_date": "2023-08-30 00:00:00 UTC",
   "source": "direct",
   "curated": "ok",
   "reviewer_name": "Eric Bullis",
   "reviewer_email": "bullis@campwildwood.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "Thanks Eric, we're always happy to hear positive feedback about our formula's drying time! We spent a *ton* of time in the lab to get it right and it's feedback like this that makes it all feel worth it. If anything else comes to mind, don't hesitate to email me at zach@edgespray.com.",
   "reply_date": "2023-09-01 17:51:57 UTC",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-9a4e9827-5866-4e38-8771-049f561c711b"
 },
 {
   "title": "",
   "body": "Great product",
   "rating": 5,
   "review_date": "2023-11-09 12:51:17 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Bernard Bowen",
   "reviewer_email": "bernardbowen825@gmail.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "174.198.6.215",
   "location": "Philadelphia, Pennsylvania, United States",
   "metaobject_handle": "review-57284e75-dbbe-4d31-8a27-0f86d874377e"
 },
 {
   "title": "Ari's Review",
   "body": "I love using EDGE spray for my sport (fencing). I got an order of the wipes as well, and have enjoyed those! I prefer the spray, but that's just me. Definitely worth a try for anyone who plays an indoor court sport.",
   "rating": 5,
   "review_date": "2023-11-19 03:00:56 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Ariel Simmons",
   "reviewer_email": "arieljsimmons@gmail.com",
   "product_id": 7736772952216,
   "product_handle": "edge-wipes-sample",
   "reply": "Thanks for sharing your experience, Ari! And I’m glad to hear that you’re getting use out of both the spray and the wipes!",
   "reply_date": "2023-11-25 22:39:37 UTC",
   "picture_urls": "",
   "ip_address": "74.142.216.242",
   "location": "Cleveland, Ohio, United States",
   "metaobject_handle": "review-013eae7a-d51f-4037-af5d-75e8e09d2c32"
 },
 {
   "title": "Game changer for middle school gyms",
   "body": "This stuff works! Middle school gyms are notoriously awful leaving basketball players sliding all over. This stuff is a game changer even on dusty/dirty MS courts.",
   "rating": 5,
   "review_date": "2023-11-21 13:04:13 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Shelly Hinz",
   "reviewer_email": "hinzshelly@gmail.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "Thanks Shelly! Middle school courts are a nuisance at best, and a liability at worst. I'm glad we could help out!",
   "reply_date": "2023-11-21 20:31:45 UTC",
   "picture_urls": "",
   "ip_address": "216.51.245.168",
   "location": "Maquoketa, Iowa, United States",
   "metaobject_handle": "review-b2c43df7-6f29-40f7-a4ec-a1589ae00faf"
 },
 {
   "title": "",
   "body": "The spray has helped provide greatest grab for my son’s shoes on the basketball court.",
   "rating": 5,
   "review_date": "2023-11-27 19:23:29 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Caleb Smith",
   "reviewer_email": "caleb_s51@hotmail.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "184.151.190.146",
   "location": "Toronto, Ontario, Canada",
   "metaobject_handle": "review-92d2dc29-717f-420c-bd9e-1060af8ee148"
 },
 {
   "title": "Kids love it",
   "body": "My kids love the edge sneaker grip . They say it helps playing basketball so much",
   "rating": 5,
   "review_date": "2023-11-29 15:05:35 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Charlene Thomas",
   "reviewer_email": "charct81@gmail.com",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "68.199.18.122",
   "location": "East Hampton, New York, United States",
   "metaobject_handle": "review-eae7a290-6654-4d32-9ea7-305fc20b65e4"
 },
 {
   "title": "",
   "body": "Works well. The performance might vary depending on the court cleaness but the spray it self provide extra but to the court. Recommended!",
   "rating": 5,
   "review_date": "2023-04-03 17:32:39 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Sunghoon Lee",
   "reviewer_email": "iamsunghoonlee@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-12099108-341b69c7-52ff-4146-9bad-29bad740189f"
 },
 {
   "title": "",
   "body": "I think it doesn’t really make a difference it just picks up more dust. And to small of a bottle",
   "rating": 3,
   "review_date": "2023-05-08 22:59:50 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "PJ MacGregorV",
   "reviewer_email": "pjmacgregorfive@icloud.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-13124406-73dd4312-9ae1-4b09-975c-53be447a292f"
 },
 {
   "title": "",
   "body": "So far it’s awesome. I used it one time for a few hours on Air Max Uptempo 97’s on a pretty dirty wood court and my traction was much better.",
   "rating": 5,
   "review_date": "2023-09-25 16:11:18 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Robert Medina",
   "reviewer_email": "dreu-77@hotmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-37658316-8d054580-5d2d-4b72-a848-c8303fc30631"
 },
 {
   "title": "",
   "body": "This stuff is legit.  Works on the dirtiest, dustiest middle school courts.",
   "rating": 5,
   "review_date": "2023-11-23 21:17:40 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Shelly Hinz",
   "reviewer_email": "hinzshelly@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-53973786-cf4ddc31-cecb-4201-b506-f34f7ba8dec4"
 },
 {
   "title": "",
   "body": "Helpful! Thanks!",
   "rating": 5,
   "review_date": "2023-11-29 00:06:19 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Amanda Fox",
   "reviewer_email": "alover76@yahoo.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-54903301-6b8ca4ca-4c0f-45d3-989e-8fc6c47e31bd"
 },
 {
   "title": "The team loves it!",
   "body": "My son took his bottle of Edge to basketball practice and said everyone wanted to use it.  It's now part of our basketball bag for all games!   Some of these basketball floors have traction issues even for new shoes so this is great to have on hand!",
   "rating": 5,
   "review_date": "2023-12-01 15:25:14 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Caren Drinkard",
   "reviewer_email": "gripper28@yahoo.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "That's amazing to hear that EDGE was in high demand! So glad we can help your son and his team with the traction issues on those floors!",
   "reply_date": "2023-12-08 16:14:22 UTC",
   "picture_urls": "",
   "ip_address": "69.140.144.178",
   "location": "Charlotte Hall, Maryland, United States",
   "metaobject_handle": "review-cb744932-4b74-4a4c-8ba0-258dc710bcac"
 },
 {
   "title": "",
   "body": "Love the bottle and love the grip it provides.",
   "rating": 5,
   "review_date": "2023-12-08 05:37:24 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Justin Naab",
   "reviewer_email": "jnaab@naabtrade.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "107.9.211.81",
   "location": "Newburgh, Indiana, United States",
   "metaobject_handle": "review-32328f73-24f6-48cf-80fd-0931cd8725b0"
 },
 {
   "title": "It Really Works!",
   "body": "Just got this stuff. WOW. It really works. Where I live courts are terrible in the winter with all the salt and dust. I no longer have to worry about thwe poor court conditions now that I'm using Edge!!. A+",
   "rating": 5,
   "review_date": "2023-12-13 01:10:42 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Adrian Hall",
   "reviewer_email": "jeff@empirelocates.com",
   "product_id": 7736772952216,
   "product_handle": "edge-wipes-sample",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "99.83.63.143",
   "location": "Louisville, Kentucky, United States",
   "metaobject_handle": "review-6b64a80e-75d5-4b2b-a067-0c21d441fbb9"
 },
 {
   "title": "",
   "body": "動画のような効果は感じられませんでした。靴底にスプレーしましたが、グリップ力が増した感じは特にありませんでした。",
   "rating": 1,
   "review_date": "2023-12-14 05:21:25 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Kristen Hanson",
   "reviewer_email": "jerseygrl884@yahoo.com",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "Hey Kristen, \n\nI'm so sorry your experience didn't meet expectations! I tried reaching out a few times to learn more about your experience, but I haven’t heard back from you and I see you left 2 separate reviews back to back.\n\nThere are lots of factors that influence each experience, such as: sneaker outsole material, court conditions, and how long you allow the formula to soak into the rubber, etc. and I can help you get the most out of your purchase.\n\nI take the customer experience very seriously, if you can please reach out! My email is zach@ edgespray .com and I can also send you my cell # if that is easier. \n\nBest,\nZach",
   "reply_date": "2024-01-13 21:54:34 UTC",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-68637879-5b92bba5-3a9f-4a57-b9ca-8d86c07cca5c"
 },
 {
   "title": "",
   "body": "違いが感じられませんでした。",
   "rating": 1,
   "review_date": "2023-12-14 05:21:58 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Kristen Hanson",
   "reviewer_email": "jerseygrl884@yahoo.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-68637952-cf530c6b-d8b5-45f5-b330-08d281aff09e"
 },
 {
   "title": "Gift for son",
   "body": "My teen asked for this for Christmas and I’m sure he’s going to be psyched to have a bottle of his own for his next game. Also Zach provided the most amazing customer service any consumer could ask for! ",
   "rating": 5,
   "review_date": "2023-12-22 01:57:54 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Lexi Forrest",
   "reviewer_email": "strykersmomma85@gmail.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "This is great to hear! Feel free to contact me anytime you need anything.\n\nMerry Christmas to you and your family!",
   "reply_date": "2023-12-25 22:57:25 UTC",
   "picture_urls": "",
   "ip_address": "174.168.2.195",
   "location": "Bethel, Connecticut, United States",
   "metaobject_handle": "review-954b7987-1160-43c0-867e-95465fde711e"
 },
 {
   "title": "IT WORKS",
   "body": "My kid said he has great traction and no longer slips on his school’s court (which desperately needs to be waxed).",
   "rating": 5,
   "review_date": "2024-01-05 02:13:16 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Jodie Farrow",
   "reviewer_email": "jodie.farrow@yahoo.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "73.226.42.86",
   "location": "Camden, New Jersey, United States",
   "metaobject_handle": "review-b282871a-3c2d-4b05-99be-97a320fde4b2"
 },
 {
   "title": "",
   "body": "Works well, good grip, cuts through dust",
   "rating": 5,
   "review_date": "2024-01-09 20:16:25 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Jaden Chen",
   "reviewer_email": "jadenchen1213@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-111240793-bb4b9688-a3db-443d-962e-9842dba45df8"
 },
 {
   "title": "Pretty dope product!",
   "body": "I tried this out the other day during my volleyball practice, and I was confused at first because i needed to let it dry for a second. But right when I hit the court, the grip was insane! I actually really enjoy this product!",
   "rating": 4,
   "review_date": "2024-01-13 17:38:07 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "brooke whitlock",
   "reviewer_email": "brookewhitlock5@gmail.com",
   "product_id": 7736772952216,
   "product_handle": "edge-wipes-sample",
   "reply": "Thank you for sharing your feedback, Brooke! You're absolutely right, the formula needs about 15 seconds on average to soak into the rubber outsole, before kicking your sneakers against the floor to lock in the grip.\n\nI'm so glad you're getting use out of the product!",
   "reply_date": "2024-01-19 20:14:58 UTC",
   "picture_urls": "",
   "ip_address": "139.60.13.108",
   "location": "Ogden, Utah, United States",
   "metaobject_handle": "review-3609ce57-dca9-4483-a0c2-f3322d55f224"
 },
 {
   "title": "Edgeは私に大きな変化をもたらしてくれました。大好きです!!!",
   "body": "こんにちは。私はフェンシング選手なのですが、この製品は本当に大きな変化を私にもたらしてくれました。プエルトリコ代表として試合をしていたとき、かなり滑ってしまっていることに気づきました。湿気が多く、屋外での試合だったので、ストリップが滑りやすくなっていたのだと思います。Edgeを使い始めてからは、滑ることがほとんどなくなりました。今ではどの大会でも使っています。滑ることはケガにつながるし、EDGEを使うことでそれを防げるので、もう手放せません。ありがとう、Edge。Gabi Hwangより",
   "rating": 5,
   "review_date": "2024-01-20 09:11:53 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Jamarys Hwang",
   "reviewer_email": "jamarysvaz@yahoo.com",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "Hi Gabi, thank you for taking the time to leave a review for our Sneaker Grip Bundles. I am so glad to hear that our product has made a huge difference for you in your fencing competitions. I understand the importance of having a secure grip on the strips, and we are happy that our product has helped you with that. Thank you for choosing EDGE and we wish you all the best in representing Puerto Rico. Keep on fencing!",
   "reply_date": "2024-02-08 23:08:58 UTC",
   "picture_urls": "https://s3.amazonaws.com/me.judge.review-images/edge-traction-spray/1705767711__img_5674__original.jpeg",
   "ip_address": "174.197.74.93",
   "location": "Dallas, Texas, United States",
   "metaobject_handle": "review-366ede25-3473-43f1-9909-7693f2d6f2c2"
 },
 {
   "title": "Squeak! Squeak!",
   "body": "This product is sensational, my shoes are able to perform on the dustiest basketball courts which helps since most players now have a stop & go playing style, I’m back to bringing the clamps! Thank you.",
   "rating": 5,
   "review_date": "2024-01-26 18:21:53 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Tyshan Jones",
   "reviewer_email": "jones90la@yahoo.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "Thank you for your glowing review of our Sneaker Sole Grip Spray! We're thrilled to hear that it's helping you dominate on the defense, even on the dustiest of surfaces. Keep bringing the clamps and thank you for choosing our product!",
   "reply_date": "2024-02-08 23:25:54 UTC",
   "picture_urls": "",
   "ip_address": "104.28.85.132",
   "location": "Los Angeles, California, United States",
   "metaobject_handle": "review-39ef852d-028c-4849-9273-032e15a66d06"
 },
 {
   "title": "Great product",
   "body": "Great product and customer service even got free wipes for being in the military which is always nice thank you",
   "rating": 5,
   "review_date": "2024-01-28 04:51:35 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Nathaniel McCampbell",
   "reviewer_email": "nathanmccampbell7@gmail.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "Thank you for your review, Nathaniel! It's my pleasure to support our military members and I hope the wipes come in handy for you. Thank you for your service!",
   "reply_date": "2024-02-08 23:06:58 UTC",
   "picture_urls": "",
   "ip_address": "184.188.64.222",
   "location": "Oceanside, California, United States",
   "metaobject_handle": "review-3cc38f11-0d2b-47d3-a263-292acbcd8f75"
 },
 {
   "title": "Great grip, Great CS!",
   "body": "Bought this because my son plays in a league with suboptimal court grip and it really helped him stand out amongst others sliding around. Nothing worse when trying to make a move to the basket while slipping and sliding on the floor. Definitely recommend for anyone trying to gain an edge when courts aren't newly resurfaced. \n\nAlso, absolute great customer service. I emailed Edge asking how long it would take for the grip spray to reach me since I needed it a bit sooner than I had anticipated for my son's game and they upgraded the shipping as a huge favor! My son won his game!!! Thanks Zach!",
   "rating": 5,
   "review_date": "2024-02-07 22:54:57 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Eduard Maldur",
   "reviewer_email": "emaldur@msn.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "Hey Ed! I am so happy to hear that our products helped your son stand out on the court. We understand how frustrating it can be to slip and slide while trying to make a move. Thank you for recommending it to others who may also be dealing with suboptimal court grip. I'm also thrilled to hear that your son won his game - the competition is what we do it for! Thank you for choosing our product and for sharing your experience!\n\n- Zach",
   "reply_date": "2024-02-08 23:11:47 UTC",
   "picture_urls": "",
   "ip_address": "70.93.170.228",
   "location": "Woodland Hills, California, United States",
   "metaobject_handle": "review-5527e5c2-83ba-4022-8b69-f11acad2a7a4"
 },
 {
   "title": "Edge spray X Chula Vista Suns",
   "body": "Game changer look forward to partnering up with edge spray",
   "rating": 5,
   "review_date": "2024-02-10 15:57:05 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Eric Brown",
   "reviewer_email": "chulavistasuns@yahoo.com",
   "product_id": 7736772952216,
   "product_handle": "edge-wipes-sample",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "172.56.188.172",
   "location": "Westminster, California, United States",
   "metaobject_handle": "review-9eed7509-194e-4b9a-9fe6-e078c8276c61"
 },
 {
   "title": "",
   "body": "The entire basketball team says this spray works the best!",
   "rating": 5,
   "review_date": "2024-02-15 21:54:36 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Jessica Knutson",
   "reviewer_email": "jessicaknutson23@yahoo.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "184.83.187.113",
   "location": "Sioux Falls, South Dakota, United States",
   "metaobject_handle": "review-6aecd80a-ac57-4b16-bab9-239d5d6dea7d"
 },
 {
   "title": "",
   "body": "My daughter loves it! Will be purchasing more . The only thing I will have to say is that’s a little pricey so we had to sparingly use it. If it was a little bit cheaper, we would use them more often thus would purchase more faster.",
   "rating": 4,
   "review_date": "2024-03-04 20:53:36 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Benjamin Nguyen",
   "reviewer_email": "johndoe40230@gmail.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-122250067-e3590a63-7877-4ff0-b8a8-9c35eeaf9bd5"
 },
 {
   "title": "Hidden Gems Showcase",
   "body": "I heard nothing but positive reviews from the players all day about how great the product was and the amount of traction that it produced.",
   "rating": 5,
   "review_date": "2024-03-28 13:00:15 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Randford Brooks",
   "reviewer_email": "info@mttsathletics.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "64.251.48.206",
   "location": "Waterbury, Connecticut, United States",
   "metaobject_handle": "review-fc32c50e-7878-4014-999c-530d61d0a4b6"
 },
 {
   "title": "Significant grip",
   "body": "My son is a basketball player and likes the wipes a lot. He says they help the grip on his shoes significantly.",
   "rating": 5,
   "review_date": "2024-02-17 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Brooke Shipbaugh",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-64b666eb-0e5d-4131-af43-96f4fd504d70"
 },
 {
   "title": "Feels great!",
   "body": "Product feels great! Just tried it out and filmed some dunks with it",
   "rating": 5,
   "review_date": "2023-12-21 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Lonnie Reed-Perez",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-5189cd3b-6e36-4d2e-8072-814775f65f3e"
 },
 {
   "title": "Teammates love it too",
   "body": "I really like the product I could definitely feel a difference. My teammates are asking me to not forget to bring the spray",
   "rating": 5,
   "review_date": "2023-11-22 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Romancomvalius",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-ce9c18ff-c8b0-4162-b69c-bd206bcb480a"
 },
 {
   "title": "Works",
   "body": "They actually work very good!",
   "rating": 5,
   "review_date": "2024-02-15 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Logan Ste",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-641111f1-50b1-4a55-8c73-840b72c0e25e"
 },
 {
   "title": "Coach",
   "body": "We love EDGE! My husband is a CYO Basketball Coach for my son’s 6th grade team St Rose. He’s been using the spray on all the boys sneakers throughout the season. This has been a great help for the boys this season. It definitely helps give them more traction. You can see we keep buying bottles!! lol",
   "rating": 5,
   "review_date": "2024-02-24 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Debby Scro",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-1809ebb6-64f7-4f72-aa90-fb4bfeaa1b05"
 },
 {
   "title": "Great product",
   "body": "I’m a retired Marine and now assistant with a Volleyball team. My daughter says it’s a great product. I will recommend this to our team, for sure.",
   "rating": 5,
   "review_date": "2024-02-15 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Rob Hunter",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-3fea81d6-de74-4742-948a-01f74e8bcd48"
 },
 {
   "title": "Strong effect",
   "body": "Really like the product. Definitely can feel the effects strongly for the first 5-10 minutes (with the spray). Used it in game a few times too",
   "rating": 4,
   "review_date": "2023-11-15 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Caleb Williams",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-fe659b36-f550-40f9-9168-6666631b36c6"
 },
 {
   "title": "Works for sure",
   "body": "I got the package yesterday right before practice and used one wipe! They work for sure. My shoes are starting to get slippery so they came just in time. The grip was good all practice and my team scrimmaged so it got the real test.",
   "rating": 5,
   "review_date": "2023-11-09 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Austin Abrams",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-678bc2a3-8472-4421-9ca2-62407d9e9236"
 },
 {
   "title": "Really works",
   "body": "Love the product. The traction really works.",
   "rating": 5,
   "review_date": "2024-03-13 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Adarsh Subra",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-c58b9e98-7cfe-4d99-86f9-c73f8a3644d0"
 },
 {
   "title": "Works",
   "body": "It’s amazing!",
   "rating": 5,
   "review_date": "2023-12-14 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "WYB",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-a3433fa4-b928-4f35-8bd1-93d494687009"
 },
 {
   "title": "Full control",
   "body": "I love the product.. got full control now inside the court",
   "rating": 5,
   "review_date": "2023-11-24 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "dredzkiiisdname",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-84ed1733-f157-4b31-9bff-ccd96815c5f3"
 },
 {
   "title": "Win",
   "body": "Our players enjoy it!",
   "rating": 5,
   "review_date": "2023-11-10 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Chris Diaz",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-92828794-44e2-446a-aacd-e1097f2ead7f"
 },
 {
   "title": "Nothing else is close",
   "body": "EDGE is the best! Nothing else is close",
   "rating": 5,
   "review_date": "2023-09-09 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "floridafan1976",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-860338b1-ff57-408f-b476-7d699be4284f"
 },
 {
   "title": "Can really tell the difference",
   "body": "It’s great, I can really tell the difference between when I’m using it or not! It does what it claims really well! My players have all liked it too. The only thing is that I haven’t gotten a chance to personally use it on a super beat up or unkept floor yet, so I don’t have experience with that. I’ve been on decent to great hardwood and good sportcourt. But it’s definitely elevated my traction on those surfaces. I’ve actually had a couple of my players ask me if I had it on my a certain days if they didn’t like how their shoes were feeling.",
   "rating": 5,
   "review_date": "2023-08-14 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Ethan Khoza",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-c9270ce0-4854-49ee-8dff-aa0edf0b1be1"
 },
 {
   "title": "Works great",
   "body": "This thing is great!",
   "rating": 5,
   "review_date": "2023-08-22 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "George Davey",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-55cf2de2-a6ab-4135-a280-c7c7339150e3"
 },
 {
   "title": "Love it",
   "body": "I LOVEEEEE the spray. It works great! My teammates also wanna start using it",
   "rating": 5,
   "review_date": "2023-08-24 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Jada Sabon",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-76b9d9d6-c2b7-4857-b647-65a0f8950547"
 },
 {
   "title": "No more slipping",
   "body": "Had a dude slipping all game the other day and told him to tryout the spray. Tried it and was sticking the rest the day.",
   "rating": 5,
   "review_date": "2023-10-25 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Jordan Boyd",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-60fd7658-e60f-4d36-82c4-5741215204d1"
 },
 {
   "title": "Passes the test",
   "body": "I’ve had some people test it out with myself included and there’s really good feedback",
   "rating": 4,
   "review_date": "2023-07-02 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Hoopwith’em",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-572c5775-e98b-4c0e-a3ab-757ed05ec921"
 },
 {
   "title": "Amazing",
   "body": "My trainer let me use some of his and it was amazing",
   "rating": 5,
   "review_date": "2023-07-30 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "1kamadou",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-2086a33d-1a30-42e2-97ea-0596e8ec5626"
 },
 {
   "title": "Works great",
   "body": "Been loving the spray this off-season man! Works great, bottle looks great. Love it",
   "rating": 5,
   "review_date": "2023-05-04 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Connor Printz",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-0d89026e-3a2b-41f1-8906-2d37c104ffae"
 },
 {
   "title": "Helped a ton",
   "body": "I was able to use the spray quite a lot over the last week of practices. Our AC has been out in the gym, so it helped a ton with the grip on the floors, and I loved it!",
   "rating": 5,
   "review_date": "2023-07-20 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Drew Thelwell",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-6db725b0-2d07-48e5-ae33-5fa6547a5517"
 },
 {
   "title": "Great",
   "body": "Got two bottles left from last deal. Nothing but great reviews!",
   "rating": 5,
   "review_date": "2023-07-15 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Grit and Grind Hoops",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-d896c05c-24b1-4953-9d7b-381a68813767"
 },
 {
   "title": "Helped with grip",
   "body": "I liked it. Helped with good grip on the court",
   "rating": 4,
   "review_date": "2023-06-14 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Bryce",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-91215d1d-6e26-4b69-97ab-068d4303a85f"
 },
 {
   "title": "Flat out works",
   "body": "I hoop in KD’s so when the floor is wet or starts getting sweaty, having low tops that slip can be detrimental. Let’s just say yesterday, I didn’t have any issues and kept the spray with me.",
   "rating": 5,
   "review_date": "2023-04-24 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Davion Robinson",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-74453255-2922-4a9d-9ec2-cab2d5a09dd3"
 },
 {
   "title": "Good review",
   "body": "I used it on the court at home! It was great",
   "rating": 5,
   "review_date": "2023-09-18 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Chase Adams",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-abb04734-f92b-4f1e-b081-b84da54348c0"
 },
 {
   "title": "Really like it",
   "body": "I really like it, EDGE works very well on the volleyball court!",
   "rating": 5,
   "review_date": "2023-02-19 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Cal Krohn",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-519da695-a0b9-4960-bdca-4d1719fd0775"
 },
 {
   "title": "Definitely noticeable",
   "body": "Honestly I was good with it for a while and definitely noticeable because I purposely went somewhere slippery",
   "rating": 5,
   "review_date": "2023-04-13 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Larry Moreno",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-438c15da-dcc2-4d29-9caf-d9db77c2c488"
 },
 {
   "title": "Can definitely feel the difference",
   "body": "Really like the spray! You definitely can feel a difference first few minutes for sure! Excited to keep using it and see how it spans over a full day of workout & camp sessions!",
   "rating": 5,
   "review_date": "2023-06-11 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Jeremy Hays",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-16e1ed19-52dc-41da-8bb2-614a152942c3"
 },
 {
   "title": "Better than anything else I've tried",
   "body": "EDGE is absolutely amazing! 2-3 pumps per shoe and I grip the whole game 40 min! Dropped 33 points and 20 rebounds. Love it I can say better than the competition on the market",
   "rating": 5,
   "review_date": "2023-05-28 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Lorenzo Ervin",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-62c199e2-8963-4e10-9fb0-738e7aa910e7"
 },
 {
   "title": "Works",
   "body": "it works, rlly appreciate u EDGE",
   "rating": 5,
   "review_date": "2023-03-22 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Adan Diggs",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-04441629-235f-440b-8ee8-987443c62266"
 },
 {
   "title": "So much more traction",
   "body": "I love the product!! It gives me that stop and go I need! My shoes have so much more traction",
   "rating": 5,
   "review_date": "2023-02-06 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Michael Barber",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-de1f1774-79ff-47fb-8dee-2abb64337a6b"
 },
 {
   "title": "Please expand to Europe",
   "body": "I play basketball over here in Monaco and I’m always slipping on courts all across Europe. I found your product review on YouTube and I decided to give it a try. Out of everything out there, you guys definitely stood out to me. The overall vibe of the brand was cool. Also the product itself looked durable and professional. I’ve only been able to use it a few times but it’s been amazing so far. Would love to hear about your expansion plans in Europe etc.",
   "rating": 5,
   "review_date": "2023-01-17 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Jordan Loyd",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-0c073eaa-eccc-41ef-9486-57fd50e2a28d"
 },
 {
   "title": "No product like it",
   "body": "Brother, it’s amazing. No product like it. You’re worth millions",
   "rating": 5,
   "review_date": "2023-05-03 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Brian",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-cd89964e-8a0f-49f1-b5c5-68a5aa8f33ee"
 },
 {
   "title": "People need to know about this",
   "body": "I love the grip on my shoes now … it helps me move freely & sharp. Thank you💪🏾‼️ Great product ‼️ people need to here more about this",
   "rating": 5,
   "review_date": "2023-03-02 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Daveonne Warfield",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-d0541b26-7bfa-4bfc-88a0-38385c20042a"
 },
 {
   "title": "Good product",
   "body": "the coaches from DeSoto high school said it's a good product, so I trust it",
   "rating": 5,
   "review_date": "2023-01-06 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Donny B.",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-94bffd84-00d4-4cc9-b2bb-a38c3a554b89"
 },
 {
   "title": "Better than Court Grip",
   "body": "I didn’t even clean the shoes or anything! I had walked a little bit and the shoes that been on a shelf for at least two months! It definitely shows! The last time I had a product similar was like back in 2011 Dwyane Wade had some kind of product that he was sponsoring to increase grip. I really liked it back then, but obviously that was a long time ago. This is by far the best",
   "rating": 5,
   "review_date": "2022-12-01 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Ricky",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-71c438c7-2ac4-4cd6-b838-24a4390df306"
 },
 {
   "title": "Amazing",
   "body": "it’s a amazing product",
   "rating": 5,
   "review_date": "2022-12-18 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Javier Daire",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-33bebdc6-19a5-430d-9ae7-247830965945"
 },
 {
   "title": "Firends are asking about it",
   "body": "My daughter is using this for indoor field hockey. I just had a mom reach out to me to ask about the product because my daughter has let some of the girls try her bottle.",
   "rating": 5,
   "review_date": "2023-01-24 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Tiffany Hilton",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-8bea9923-5e6b-4f3b-9907-23536dda390c"
 },
 {
   "title": "Helped",
   "body": "I tried it out a small bit yesterday and I think it helped a little bit - there are a number of factors to work against so the jury is still out on how much rubber revival can happen, but I’m hopeful",
   "rating": 4,
   "review_date": "2023-02-23 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Andrew Wittler",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-3d72931a-3909-4ff4-9758-90189a70cfc5"
 },
 {
   "title": "Doesn't get dirty like a sticky mat",
   "body": "It’s great! Definitely improves my grip. The duration of it could possibly be improved but it’s not much of a problem. But other than that it’s simple and easy! Personally, I think this is better cuz it doesn’t get dirty like a sticky mat and is not as big. But ig the one thing that a sticky mat may have an advantage in is the fact that all you have to do is step on it and step off",
   "rating": 4,
   "review_date": "2022-09-06 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Jaylen Wells",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-cad84a0e-3065-4005-a1da-e7b94c82f62d"
 },
 {
   "title": "Loving it",
   "body": "Tried out the product yesterday and loving it so far!! will continue to use it",
   "rating": 5,
   "review_date": "2022-10-24 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Tyler Leclerc",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-dd63840e-9187-461c-a2db-475a62a02a30"
 },
 {
   "title": "Immaculate!",
   "body": "Used it the last few hoop seshes and needless to say i LOVE IT! i tried it on some of the hoopin shoes that i thought did not have the best traction and after the spray they were immaculate!!!",
   "rating": 5,
   "review_date": "2023-01-15 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Parker Reese",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-2a066be9-def5-477c-b384-c4fe551f897f"
 },
 {
   "title": "Extra grip",
   "body": "I like how I get that extra bit of grip that I need in order to perform to the best of my ability",
   "rating": 5,
   "review_date": "2022-11-29 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Jacob Falko",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-84ebc289-266f-4be3-ac93-8e2b3ee5aaec"
 },
 {
   "title": "Son plays basketball, product seems to work well",
   "body": "My son is using it for his basketball games. I always see him wiping his shoes on the court with his hands so I thought this would be a better option. I think it’s good so far!",
   "rating": 4,
   "review_date": "2023-01-17 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Noelle Penna",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-5f2aa5b6-5a80-4443-8da3-f5c491706400"
 },
 {
   "title": "Amazing",
   "body": "This product is amazing",
   "rating": 5,
   "review_date": "2022-04-13 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Lexi Barros",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-091cbb5c-9c27-473c-a02a-3202396819e7"
 },
 {
   "title": "Incredible grip",
   "body": "I just wanted to say the spray as been working great I’ve gotten two people to stumble from How good the grip has been lol",
   "rating": 5,
   "review_date": "2022-08-29 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Mark Winston",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-cee88397-2a16-4ef7-b942-109a7fe6b9c1"
 },
 {
   "title": "Incredible",
   "body": "I firmly believe in your product. I've tried it out, and it is incredible",
   "rating": 5,
   "review_date": "2022-03-22 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Christopher Hoang Anh Nguyen",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-439d9832-e46e-40c0-a442-7504748d29cf"
 },
 {
   "title": "Grip",
   "body": "Bro that EDGE grip is tough brooo",
   "rating": 5,
   "review_date": "2022-02-17 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "AtmBucketzzz",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-5acb96f5-964a-462c-9b1d-f336d6d289d9"
 },
 {
   "title": "Works the best",
   "body": "My twin boys use it for High School Basketball. I bought three different brands of this type of spray. They said EDGE is the only one that actually works. Of course it is the most expensive one. A lot of their teammates have started to use it, so it ran out quickly. I told them to tell their buddies to buy their own. Ha! They like the way it works. My only complaint would be price point.",
   "rating": 4,
   "review_date": "2023-01-24 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Jessica Knutson",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-26433204-7b50-403d-8753-412c9becbf36"
 },
 {
   "title": "Use it daily",
   "body": "Your product is great and I use it daily",
   "rating": 5,
   "review_date": "2023-01-31 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Kennady McQueen",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-37f2011d-e92b-43a9-994f-1ba94f328088"
 },
 {
   "title": "Works really really well",
   "body": "Works really well, had a slippery court a couple of weeks ago and it made my shoes feel brand new",
   "rating": 5,
   "review_date": "2022-06-26 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Jacob De Armas",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-559062e5-ae44-4441-b5bd-577511112c97"
 },
 {
   "title": "Stop on a dime",
   "body": "Tried it again indoor for the first time and it’s great bro! The way you can stop on a dime is incredible! Def gunna be using this product from now on",
   "rating": 5,
   "review_date": "2022-04-06 17:00:00 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Derek West",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-403aeb9f-0304-4a3e-8172-89fc8858e9f3"
 },
 {
   "title": "STELLAR PRODUCT!",
   "body": "Last weekend I shared my Edge wipes with my teammates as we got ready to compete in a tournament.  The Edge wipes had my team stopping on a dime and they made transitioning from offense to defense much easier!  Thank you Edge brand for creating a product that complements athlete’s game!",
   "rating": 5,
   "review_date": "2024-05-22 00:06:29 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Jaylen Williams",
   "reviewer_email": "officiallyjaywill@gmail.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "107.122.225.8",
   "location": "San Antonio, Texas, United States",
   "metaobject_handle": "review-f8310cfa-a75f-481f-9afd-bfc5a2f656f2"
 },
 {
   "title": "Edge Spray is fire!",
   "body": "Love this product. We have bought other grip spray products, but none have been so easy to use and worked the way Edge does! Definitely recommend!",
   "rating": 5,
   "review_date": "2024-06-04 21:23:07 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Jacquelyn King",
   "reviewer_email": "jakb2013@yahoo.com",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "Thank you for taking time to leave a review! We are thrilled to hear that you are loving our Grip Spray. We are committed to making the best grip products out there and I'm happy to hear that it worked better than others on the market.\n\nI appreciate your support and hope to continue providing you with top-notch products!",
   "reply_date": "2024-06-04 21:33:17 UTC",
   "picture_urls": "",
   "ip_address": "174.126.117.134",
   "location": "Prescott, Arizona, United States",
   "metaobject_handle": "review-b1a31b4b-ee76-47e9-8c4f-ace5060bfffa"
 },
 {
   "title": "Good product, grip is dependent on the actual condition of the floor",
   "body": "I used the wipes as directed and found immediate much better traction.  The effect lasts much longer on floors that have t least been swept recently.  On horrible floors the effects were short lived.  Still worth trying.  I’ll keep using them",
   "rating": 4,
   "review_date": "2024-06-07 22:29:53 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Philip Rubenstein",
   "reviewer_email": "par167@yahoo.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "Thank you for the feedback, Philip! You're right - on unusually dusty courts (much more than the typical YMCA or AAU courts), you'll need to use EDGE more often than normal. Our formula soaks directly into rubber, so the improvement in grip is actually coming from the rubber itself. The more dust or dirt that is on the court, the less the rubber can grip the court, no matter how grippy it is.\n\nOur Sneaker Grip Wipes have the added benefit of cleaning the dust off your sneaker outsoles while simultaneously modifying the chemistry of the rubber with our grip formula. We appreciate the feedback!",
   "reply_date": "2024-06-14 14:04:52 UTC",
   "picture_urls": "",
   "ip_address": "73.198.167.80",
   "location": "West Orange, New Jersey, United States",
   "metaobject_handle": "review-47741a0e-151f-42a0-8174-4b37af77e413"
 },
 {
   "title": "Exceptional product.  Better than anything on the market",
   "body": "Lasted the entire basketball game, could hear the shoes squeak in the stands.  Logan played great, he had so much confidence in his agility due to the traction from the Edge product.  29 points as a sophomore on varsity.",
   "rating": 5,
   "review_date": "2024-06-14 03:05:23 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Zac MISSLER",
   "reviewer_email": "zmissler@misslerhomes.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "75.141.164.74",
   "location": "Atascadero, California, United States",
   "metaobject_handle": "review-1ac3884f-b592-4d5d-8f7f-3865b966d708"
 },
 {
   "title": "Awesome",
   "body": "Product has been great to use. Highly recommend for elite athletes.",
   "rating": 5,
   "review_date": "2024-06-20 17:00:41 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Loren Jackson",
   "reviewer_email": "lorenjackson3@gmail.com",
   "product_id": 7736772952216,
   "product_handle": "edge-wipes-sample",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "104.28.57.243",
   "location": "Miami, Florida, United States",
   "metaobject_handle": "review-c0ea29d1-c51f-453d-a516-010c7af4fb86"
 },
 {
   "title": "B-ball Players Dream",
   "body": "I bought this for my son for Christmas and when he ran out he asked me to get him more.  You don't need to use too much of it and each usage lasts pretty long.",
   "rating": 5,
   "review_date": "2024-06-21 14:32:13 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Lori Carelle",
   "reviewer_email": "lori.carelle@gmail.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "I'm glad your son's 2oz bottle lasted from Christmas until June - that's exactly what we intended! We designed our EDGE® Spray bottles to be portable and small without needing to buy a new bottle every month.\n\nThank you for giving us this feedback!",
   "reply_date": "2024-06-21 15:22:52 UTC",
   "picture_urls": "",
   "ip_address": "50.248.80.45",
   "location": "Bridgeville, Pennsylvania, United States",
   "metaobject_handle": "review-6d767ac8-4b58-47fb-a62f-3e1efbb8fc50"
 },
 {
   "title": "Edge wipes",
   "body": "My boys really like the stuff.  They come to me asking me before games to prep their shoes.  It’s funny to watch the other players who don’t use edge sliding all over the floor.",
   "rating": 5,
   "review_date": "2024-06-26 01:56:18 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Ryan Cueni",
   "reviewer_email": "iroscoi@yahoo.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "71.79.146.163",
   "location": "Painesville, Ohio, United States",
   "metaobject_handle": "review-8885fb51-8c44-4c7c-bfef-2a5bd2a9137b"
 },
 {
   "title": "Edge grip wipes",
   "body": "They product actually works I’d use more of it for sure.",
   "rating": 5,
   "review_date": "2024-06-26 22:23:40 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "DJ Freeman",
   "reviewer_email": "superathlete6093@gmail.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "107.115.163.20",
   "location": "Midland, Texas, United States",
   "metaobject_handle": "review-48df1fae-e292-4ac4-ad03-f0316fa0a400"
 },
 {
   "title": "",
   "body": "Amazing product. Must have product for highschool gym floors. Even on a swept clean floor these still add so much better traction even with newer shoes only ever worn inside. 1.00 a wipe per game, worth it!",
   "rating": 5,
   "review_date": "2024-06-30 20:26:22 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Steve Darnell",
   "reviewer_email": "sdarnell2618@gmail.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-147043622-30e1e8b4-df4d-48a2-bdbd-376b45e4d931"
 },
 {
   "title": "",
   "body": "The whipes work GREAT!  They remove the debris on the underside of the shoes and increase traction.  I can't imagine fencing without them.",
   "rating": 5,
   "review_date": "2024-07-03 12:44:38 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "John Tomasi",
   "reviewer_email": "fencingengineer@gmail.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "174.207.230.233",
   "location": "Cincinnati, Ohio, United States",
   "metaobject_handle": "review-4648973a-dcc3-44ef-8cde-ed90b0447937"
 },
 {
   "title": "Great Product. Must Have.",
   "body": "Kept seeing my son with variable traction with new shoes depending on the court. Didn’t want him to get injured. Bought the wipes and he LOVES them. No need to unfold them as they work as directed. Even got his teammates wanting to know where he got them. Going to check out the spray as well. This is a must have!",
   "rating": 5,
   "review_date": "2024-07-07 17:18:58 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Erik Nelson",
   "reviewer_email": "ejnelson06@gmail.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "100.7.87.167",
   "location": "Moseley, Virginia, United States",
   "metaobject_handle": "review-b00adc42-31dc-4432-8479-d5084db84dc4"
 },
 {
   "title": "",
   "body": "'-'",
   "rating": 5,
   "review_date": "2024-07-09 22:34:12 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Glenn Marumoto",
   "reviewer_email": "marumoto.glenn@gmail.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "47.149.222.60",
   "location": "Long Beach, California, United States",
   "metaobject_handle": "review-696d5a1c-9e07-4c47-bbd7-0173da04ac39"
 },
 {
   "title": "Edge’s Sneaker Grip review",
   "body": "For the first time using this product it was great and it really helped with the grip on my shoes",
   "rating": 5,
   "review_date": "2024-07-12 19:17:57 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Carl Taylor",
   "reviewer_email": "carl.taylor615@gmail.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "172.56.219.234",
   "location": "Philadelphia, Pennsylvania, United States",
   "metaobject_handle": "review-b0a5ab9a-68f9-47fe-9f77-e3a0270efd74"
 },
 {
   "title": "Amazing product!",
   "body": "I didn’t realize how much of a difference Edge grip spray made until I tried it for myself. It gives you terrific traction that makes you feel like a better athlete! I play basketball in college and will definitely be using this product! 1000 % recommend!",
   "rating": 5,
   "review_date": "2024-07-23 13:20:51 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Grant Stubbs",
   "reviewer_email": "grant.stubbs0920@gmail.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "Thank you for taking the chance to test our product! Using it yourself is the best way to become a believer in the product and how much of a difference it can make. Thats why we offer the money-back guarantee so you can test it without any risk - we're very confident in the products we've developed!",
   "reply_date": "2024-07-24 02:05:03 UTC",
   "picture_urls": "",
   "ip_address": "172.56.226.122",
   "location": "Birmingham, Alabama, United States",
   "metaobject_handle": "review-e0bdb927-3a06-4adf-9121-b73d3ffdfb70"
 },
 {
   "title": "Very versatile product!",
   "body": "Even though I’m a track and field athlete this product works perfectly!",
   "rating": 5,
   "review_date": "2024-07-23 14:05:06 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Dewayne Johnson",
   "reviewer_email": "dcjohnson0112@gmail.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "98.227.93.120",
   "location": "Park Forest, Illinois, United States",
   "metaobject_handle": "review-68d0f0b4-253f-4f53-8209-11b19acc0a17"
 },
 {
   "title": "最高の製品",
   "body": "最初は半信半疑でしたが、本当に効果があり、使ってみてよかったと思いました。私はD2 NCAA男子バレーでプレーしていますが、この製品のおかげでプレーが変わりました。",
   "rating": 5,
   "review_date": "2024-07-23 21:21:11 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Erika Lane",
   "reviewer_email": "erikalane24@gmail.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "184.61.44.46",
   "location": "Pequot Lakes, Minnesota, United States",
   "metaobject_handle": "review-974f722d-f941-40e2-b5b3-963371df54e4"
 },
 {
   "title": "D1 Athlete",
   "body": "I’m a D1 athlete and I tried these out for the first time on the volleyball court and they made a HUGE difference!",
   "rating": 5,
   "review_date": "2024-07-23 22:03:20 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Keyana Cruse",
   "reviewer_email": "k-cruse@wiu.edu",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "23.81.164.196",
   "location": "San Jose, California, United States",
   "metaobject_handle": "review-4c47b0e2-4492-4a1a-9ccb-ea226f5d6e9a"
 },
 {
   "title": "Game-Changing Grip",
   "body": "Slippery shoes have always been a major hindurance while playing on some basketball courts even at the D1 level. These give my shoes the extra traction I need especially on those courts that just seem to be too slippery. With one wipe, I can give both my shoes extra traction allowing me to cut better and safer.",
   "rating": 5,
   "review_date": "2024-07-23 22:26:49 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Sofie Lowis",
   "reviewer_email": "slowis@siue.edu",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "104.167.152.65",
   "location": "Edwardsville, Illinois, United States",
   "metaobject_handle": "review-42bb9f01-6fc7-4a76-b7ea-46234ece833b"
 },
 {
   "title": "Great product",
   "body": "I loved using this product. The floors I play on are pretty slippery and the wipes are amazing. Easy to use and an absolute must for athletes",
   "rating": 5,
   "review_date": "2024-07-23 23:02:05 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Teagan Thurman",
   "reviewer_email": "teagan1010@icloud.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "Sorry to hear that you deal with slippery floors, but I'm glad our Sneaker Grip Wipes have been helpful for you to counter that problem! Thanks for sharing your feedback, Teagan!",
   "reply_date": "2024-07-24 02:01:31 UTC",
   "picture_urls": "",
   "ip_address": "66.218.40.208",
   "location": "Tehachapi, California, United States",
   "metaobject_handle": "review-f3ce4c59-cd6d-42db-a442-e0f8a309f020"
 },
 {
   "title": "Sneaker Grip Wipes",
   "body": "Amazing product. I am a zumba instructor and recommend this product very much. My students and I were happy with results. After using them we felt secure on the floor while dancing (laminated floors)",
   "rating": 5,
   "review_date": "2024-07-28 20:33:05 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "selene Hinojosa",
   "reviewer_email": "selenehinojosa1981@gmail.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "172.56.81.149",
   "location": "Phoenix, Arizona, United States",
   "metaobject_handle": "review-e0c4c640-bce8-466e-9aea-3d043b9f42da"
 },
 {
   "title": "Product Works But Spray Bottle Clogged",
   "body": "I was unable to use the spray bottle on my footwear. The pump may be clogged. I had to unscrew the bottle and pour a small amount on a paper towel and then apply it to the bottom of my footwear. After it dried I can tell the difference when walking on tiled floors. It does help me to not slip.",
   "rating": 3,
   "review_date": "2024-07-28 23:53:16 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Marsha Jones-Harry",
   "reviewer_email": "marshaharry0118@yahoo.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "24.185.19.74",
   "location": "The Bronx, New York, United States",
   "metaobject_handle": "review-aae56edc-5ba6-4eb0-8a8e-c80656b5ea07"
 },
 {
   "title": "Very good!",
   "body": "The product is exactly what I want. Thank you very much!",
   "rating": 5,
   "review_date": "2024-07-29 18:08:11 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Toshinori Matsuyama",
   "reviewer_email": "tmatsuyama0227@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "68.179.135.124",
   "location": "Canton, Michigan, United States",
   "metaobject_handle": "review-69334a8f-5a44-4a84-a604-253338c783b4"
 },
 {
   "title": "Be a player with the Advant-EDGE",
   "body": "As soon as I put Edge on my sneakers and stepped on the court I noticed a difference right away - it was amazing! This really does work like it says it will. It was easy to use, quick and 100% miraculous. Be the one with the advant-Edge!",
   "rating": 5,
   "review_date": "2024-08-13 00:44:48 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Natalia Hassinger",
   "reviewer_email": "cabrel23@hotmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "69.142.212.58",
   "location": "Moorestown, New Jersey, United States",
   "metaobject_handle": "review-c0b83701-746d-4853-b7f0-28f5b26b775d"
 },
 {
   "title": "Best Product on the Market",
   "body": "Before I used and purchased Edge Wipes my shoe grip was around 4-5 out of 10. With them I feel like I’m at an 12!!!! It’s so simple to use and it works so fast. I’ll be a customer for a lifetime!",
   "rating": 5,
   "review_date": "2024-08-17 23:08:34 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Nate Lewis",
   "reviewer_email": "natel4492@gmail.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "Thank you for your review of our Sneaker Grip Wipes! We are thrilled to hear that you are happy with the improvement to your traction. We are committed to providing the best products on the market and we are grateful to have you as a lifelong customer!",
   "reply_date": "2024-09-03 16:17:58 UTC",
   "picture_urls": "",
   "ip_address": "47.230.97.15",
   "location": "Fort Lee, New Jersey, United States",
   "metaobject_handle": "review-7fe85e34-c4c5-4434-9c65-d612e818b279"
 },
 {
   "title": "Basketball players must USE",
   "body": "Great traction improvement!",
   "rating": 5,
   "review_date": "2024-08-21 17:01:41 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Zac MISSLER",
   "reviewer_email": "zmissler@misslerhomes.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "172.56.208.3",
   "location": "Las Vegas, Nevada, United States",
   "metaobject_handle": "review-c277926c-4de2-43d3-a166-7ba137716634"
 },
 {
   "title": "It really works!",
   "body": "Great Product",
   "rating": 5,
   "review_date": "2024-08-28 20:22:51 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Quincy Todd",
   "reviewer_email": "sonofgoldie@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "76.170.62.42",
   "location": "Los Angeles, California, United States",
   "metaobject_handle": "review-f93665b2-8072-4e51-9653-61b659a75ec0"
 },
 {
   "title": "Great!",
   "body": "100% recommend! Works for all shoes!",
   "rating": 5,
   "review_date": "2024-09-03 02:41:06 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Kendall Hicks",
   "reviewer_email": "kendall.hicks2056@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "104.28.32.195",
   "location": "Atlanta, Georgia, United States",
   "metaobject_handle": "review-fb0ed2fd-bab4-472f-b1cf-cc357c684e74"
 },
 {
   "title": "Repeat customer for a great product",
   "body": "My son has used these wipes for over a year, just reloaded our supply. \nAnyone who travels around playing on various courts knows just how bad the surfaces can get after repeated use and no wipe downs in between. These wipes do the job, creating more grip and traction!",
   "rating": 5,
   "review_date": "2024-09-09 18:00:51 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Ryan Glenn",
   "reviewer_email": "ryanmglenn@gmail.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "Thank you for the support for so long now!\nWe hate that courts are such a liability, but that's exactly why we spent the last 5 years working on this solution. It's feedback like this that keeps us going, so thank you for sharing your review!",
   "reply_date": "2024-09-09 18:13:27 UTC",
   "picture_urls": "",
   "ip_address": "108.16.53.58",
   "location": "Horsham, Pennsylvania, United States",
   "metaobject_handle": "review-739467aa-4695-4aed-b71c-69957d8c259d"
 },
 {
   "title": "Price and product are spot on",
   "body": "This is one of the best products I have ever seen for the court. The bundle prices just make it even easier to make the purchase.",
   "rating": 5,
   "review_date": "2024-09-22 11:22:56 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Marc Morgan",
   "reviewer_email": "mmorgan@warrenjfk.com",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "76.188.147.107",
   "location": "Niles, Ohio, United States",
   "metaobject_handle": "review-ba55361c-4dcb-4845-80ae-b22cc862fb6b"
 },
 {
   "title": "",
   "body": "Great product!! Our BING BONG team loved how fast it worked and made a difference. 10/10!! Highly recommend. Thanks Edge!",
   "rating": 5,
   "review_date": "2024-09-29 14:47:09 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Brian Munoz",
   "reviewer_email": "bmoony42@yahoo.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-160434605-1df798d2-0b82-421d-9b96-74f75c026b91"
 },
 {
   "title": "Changed the game!",
   "body": "No longer worried about slipping, so I can really go for my lunges every time!",
   "rating": 5,
   "review_date": "2024-11-03 02:14:19 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Jessica Dunne",
   "reviewer_email": "jessicadunne17@gmail.com",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "67.81.193.92",
   "location": "Riverside, Connecticut, United States",
   "metaobject_handle": "review-ebf18428-5643-40f2-8fb9-a8bff8f02a0c"
 },
 {
   "title": "",
   "body": "My son loves it!",
   "rating": 5,
   "review_date": "2024-11-07 15:25:46 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Kristin Nelson",
   "reviewer_email": "kristinnelson2@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-166052707-ce4659e8-f52e-4701-8144-fedc1cf9fb1f"
 },
 {
   "title": "Best Stuff on Market!!!",
   "body": "I’m very happy to have been on instagram and randomly found a video for edgespray. I made a decision to check it out and it’s the best decision I’ve made. I’ll be a customer for life .",
   "rating": 5,
   "review_date": "2024-11-12 18:11:09 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Nate Lewis",
   "reviewer_email": "natel4492@gmail.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "12.74.62.35",
   "location": "New York, New York, United States",
   "metaobject_handle": "review-f81ca2a2-5617-4d82-92ec-a353cf9e1496"
 },
 {
   "title": "Never received spray",
   "body": "Never received spray only wipes.",
   "rating": 2,
   "review_date": "2024-11-13 18:23:38 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Dawn Garetson",
   "reviewer_email": "chuckdawn@tds.net",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-b1d8edaf-9b2f-4cc6-9e08-d1b561f53835"
 },
 {
   "title": "Great Product and Company",
   "body": "Great costumer service and my boys love the spray that helps them maintain traction on an older floor they practice on.  Thanks!",
   "rating": 5,
   "review_date": "2024-11-19 23:20:17 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Jake Linden",
   "reviewer_email": "jelinden@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "Thank you for your kind words! I'm glad to hear that our Grip Spray has been a hit with your boys and has helped them maintain traction on the practice floor they struggle with. Customer service is probably our top priority outside of constantly improving our products and I'm happy to know that we've met your expectations. Thank you for supporting us on this journey!",
   "reply_date": "2024-11-20 00:41:37 UTC",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-19d23d5d-1681-43f1-884d-7816e7c31fb9"
 },
 {
   "title": "Works well",
   "body": "I purchased this for my 13 yr of son, he likes it and uses it once a day.  He plays at least 3x a day but said it stays well enough on the hardwood courts that he dosen't need to spray again later in the day.  Bad points for glass container and $$",
   "rating": 5,
   "review_date": "2024-11-21 01:20:53 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "bettie austin",
   "reviewer_email": "bettieaustin23@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "Hey Bettie, I'm so glad to hear your son is getting lots of use out of our Sneaker Grip Spray! We use glass in our 2oz bottles to limit the amount of plastics we use for environmental reasons, but we have recently switched our 4oz spray bottles to plastic. If you're interested in the 4oz for your next order, please reach out and I will send you a discount code as a token of my appreciation for your review feedback!\n\n-Zach",
   "reply_date": "2024-11-21 04:43:20 UTC",
   "picture_urls": "",
   "ip_address": "172.56.92.127",
   "location": "San Antonio, Texas, United States",
   "metaobject_handle": "review-4deac654-8a87-4d05-938f-73fe93003438"
 },
 {
   "title": "Shoe Magic",
   "body": "These wipes really work..!! Have 2 basketball players using them this season and they truly help with better traction on the court..!! Definitely will buy more when they run out..!!",
   "rating": 5,
   "review_date": "2024-11-21 14:14:58 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Joni Thorp",
   "reviewer_email": "bigstartx@yahoo.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "174.197.5.141",
   "location": "Austin, Texas, United States",
   "metaobject_handle": "review-bd2cdce8-28b1-48cf-b647-b9eac7e69247"
 },
 {
   "title": "Don't go to the court without it",
   "body": "Both of my daughters are using Edge now. It's a must have!",
   "rating": 5,
   "review_date": "2024-11-25 00:58:05 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "David Cline",
   "reviewer_email": "dcline@eastcentralcropservice.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "64.184.98.58",
   "location": "Hagerstown, Indiana, United States",
   "metaobject_handle": "review-be82dad8-247c-4c35-b807-499108967a96"
 },
 {
   "title": "Great item to have In Volleyball bag",
   "body": "Love it no need to dust off shoes",
   "rating": 5,
   "review_date": "2024-11-25 15:56:55 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Juan Rivera",
   "reviewer_email": "jrcaal@gmail.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "Great to hear that you're enjoying the product for Volleyball and that it helps you avoid having to constantly wipe the dust off your shoes!\n\nThank you for your feedback!",
   "reply_date": "2024-11-25 16:12:18 UTC",
   "picture_urls": "",
   "ip_address": "24.6.247.190",
   "location": "Pittsburg, California, United States",
   "metaobject_handle": "review-405dc120-2d7f-44ad-ba8f-15662af46797"
 },
 {
   "title": "",
   "body": "The wipe didn’t last for the whole practice",
   "rating": 4,
   "review_date": "2024-11-25 23:56:39 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Jacqueline WilliamsOlango",
   "reviewer_email": "jawill72@hotmail.com",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "Thank you for supporting our company and for reporting back! Some of our athletes do prefer to reapply halfway through games and practices, especially on excessively dusty courts - I'm glad to see you still enjoyed the product though (given the high rating)!\n\nIf you have any questions or need any help, please feel free to chat with us on our website support chat or on social media!",
   "reply_date": "2024-12-05 06:49:43 UTC",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-169564499-0f298769-49c2-44d2-ada4-d0a0310a2a3f"
 },
 {
   "title": "",
   "body": "It’s a gift so it has not been used yet!",
   "rating": 5,
   "review_date": "2024-12-07 16:42:33 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Donell Merchant",
   "reviewer_email": "merchantdonell@gmail.com",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-171769837-50ec50ca-cc0b-40c1-9c00-57b7be9701fe"
 },
 {
   "title": "",
   "body": "Works well, kids like the extra grip to help on the court!",
   "rating": 5,
   "review_date": "2024-12-07 18:56:01 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Tesha Peterman",
   "reviewer_email": "boatman_tesha@live.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-171795845-9c93d88a-e83f-4209-9804-d794153c32cb"
 },
 {
   "title": "Great for Wrestling",
   "body": "I tried this product to see if it would help with grip while wrestling (heavyweight). I found that with the Edge spray I slip less when executing on mat rolls and am able to get more traction during escapes.",
   "rating": 5,
   "review_date": "2024-12-09 00:52:07 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Robert Ward",
   "reviewer_email": "pyorkward@hotmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "This is awesome to hear! So glad we can help you maintain your footing for wrestling!\n\nThank you for the support 🙏",
   "reply_date": "2024-12-09 04:29:48 UTC",
   "picture_urls": "",
   "ip_address": "75.208.106.48",
   "location": "Nashville, Tennessee, United States",
   "metaobject_handle": "review-0fcf6db4-d68f-4342-93ad-2a51366a5d3b"
 },
 {
   "title": "Great product",
   "body": "This spray works really well. I’d only suggest that when you spray your shoes, do it over a towel or completely off the gym floor as it’s pretty slick if left on the floor. Expensive, but works.",
   "rating": 5,
   "review_date": "2024-12-09 18:56:56 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Katie McCoy",
   "reviewer_email": "woodruffkm@yahoo.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "I'm glad you're happy with your purchase, Katie! In case this is helpful - note that if you do get any on the floor, you can kick your sneakers into it to dry it up the same way we do with sweat when someone falls on the court.\n\nThank you for the feedback and for the suggestions!",
   "reply_date": "2024-12-09 23:29:22 UTC",
   "picture_urls": "",
   "ip_address": "73.103.135.119",
   "location": "Indianapolis, Indiana, United States",
   "metaobject_handle": "review-ccb8c93e-6d37-4303-bd1c-51d755cebd9b"
 },
 {
   "title": "It’s Hands Down A Game Changer‼️",
   "body": "Edge Spray Is For Sure A Must Cop‼️",
   "rating": 5,
   "review_date": "2024-12-10 00:46:52 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Clinton Byrd",
   "reviewer_email": "coachbyrd42@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "104.28.126.141",
   "location": "Huntsville, Alabama, United States",
   "metaobject_handle": "review-880d4787-1b65-4747-a7fa-53a7c74138a6"
 },
 {
   "title": "宣伝ほどではない",
   "body": "商品の効果があまりなく、持続もしなくて残念です。",
   "rating": 1,
   "review_date": "2024-12-11 05:54:59 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Eric Barajas",
   "reviewer_email": "ebar21@aol.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "Eric - I'm so sorry to learn about your experience :(\n\nI can usually help you get better use out of the product if you want to reach out to our team@edgespray.com email! If not, I am always happy to honor our money-back guarantee. We are not in the business of taking money from anyone who isn't satisfied with the product!\n\nThank you for the support and let me know if I can help in any other way!",
   "reply_date": "2025-02-17 17:16:52 UTC",
   "picture_urls": "",
   "ip_address": "70.95.192.153",
   "location": "San Diego, California, United States",
   "metaobject_handle": "review-955d1c9c-779b-47ff-8b8e-611453080f7f"
 },
 {
   "title": "",
   "body": "My daughter plays volleyball and I thought this would help her instead of always licking her hands and wiping her shoes, however she says it works but wears off quick.",
   "rating": 2,
   "review_date": "2024-12-11 12:44:05 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Nicole Pelzman",
   "reviewer_email": "nickeyp1980@yahoo.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-172664326-41c35e7b-0b85-4424-a847-c0a7e0892047"
 },
 {
   "title": "Son loves them",
   "body": "Son has used them and loves them. They provide the grip he needs on different surface levels (some gyms more slippier than others) and it helps him get better control.",
   "rating": 5,
   "review_date": "2024-12-11 14:34:17 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Shandy",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-d69c1128-f1ff-406c-9c9d-490a06bd6494"
 },
 {
   "title": "Impressed",
   "body": "My 6’4”, 17 year old son is a serious student athlete. He used them this weekend during the Live Period. A teammate of his saw how well his grip was after using it and asked to test one out. My son loves the product. He can speak performance of the product very well. He was impressed!! His teammate had already asked him multiple times where he bought the product at. I bought the wipes because he had some new shoes that didn’t have the best traction on a few courts but they give him the best comfort for a young man that wears a size 15 shoe and makes an impact all over the floor.",
   "rating": 5,
   "review_date": "2024-12-11 14:34:17 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Erik",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-2567720f-eca8-4964-a46e-26930a7a6a31"
 },
 {
   "title": "Work very well",
   "body": "My son has been using it and he says they work very well. Apparently there is a gym he trains in on Tuesdays that never gets cleaned and is extra dirty and dusty. It works great for him there.",
   "rating": 5,
   "review_date": "2024-12-11 14:34:17 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Jeremy",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-2633b656-33e4-44eb-b89b-75c95f6c2aea"
 },
 {
   "title": "Teammates love them too",
   "body": "My son took two with him to practice tonight so he could try one, and he could have one of his friends/teammates try one out as well. They were in their school's new gymnasium for practice today, which is only a couple of years old, only used exclusively for sports, and very well maintained; however, they could still tell that your product (wipes) made a big difference, traction wise. He said they both really liked it!!! I asked him if he would like me to keep buying them for the season and he immediately answered \"yes\". I will definitely be purchasing more soon, along with the spray (just to try out)",
   "rating": 5,
   "review_date": "2024-12-11 14:34:17 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Jason",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-40e5869e-65ea-4c49-9f91-0b9c55bee0b8"
 },
 {
   "title": "Love both the spray and wipes",
   "body": "Love the spray and wipes.  Every training she uses it and can tell a big difference.  She's won a silver and gold individual medal at the club, and just the weekend finished 5th in the U20 nationals here, and was part of the gold medal team.",
   "rating": 5,
   "review_date": "2024-12-11 14:34:17 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Greg",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-8e044d58-d06e-4591-a8aa-69feed72bddf"
 },
 {
   "title": "Hasn’t worked yet",
   "body": "Followed the steps over and over. Reached out to Zach, sent a few emails and then never responded. Just buy the sticky mats and save your $$ in my opinion",
   "rating": 3,
   "review_date": "2024-12-12 01:25:55 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "Rick Leasure",
   "reviewer_email": "rleasure42@live.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "Hey Rick,\n\nI'm sorry to see this, but I'm also confused! We have an email thread of 9 emails back and forth, the very first of which I offered to send you a return label if I couldn't help troubleshoot for you. Your last email is on Dec 1, which responded to on Dec 5, then followed up again on Dec 11 because I hadn't heard from you. They are all in the same thread with my Cofounder CC'd on every one of both yours and mine, so I'm not sure why they wouldn't show up in your inbox.\n\nI'm still happy to give you a refund for the inconvenience, just wanted to share my perspective because I take a lot of pride in my customer service and care deeply about each customer!\n\nIf you have any feedback on how I can improve, please let me know and I appreciate you taking the chance on our product either way",
   "reply_date": "2025-02-17 17:24:46 UTC",
   "picture_urls": "",
   "ip_address": "74.141.90.230",
   "location": "Willoughby, Ohio, United States",
   "metaobject_handle": "review-aeee63fe-a889-4076-bffd-eaf9e2698629"
 },
 {
   "title": "",
   "body": "先週末に使ってみましたが、コートでの違いは特に感じませんでした。",
   "rating": 1,
   "review_date": "2024-12-12 18:53:06 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Michelle Lee",
   "reviewer_email": "michellelee1028@yahoo.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-173012300-8171bc5b-0901-499f-9c60-5bd0e72898c6"
 },
 {
   "title": "Travel ball",
   "body": "My son plays travel ball and middle school ball so Edge will get a lot of use..",
   "rating": 5,
   "review_date": "2024-12-13 00:51:03 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Christopher",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-756047b9-7bc9-4ad6-98fb-163aacb0d76b"
 },
 {
   "title": "Surprised",
   "body": "My son thinks these are great. He was really surprised how well they worked! He said the wipes are super easy to use. He likes that he can easily keep them in his basketball bag. He also appreciated how quick they were to use and how fast it dried so he can wipe down his shoes just prior to games. Awesome product.",
   "rating": 5,
   "review_date": "2024-12-13 00:51:03 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Karen",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-184f9905-3d78-46e3-a08b-30d54ea3e652"
 },
 {
   "title": "Victory!",
   "body": "I got a lot of great feedback last night at volleyball. They pulled out a 3rd set victory and they loved the extra grip while playing. I can't wait to try these Sunday for bball.",
   "rating": 5,
   "review_date": "2024-12-13 00:51:03 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Marc",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-b62f16bf-9168-49f0-8fa5-64c6c89ace1d"
 },
 {
   "title": "Really like them so far",
   "body": "So far, they've really liked them. During training, it made a definite difference when they were going up the warped wall and going through the jumping spider.",
   "rating": 5,
   "review_date": "2024-12-13 00:51:03 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Noah",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-2eebbf92-caf7-4032-b931-267925958653"
 },
 {
   "title": "Rave reviews",
   "body": "my husband coaches travel basketball teams for both girls and boys and has had my children use them and raves about them.",
   "rating": 5,
   "review_date": "2024-12-13 00:51:03 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "Stephanie",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-6c4b0695-ba3d-4832-9748-61be8d2fdd2f"
 },
 {
   "title": "Works on smooth granite",
   "body": "I used the wipes on some rubber hiking boots before climbing the cables on Half Dome in Yosemite and felt like I had great traction while others were slipping.",
   "rating": 5,
   "review_date": "2024-12-13 00:51:03 UTC",
   "source": "wizard",
   "curated": "ok",
   "reviewer_name": "David",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-0fd9509c-dde4-43ab-9359-a7e69c0e62ef"
 },
 {
   "title": "",
   "body": "They work great my daughter tried at her game other night",
   "rating": 5,
   "review_date": "2024-12-22 05:31:25 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "WALTER JOHNSON",
   "reviewer_email": "bigwallyjohnson@aol.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-175280890-9beeafc5-9e18-40a4-9f08-c754754702d4"
 },
 {
   "title": "",
   "body": "クリスマスプレゼントでもらいました。まだ何とも言えません。とても高い商品なので、値段に見合うか様子見です。",
   "rating": 1,
   "review_date": "2024-12-23 20:31:59 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Nicci Mercado",
   "reviewer_email": "nicciwd40@yahoo.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "Hey Nicci, Bumping this in case you had any updates after your niece and nephews tried the product - thanks so much for your support!",
   "reply_date": "2025-01-16 19:03:05 UTC",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-175577608-5ea7fbb5-ab55-4f06-bc7b-72b54985d868"
 },
 {
   "title": "",
   "body": "長持ちしません",
   "rating": 2,
   "review_date": "2024-12-24 00:31:53 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "David Lorence",
   "reviewer_email": "dave32880@aol.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-175628074-83feeafb-8c42-438c-aaa0-1309b32f9277"
 },
 {
   "title": "Several teammates wanted to try, game changer",
   "body": "The edge spray has been a game changer for me. Unfortunately not too long after I used it, I had the bottle in the gym and someone walked off with it. Several of my teammates wanted to try it. We just played a game in an old gym floor that was slippery and I really could have used it.",
   "rating": 5,
   "review_date": "2024-12-24 00:00:00 UTC",
   "source": "judge-me",
   "curated": "ok",
   "reviewer_name": "Ava Reymond",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-5a054531-c528-4e7c-9988-02327c2d3978"
 },
 {
   "title": "Wipes worked super well, friends liked them",
   "body": "wipes worked super well and the girls liked them. Have a tournament this weekend and going to bring for people to try there too!",
   "rating": 5,
   "review_date": "2024-12-24 00:00:00 UTC",
   "source": "judge-me",
   "curated": "ok",
   "reviewer_name": "Ana Stojanovic",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-59cf429e-4eb5-487b-9afc-924cb0ddc777"
 },
 {
   "title": "Works great, improves confidence",
   "body": "It works great! We feel confident knowing we don’t have to worry about slippery floors.",
   "rating": 5,
   "review_date": "2024-12-24 00:00:00 UTC",
   "source": "judge-me",
   "curated": "ok",
   "reviewer_name": "Qeshaun Todd",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-d7f7bff2-59e6-43f1-a6ef-aab4ba8a8227"
 },
 {
   "title": "Game changer, helps with slippery gym floor",
   "body": "Game changer!! Especially because my gyms floor where the bags are is SUPER slippery oddly enough thank you!!",
   "rating": 5,
   "review_date": "2024-12-24 00:00:00 UTC",
   "source": "judge-me",
   "curated": "ok",
   "reviewer_name": "Alaena Vampira",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-c5bb5300-2386-47a0-a75b-c74364f25fcd"
 },
 {
   "title": "Definitely made an improvement",
   "body": "We had a few kids and a few of the experienced fencers try it. I asked them to fence a bout AND then treat their shoes to compare. Definitely made an improvement.",
   "rating": 5,
   "review_date": "2024-12-24 00:00:00 UTC",
   "source": "judge-me",
   "curated": "ok",
   "reviewer_name": "Brad",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-fe79dd9c-d976-43e6-bf59-07cdc2afef22"
 },
 {
   "title": "",
   "body": "Great product! AMAZING customer service!",
   "rating": 5,
   "review_date": "2024-12-26 15:06:31 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Lauren Paquette",
   "reviewer_email": "laurenpaquette77@live.com",
   "product_id": 7734929129624,
   "product_handle": "sneaker-sole-grip-spray-4oz",
   "reply": "Thank you for the feedback and I'm always happy to help!\n-Zach",
   "reply_date": "2025-01-06 19:29:53 UTC",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-176072695-e9f88ad2-3245-427a-bd22-8ade0c880775"
 },
 {
   "title": "",
   "body": "最高の商品。",
   "rating": 5,
   "review_date": "2025-01-11 15:27:30 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Bobby Kovach",
   "reviewer_email": "bobbylitefit12@gmail.com",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-179283675-5616e131-3cc8-4700-8b21-07c652eb2d47"
 },
 {
   "title": "",
   "body": "この商品は息子たちの大のお気に入りです。バスケコートでのグリップ力が格段にあがります。チームのみんなも試してみたいと聞いてきました。絶対にまた購入します！",
   "rating": 5,
   "review_date": "2025-01-13 20:50:30 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Kristy Hamm",
   "reviewer_email": "kristy.fischer@hotmail.com",
   "product_id": 7738116505752,
   "product_handle": "sneaker-sole-grip-bundles",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-179666192-a0fa50af-0f2c-478a-ab31-4ebfe2c25f76"
 },
 {
   "title": "商品もカスタマーサービスもすばらしい",
   "body": "息子たち二人ともバレーをやっていて、クリスマスプレゼントにEDGEスプレーをもらったのですが、すっかり気に入っています。滑り止めに役立つだけでなく、ジャンプ力も上がりました！Zachさんの対応がすばらしく、カスタマーサービスも最高です！ \n\nRolanda Wii",
   "rating": 5,
   "review_date": "2025-01-31 17:59:33 UTC",
   "source": "web",
   "curated": "ok",
   "reviewer_name": "Rolanda W Canada ",
   "reviewer_email": "rolandawitt@sasktel.net",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "I'm so glad to hear your boys are getting use out of the product! Thank you so much for taking the time to fill out a review and include some footage!\n\nAnd I appreciate your kind words - feedback like this makes my entire week :)\n\n-Zach",
   "reply_date": "2025-02-04 08:45:36 UTC",
   "picture_urls": "",
   "ip_address": "71.17.210.127",
   "location": "Saskatoon, Saskatchewan, Canada",
   "metaobject_handle": "review-84253be9-2abd-410d-b3d5-044df2641b8b"
 },
 {
   "title": "",
   "body": "息子もとても気に入っているようです！先日の試合のとき体育館の床がすごく滑りやすかったので、本当に役立ちました。",
   "rating": 4,
   "review_date": "2025-02-13 02:55:50 UTC",
   "source": "shop-app",
   "curated": "ok",
   "reviewer_name": "Jill Llewellyn",
   "reviewer_email": "jilliellew1601@gmail.com",
   "product_id": 7728439034008,
   "product_handle": "sneaker-sole-grip-wipes",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "shop-2519111-185433023-bbd3d356-302a-40f5-9268-58834fdff989"
 },
 {
   "title": "ゴルフグリップにも使えます",
   "body": "私にとって夏のスポーツといえばゴルフなので、靴に使えるならゴルフグリップでもいけるんじゃないかなと思って使ってみました。",
   "rating": 5,
   "review_date": "2025-05-21 00:00:00 UTC",
   "source": "judge-me",
   "curated": "ok",
   "reviewer_name": "Kelly R",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "Thank you for sharing!! You are one of the 1st people to test EDGE on your golf grips and that is so freaking cool to hear that the product we made for sneaker grip is helping restore grip to your clubs!",
   "reply_date": "2025-05-23 22:02:42 UTC",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-ad4328f2-d9b7-4931-8994-ea28d26a5772"
 },
 {
   "title": "アメフトグローブ！",
   "body": "普段アメフトグローブを買っても最初の１、２回しかグリップがよくないんですが、この商品を使うと毎回しっかりグリップできて、大きな違いを感じています。",
   "rating": 5,
   "review_date": "2025-05-20 00:00:00 UTC",
   "source": "judge-me",
   "curated": "ok",
   "reviewer_name": "Drake L",
   "reviewer_email": "support+anonymous@judge.me",
   "product_id": 6754115092632,
   "product_handle": "sneaker-sole-grip-spray",
   "reply": "Thank you for being one of the first people to test EDGE on your football gloves!! I LOVE hearing new use cases like this and I appreciate you for sharing your feedback!",
   "reply_date": "2025-05-23 22:00:57 UTC",
   "picture_urls": "",
   "ip_address": "",
   "location": "",
   "metaobject_handle": "review-1a95f983-1502-4a97-b9e6-64f9c277490d"
 },
 {
   "title": "すばらしい商品",
   "body": "本当にすばらしい商品です。説明されている以上の効果があります！とてもオススメです！",
   "rating": 5,
   "review_date": "2025-05-24 07:02:05 UTC",
   "source": "new-rre-flow",
   "curated": "ok",
   "reviewer_name": "PK Higa",
   "reviewer_email": "3andoutfitness@gmail.com",
   "product_id": 8573934534808,
   "product_handle": "sneaker-grip-bundles-private-reorder",
   "reply": "",
   "reply_date": "",
   "picture_urls": "",
   "ip_address": "66.8.203.193",
   "location": "Makawao, Hawaii, United States",
   "metaobject_handle": "review-f77ad873-e72d-4a6e-8200-7e0c58283ed9"
 }
];
}

window.review_json = review_json;
 
var PER_PAGE = 5;
var TOTAL_PAGES = Math.ceil(review_json.length / PER_PAGE);


function generate_html_review(review) {
  const pictures = review.picture_urls ? review.picture_urls.split(',') : [];

  const reviewDate = new Date(review.review_date);
  const now = new Date();
  const monthsAgo = Math.floor(
    (now.getFullYear() - reviewDate.getFullYear()) * 12 +
      (now.getMonth() - reviewDate.getMonth())
  );
  const timeAgo = monthsAgo > 0 ? `${monthsAgo} month${monthsAgo > 1 ? 's' : ''} ago` : 'Recently';

  let starsHTML = '';
  for (let i = 1; i <= 5; i++) {
    starsHTML += `<span class="custom_jdgm-star ${i <= review.rating ? 'custom_jdgm--on' : 'custom_jdgm--off'}"></span>`;
  }

  let picsHTML = '';
  if (pictures.length) {
    picsHTML = `<div class="custom_jdgm-rev__pics">`;
    pictures.forEach((url) => {
      picsHTML += `<a class="custom_jdgm-rev__pic-link" target="_blank" rel="nofollow" href="${url.trim()}"> <img class="jdgm-rev__pic-img" src="${url.trim()}" alt="Review picture" /></a>`;
    });
    picsHTML += `</div>`;
  }

  var review_reply = '';
  if(review.reply != '') {
    review_reply += ` <div class="custom_jdgm-rev__reply" > 
     <div class="custom_jdgm-rev__replier-wrapper" >&gt;&gt; <b class="custom_jdgm-rev__replier">${window.edge_name}</b> ${window.replied}:</div> 
     <div class="custom_jdgm-rev__reply-content" ><p>${review.reply}</p></div>  </div>
  `;
  }

  var review_source = `<span class="custom_jdgm-rev__buyer-badge-wrapper">
            <span class="custom_jdgm-rev__buyer-badge">Verified</span>
          </span>`;
  if (review.source == 'web') {
    review_source = `<span class="custom_jdgm-rev__source" data-source="shop-app"><img class="custom_jdgm-rev__verification-badge-img custom_jdgm--loading" alt="Verified by Shop" src="https://judgeme-public-images.imgix.net/judgeme/verified-badge-v2/verified-by-shop_light.svg"></span>`;
  }

  return `
  <div class="custom_jdgm-rev custom_jdgm-divider-top custom_jdgm--done-setup" data-verified-buyer="true">
    <div class="custom_jdgm-rev__header">
      <div class="custom_jdgm-row-product"></div>
      <div class="custom_jdgm-row-rating">
        <span class="custom_jdgm-rev__rating" data-score="${review.rating}" tabindex="0" aria-label="${review.rating} star review" role="img">
          ${starsHTML}
        </span>
        <span class="custom_jdgm-rev__timestamp" data-content="${review.review_date}">${timeAgo}</span>
      </div>
      <div class="custom_jdgm-row-profile">
        <div class="custom_jdgm-rev__icon"></div>
        <span class="custom_jdgm-rev__author-wrapper">
          <span class="custom_jdgm-rev__author">${review.reviewer_name}</span>
          ${review_source}
          </span>
      </div>
      <div class="custom_jdgm-row-extra">
        <span class="custom_jdgm-rev__location">${review.location || ''}</span>
      </div>
      <div class="custom_jdgm-rev__br"></div>
    </div>
    <div class="custom_jdgm-rev__content">
      <b class="custom_jdgm-rev__title">${review.title}</b>
      <div class="custom_jdgm-rev__body"><p>${review.body}</p></div>
      ${picsHTML}
      <div class="custom_jdgm-rev__custom-form"></div>
      <div class="custom_jdgm-rev__transparency-badge-wrapper"></div>
    </div>
    <div class="custom_jdgm-rev__actions">
      <div class="custom_jdgm-rev__social"></div>
      <div class="custom_jdgm-rev__votes"></div>
    </div>
    ${review_reply}
   </div>
  `;

}

function render_review_html(review_json) {
  var review_html = '';
  review_json.forEach(function(review){
    review_html += generate_html_review(review);
  });
  return review_html;
}



if($('.custom_reviews').length > 0) {
  $('.custom_reviews').each(function(index, reviews_html){
    console.log(reviews_html);
    $(reviews_html).find('.custom_jdgm-rev-widg__reviews').html(render_review_html(review_json.slice(0,PER_PAGE)));
  });
}

function getPaginationElements(c) {
    var els = {};
    els.context = c;
    els.prevPage = c.querySelector('.custom_jdgm-paginate__prev-page');
    els.firstPage = c.querySelector('.custom_jdgm-paginate__first-page');
    els.nextPage = c.querySelector('.custom_jdgm-paginate__next-page');
    els.lastPage = c.querySelector('.custom_jdgm-paginate__last-page');
    els.numbersContainer = c.querySelector('.page-numbers-container');
    els.reviewsContainer = c.querySelector('.custom_jdgm-rev-widg__reviews');
    return els;
}


function generatePageNumbers(c, currentPage) {
    var els = getPaginationElements(c);
    var startPage;
    var endPage;
    var i;
    var html = '';
    var maxVisible = 3; 
    var halfVisible = Math.floor(maxVisible / 2); 

    startPage = currentPage - halfVisible;

    console.log(currentPage, " ", startPage);

    if (startPage < 1) {
        startPage = 1;
    }

    endPage = startPage + maxVisible - 1;

    if (endPage > TOTAL_PAGES) {
        endPage = TOTAL_PAGES;
        startPage = Math.max(1, TOTAL_PAGES - maxVisible + 1);
    }

    if (els.numbersContainer) {
        els.numbersContainer.innerHTML = '';
    }

    for (i = startPage; i <= endPage; i++) {
        var activeClass = (i === currentPage) ? ' custom_jdgm-curt' : '';
        html += '<span class="custom_jdgm-paginate__page' + activeClass + '" data-page="' + i + '">' + i + '</span>';
    }

    if (els.numbersContainer) {
        els.numbersContainer.innerHTML = html;
    }
}

function renderReviews(c, p, review_json = window.review_json) {
    TOTAL_PAGES = Math.ceil(review_json.length / PER_PAGE);
    var currentPage = Math.min(Math.max(1, p), TOTAL_PAGES);
    var startIndex = (currentPage - 1) * PER_PAGE;
    var endIndex = currentPage * PER_PAGE;
    var reviews = review_json.slice(startIndex, endIndex);
    var els = getPaginationElements(c);

    generatePageNumbers(c, currentPage); 

    els.reviewsContainer.innerHTML = render_review_html(reviews);

    if (currentPage === 1) {
        if (els.prevPage) els.prevPage.style.display = 'none';
        if (els.firstPage) els.firstPage.style.display = 'none';
        
        if (TOTAL_PAGES > 1) {
            if (els.nextPage) els.nextPage.style.display = '';
            if (els.lastPage) els.lastPage.style.display = '';
        }
    } else if (currentPage === TOTAL_PAGES) {
        if (els.nextPage) els.nextPage.style.display = 'none';
        if (els.lastPage) els.lastPage.style.display = 'none';

        if (TOTAL_PAGES > 1) {
            if (els.prevPage) els.prevPage.style.display = '';
            if (els.firstPage) els.firstPage.style.display = '';
        }
    } else {
        if (els.prevPage) els.prevPage.style.display = '';
        if (els.firstPage) els.firstPage.style.display = '';
        if (els.nextPage) els.nextPage.style.display = '';
        if (els.lastPage) els.lastPage.style.display = '';
    }


    if(TOTAL_PAGES == 1) {
      els.context.querySelector('.custom_jdgm-paginate').style.display = 'none';
    } else {
      els.context.querySelector('.custom_jdgm-paginate').style.display = 'block';
    }


    console.log(c.closest('.custom_reviews').querySelector(".custom_jdgm-row-actions"));

    c.closest('.custom_reviews').querySelector(".custom_jdgm-row-actions")?.scrollIntoView({ behavior: "smooth" });
}

function handlePaginationClick(e) {
  TOTAL_PAGES = Math.ceil(window.review_json.length / PER_PAGE);
    var clickedElement = e.target.closest('.custom_jdgm-paginate__page');
    if (!clickedElement) return;

    var contextEl = clickedElement.closest('.custom_reviews');
    if (!contextEl) return;
    
    var targetPage = 1;
    var currentPageEl = contextEl.querySelector('.page-numbers-container .custom_jdgm-curt');
    var currentPage = currentPageEl ? parseInt(currentPageEl.getAttribute('data-page')) : 1;


    if (clickedElement.classList.contains('custom_jdgm-paginate__first-page')) {
        targetPage = 1;
    } else if (clickedElement.classList.contains('custom_jdgm-paginate__prev-page')) {
        targetPage = currentPage - 1;
    } else if (clickedElement.classList.contains('custom_jdgm-paginate__next-page')) {
        targetPage = currentPage + 1;
    } else if (clickedElement.classList.contains('custom_jdgm-paginate__last-page')) {
        targetPage = TOTAL_PAGES;
    } else {
        targetPage = parseInt(clickedElement.getAttribute("data-page"));
    }

    renderReviews(contextEl, targetPage);
}

function handleFilter(e) {
    var clickedElement = e.target.closest('.custom_jdgm-sort-dropdown');
    if (!clickedElement) return;

    var contextEl = clickedElement.closest('.custom_reviews');
    if (!contextEl) return;

    var selectedValue = clickedElement.value;

    var filteredReviews = [...review_json]; 

    switch (selectedValue) {
        case "most-recent":
            filteredReviews.sort((a, b) => new Date(b.review_date) - new Date(a.review_date));
            break;
        case "highest-rating":
            filteredReviews.sort((a, b) => b.rating - a.rating);
            break;
        case "lowest-rating":
            filteredReviews.sort((a, b) => a.rating - b.rating);
            break;
        case "with-pictures":
            filteredReviews = filteredReviews.filter(r => r.picture_urls && r.picture_urls.trim() !== "");
            break;
        case "pictures-first":
            filteredReviews.sort((a, b) => {
                const aHasPics = a.picture_urls && a.picture_urls.trim() !== "" ? 1 : 0;
                const bHasPics = b.picture_urls && b.picture_urls.trim() !== "" ? 1 : 0;
                return bHasPics - aHasPics; 
            });
            break;
    }

    window.review_json = filteredReviews;

    renderReviews(contextEl, 1, filteredReviews);
}

function handleRatingFilter(e) {
    const row = e.target.closest('.custom_jdgm-histogram__row');
    if (!row) return;

    const rating = row.getAttribute('data-rating');
    const contextEl = row.closest('.custom_reviews');
    if (!contextEl) return;

    if(rating == 'null' || typeof(rating) == NaN) {
      var filteredReviews = review_json;
      contextEl.querySelector('.custom_jdgm-histogram__clear-filter').style.display = "none";
      console.log(rating, " rating");
    } else {
      var filteredReviews = review_json.filter(r => r.rating === parseInt(rating));
      contextEl.querySelector('.custom_jdgm-histogram__clear-filter').style.display = "block";
    }

    window.review_json = filteredReviews;

    renderReviews(contextEl, 1, filteredReviews);
}

document.body.addEventListener("click", handleRatingFilter);

document.body.addEventListener("change", handleFilter);

document.body.addEventListener("click", handlePaginationClick);


$('body').on('click','.desc-toggle', function() {
    const $toggle = $(this);
    const $content = $toggle.next('.desc-content');

    if ($toggle.hasClass('active')) {
      $content.slideUp(250);
      $toggle.removeClass('active');
    } else {
      $content.slideDown(250);
      $toggle.addClass('active');
    }
  });

 let countdownTimer = class extends HTMLElement {
  constructor() {
      super();
      console.log(this, this.querySelector('.countdown__timer'));
      var counttime = this.querySelector('.countdown__timer').dataset.timer;
      var countDownDate = new Date(counttime).getTime();
      var expired_msg  = this.querySelector('.countdown__datetime').dataset.expired_msg;

      var days = this.querySelector('[data-days]');
      var hours = this.querySelector('[data-hours]');
      var seconds = this.querySelector('[data-seconds]');
      var minutes = this.querySelector('[data-minutes]');
      var countdown = this.querySelector(".countdown__timer");
      var reset_hours = this.querySelector(".countdown__timer").dataset.reset_hours || null;

      document.querySelector('.timer_left_text').style.display = 'block';
      
      if (reset_hours != null) {
        function getNextResetTime() {
          const now = new Date();
          const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
          const msIn48Hours = parseFloat(reset_hours) * 60 * 60 * 1000;

          const lastReset = new Date(midnight.getTime() - (midnight.getTime() % msIn48Hours));
          let nextReset = new Date(lastReset.getTime() + msIn48Hours);

          if (nextReset < now) nextReset = new Date(nextReset.getTime() + msIn48Hours);
          return nextReset;
        }
      //  function getNextResetTime() {
      //     const now = new Date();
      //     const resetHours = {{ section.settings.reset_hours | times: 1 | plus: 0 }};
      //     const msInReset = resetHours * 60 * 60 * 1000;

      //     const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
      //     const elapsedSinceMidnight = now.getTime() - midnight.getTime();
      //     const lastResetOffset = Math.floor(elapsedSinceMidnight / msInReset) * msInReset;

      //     const lastReset = new Date(midnight.getTime() + lastResetOffset);
      //     let nextReset = new Date(lastReset.getTime() + msInReset);

      //     if (nextReset <= now) nextReset = new Date(nextReset.getTime() + msInReset);

      //     return nextReset;
      //   }

        countDownDate = getNextResetTime().getTime();

        setInterval(() => {
          const now = new Date().getTime();
          const distance = Number(countDownDate) - Number(now);

          if (distance <= 0) {
            countDownDate = getNextResetTime().getTime();
            return;
          }

          const d = Math.floor(distance / (1000 * 60 * 60 * 24)).toString().padStart(2, '0');
          const h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString().padStart(2, '0');
          const m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0');
          const s = Math.floor((distance % (1000 * 60)) / 1000).toString().padStart(2, '0');

          days.textContent = d;
          hours.textContent = h;
          minutes.textContent = m;
          seconds.textContent = s;
        }, 1000);
      } else {
        var x = setInterval(function() {
      
        var now = new Date().getTime();
      
        var distance = countDownDate - now;
      
        var d = Math.floor(distance / (1000 * 60 * 60 * 24)).toString().padStart(2, '0');
        var h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString().padStart(2, '0');
        var m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0');
        var s = Math.floor((distance % (1000 * 60)) / 1000).toString().padStart(2, '0');
      
        
        minutes.innerHTML = m;
        days.innerHTML = d;
        seconds.innerHTML = s;
        hours.innerHTML = h;
      
        if (distance < 0) {
          clearInterval(x);
          countdown.innerHTML = expired_msg;
          document.querySelector('.timer_left_text').style.display = 'none';
          if (expired_msg == '') {
            document.querySelector('.homw_timer').style.display = 'none';
          }
        }
      }, 1000);
    }
          
    }
  };

  customElements.get("countdown-timer") || customElements.define("countdown-timer", countdownTimer);  


});

document.addEventListener("contextmenu", function(e) {
    e.preventDefault();
  });


